import type { CategorySlug, Product } from "./product-types";
import { img } from "./product-types";
import spinnerBiohazardImg from "@/assets/spinner-biohazard.webp";
import spinnerSmallImg from "@/assets/spinner-small.webp";
import spinnerYinYangImg from "@/assets/spinner-yin-yang.webp";
import spinnerMandalaImg from "@/assets/spinner-mandala.webp";
import spinnerHexImg from "@/assets/spinner-hex-pattern.webp";
import spinnerLolImg from "@/assets/spinner-lol.webp";
import spinnerStarGrooveImg from "@/assets/spinner-star-groove.webp";
import spinnerStarPlainImg from "@/assets/spinner-star-plain.webp";
import spinnerThreeSquarePlainImg from "@/assets/spinner-3-square-plain.webp";
import spinnerThreeSquareGrooveImg from "@/assets/spinner-3-square-groove.webp";
import spinnerThreeRoundPlainImg from "@/assets/spinner-3-round-plain.webp";
import spinnerThreeRoundGrooveImg from "@/assets/spinner-3-round-groove.webp";
import spinnerFourRoundPlainImg from "@/assets/spinner-4-round-plain.webp";
import spinnerFourRoundGrooveImg from "@/assets/spinner-4-round-groove.webp";
import carvSafari1Img from "@/assets/carving-african-safari-1.webp";
import carvSafari2Img from "@/assets/carving-african-safari-2.webp";
import carvDeerImg from "@/assets/carving-deer-in-a-frame.webp";
import carvEagleWolfImg from "@/assets/carving-eagle-and-wolf.webp";
import carvPheasantImg from "@/assets/carving-pheasant-hunt.webp";
import carvFairyMushImg from "@/assets/carving-fairy-door-mushroom.webp";
import carvFairyPlainImg from "@/assets/carving-fairy-door-plain.webp";
import carvHobbitImg from "@/assets/carving-hobbit-door.webp";
import carvDishEagle1Img from "@/assets/carving-dished-eagle-1.webp";
import carvDishEagle2Img from "@/assets/carving-dished-eagle-2.webp";
import carvDishElkImg from "@/assets/carving-dished-elk.webp";
import carvDishFrogImg from "@/assets/carving-dished-frog.webp";
import carvDishHenImg from "@/assets/carving-dished-hen.webp";
import carvDishHorseImg from "@/assets/carving-dished-horse.webp";
import carvDishUni1Img from "@/assets/carving-dished-unicorn-1.webp";
import carvDishUni2Img from "@/assets/carving-dished-unicorn-2.webp";
import dtGAfz from "@/assets/dt-g-afz.webp";
import dtGOc from "@/assets/dt-g-oc.webp";
import dtR1Ia119 from "@/assets/dt-r1-ia119.webp";
import dtR4Ia125 from "@/assets/dt-r4-ia125.webp";
import dtChrShe from "@/assets/dt-chr-she.webp";
import dtGunOo from "@/assets/dt-gun-oo.webp";
import mesa1Img from "@/assets/mesa1-gold-fordite.webp";
import mesa2Img from "@/assets/mesa2-chrome-braided-steel.webp";
import mesa3Img from "@/assets/mesa3-gold-chrome-carbon-fiber.webp";
import mesa4Img from "@/assets/mesa4-gunmetal-denim.webp";
import mcf1Img from "@/assets/mcf1-chrome-carbon-fiber.webp";
import mcf2Img from "@/assets/mcf2-gold-gunmetal-carbon-fiber.webp";
import mcf3Img from "@/assets/mcf3-gold-carbon-fiber.webp";
import mcf4Img from "@/assets/mcf4-gold-chrome-carbon-fiber.webp";
import mcf5Img from "@/assets/mcf5-gunmetal-carbon-fiber.webp";
import wsii1Img from "@/assets/wsii-1-copper.webp";
import ct1Img from "@/assets/ct1-camo-gunmetal.webp";
import ct3Img from "@/assets/ct3-lb27-satin-chrome.webp";
import ct4Img from "@/assets/ct4-lacewood-satin-chrome.webp";
import ap1Img from "@/assets/ap1-american-patriot-chrome.webp";
import ap2Img from "@/assets/ap2-american-patriot-antique-pewter.webp";
import ap3Img from "@/assets/ap3-american-patriot-antique-brass.webp";
import drtAc1Img from "@/assets/drt-ac1-dragon-antique-copper.webp";
import drtAc2Img from "@/assets/drt-ac2-dragon-antique-copper.webp";
import drtAb1Img from "@/assets/drt-ab1-dragon-antique-brass.webp";
import drtAb2Img from "@/assets/drt-ab2-dragon-antique-brass.webp";
import drtAp1Img from "@/assets/drt-ap1-dragon-antique-pewter.webp";
import drtAp1bImg from "@/assets/drt-ap1b-dragon-antique-pewter-wood.webp";
import ka1Img from "@/assets/ka1-knights-armor-antique-pewter.webp";
import ka2Img from "@/assets/ka2-knights-armor-antique-brass.webp";
import ka4Img from "@/assets/ka4-knights-armor-antique-pewter.webp";
import ka5Img from "@/assets/ka5-knights-armor-castle-pewter.webp";
import ka6Img from "@/assets/ka6-knights-armor-castle-brass.webp";
import ka7Img from "@/assets/ka7-knights-armor-antique-pewter.webp";
import ka8Img from "@/assets/ka8-knights-armor-antique-brass.webp";
import gs1Img from "@/assets/gs1-gearshift-antique-pewter.webp";
import gs2Img from "@/assets/gs2-gearshift-antique-brass.webp";
import gs3Img from "@/assets/gs3-gearshift-chrome.webp";
import gs4Img from "@/assets/gs4-gearshift-chrome.webp";
import gs5Img from "@/assets/gs5-gearshift-antique-pewter.webp";
import gs6Img from "@/assets/gs6-gearshift-antique-brass.webp";
import gs7Img from "@/assets/gs7-gearshift-gun-metal.webp";
import bb1Img from "@/assets/bb1-big-ben-antique-copper.webp";
import princessImg from "@/assets/princess-twist-gold-crystals.webp";
import np1Img from "@/assets/np1-necklace-pen-gold.webp";
import sbp1Img from "@/assets/sbp1-rhodium-coffee-beans.webp";
import sbp2Img from "@/assets/sbp2-gold-carbon-fiber.webp";
import sbp3Img from "@/assets/sbp3-chrome-carbon-fiber.webp";
import sbp4Img from "@/assets/sbp4-gold-resin.webp";
import sbp5Img from "@/assets/sbp5-black-tn-resin.webp";
import sbp6Img from "@/assets/sbp6-rhodium-elk-inlay.webp";
import sbp7Img from "@/assets/sbp7-gold-tn-paw-prints.webp";
import sbp8Img from "@/assets/sbp8-rhodium-herringbone.webp";
import sbp10Img from "@/assets/sbp10-gold-black-tn-resin.webp";
import sbp11Img from "@/assets/sbp11-gold-tn-dragon-inlay.webp";
import ksResImg from "@/assets/ks-res-resin-kaleidoscope.webp";
import ksWoodImg from "@/assets/ks-wood-kaleidoscope.webp";
import dcResImg from "@/assets/dc-res-resin-duck-call.webp";
import dcWoodImg from "@/assets/dc-wood-duck-call.webp";
import cs1Img from "@/assets/cs1-corkscrew.webp";
import cs2Img from "@/assets/cs2-corkscrew.webp";
import cs3Img from "@/assets/cs3-corkscrew.webp";
import bs1Img from "@/assets/bs1-red-pink-bottle-stopper.webp";
import bs2Img from "@/assets/bs2-blue-bottle-stopper.webp";
import bs3Img from "@/assets/bs3-green-pink-bottle-stopper.webp";
import bs4Img from "@/assets/bs4-gold-pink-bottle-stopper.webp";
import bs5Img from "@/assets/bs5-silver-blue-bottle-stopper.webp";
import bsff1Img from "@/assets/bsff1-gold-fishing-fly-bottle-stopper.webp";
import bsff2Img from "@/assets/bsff2-gold-fishing-fly-bottle-stopper.webp";
import kr1Img from "@/assets/kr1-keyring-african-coral.webp";
import kr2Img from "@/assets/kr2-keyring-red-resin.webp";
import spm1Img from "@/assets/spm1-salt-pepper-mill.webp";
import perf1Img from "@/assets/perf1-perfume-atomizer-wood.webp";
import perf2Img from "@/assets/perf2-perfume-atomizer-black-gold.webp";
import smPrayImg from "@/assets/sign-mosaic-pray.webp";
import smFearsImg from "@/assets/sign-mosaic-fears.webp";
import smRegretImg from "@/assets/sign-mosaic-regret.webp";
import smBeOnYourGuardImg from "@/assets/sign-mosaic-be-on-your-guard.webp";
import smPowerOfGodImg from "@/assets/sign-mosaic-power-of-god.webp";
import smJourneyImg from "@/assets/sign-mosaic-journey.webp";
import smCaresImg from "@/assets/sign-mosaic-cares.webp";
import smRighteousnessImg from "@/assets/sign-mosaic-righteousness.webp";
import smStarsImg from "@/assets/sign-mosaic-stars.webp";
import smGrowThroughImg from "@/assets/sign-mosaic-grow-through.webp";
import smAwesomeImg from "@/assets/sign-mosaic-awesome.webp";
import smPathImg from "@/assets/sign-mosaic-path.webp";
import smHopeImg from "@/assets/sign-mosaic-hope.webp";
import smChristImg from "@/assets/sign-mosaic-christ.webp";
import swLuckyImg from "@/assets/sign-wood-lucky.webp";
import swChristImg from "@/assets/sign-wood-christ.webp";
import swAskImg from "@/assets/sign-wood-ask.webp";
import swWiseMenImg from "@/assets/sign-wood-wise-men.webp";
import swLifeIsToughImg from "@/assets/sign-wood-life-is-tough.webp";
import swBeOnYourGuardImg from "@/assets/sign-wood-be-on-your-guard.webp";
import swRighteousnessImg from "@/assets/sign-wood-righteousness.webp";
import swPowerOfGodImg from "@/assets/sign-wood-power-of-god.webp";
import swJourneyImg from "@/assets/sign-wood-journey.webp";
import swFishingImg from "@/assets/sign-wood-fishing.webp";
import fp1Img from "@/assets/fp-1-majestic.webp";
import fp2Img from "@/assets/fp-2-euro.webp";
import fp3Img from "@/assets/fp-3-el-grande.webp";
import fp4Img from "@/assets/fp-4-el-grande.webp";
import majf1Img from "@/assets/fp-majf-1-majestic.webp";
import majf2Img from "@/assets/fp-majf-2-majestic.webp";
import majf3Img from "@/assets/fp-majf-3-majestic.webp";
import majf4Img from "@/assets/fp-majf-4-majestic.webp";
import majf5Img from "@/assets/fp-majf-5-majestic.webp";
import majf6Img from "@/assets/fp-majf-6-majestic.webp";
import majjrf1Img from "@/assets/fp-majjrf-1-ia115.webp";
import majjrf2Img from "@/assets/fp-majjrf-2-maple-burl.webp";
import majjrf3Img from "@/assets/fp-majjrf-3-majestic.webp";
import majjrf4Img from "@/assets/fp-majjrf-4-majestic.webp";
import majjrf5Img from "@/assets/fp-majjrf-5-majestic.webp";
import majjrf6Img from "@/assets/fp-majjrf-6-majestic.webp";
import majrb1Img from "@/assets/rb-majrb-1-majestic.webp";
import majrb2Img from "@/assets/rb-majrb-2-majestic.webp";
import majrb3Img from "@/assets/rb-majrb-3-majestic.webp";
import majrb4Img from "@/assets/rb-majrb-4-majestic.webp";
import majjrrb1Img from "@/assets/rb-majjrrb-1-majestic.webp";
import majjrrb2Img from "@/assets/rb-majjrrb-2-majestic.webp";
import majjrrb3Img from "@/assets/rb-majjrrb-3-majestic.webp";
import majjrrb4Img from "@/assets/rb-majjrrb-4-majestic.webp";
import dkf1Img from "@/assets/fp-dkf1-diamond-knurl.webp";
import dkf2Img from "@/assets/fp-dkf2-diamond-knurl.webp";
import claf1Img from "@/assets/fp-claf1-classic.webp";
import claf2Img from "@/assets/fp-claf2-classic.webp";
import claf3Img from "@/assets/fp-claf3-classic.webp";
import claf4Img from "@/assets/fp-claf4-classic.webp";
import claf5Img from "@/assets/fp-claf5-classic.webp";
import drf1Img from "@/assets/fp-drf1-dragon.webp";
import drf2Img from "@/assets/fp-drf2-dragon.webp";
import drf3Img from "@/assets/fp-drf3-dragon.webp";
import rb3Img from "@/assets/rb-3-nouveau-sceptre.webp";
import rb4Img from "@/assets/rb-4-robusto.webp";
import rb6Img from "@/assets/rb-6-el-grande.webp";
import rb8Img from "@/assets/rb-8-churchill.webp";
import rb9Img from "@/assets/rb-9-el-grande.webp";
import rb10Img from "@/assets/rb-10-parker.webp";
import drrabImg from "@/assets/rb-drr-ab-dragon.webp";
import drrab2Img from "@/assets/rb-drr-ab2-dragon.webp";
import drracImg from "@/assets/rb-drr-ac-dragon.webp";
import dkrb1Img from "@/assets/rb-dkrb1-stainless.webp";
import dkrb2Img from "@/assets/rb-dkrb2-copper.webp";
import dkrb3Img from "@/assets/rb-dkrb3-carbon-fiber.webp";
import dkrb4Img from "@/assets/rb-dkrb4-purple-heart.webp";
import dkrb5Img from "@/assets/rb-dkrb5-unknown-wood.webp";
import agr1Img from "@/assets/rb-agr1-amazing-grace.webp";
import agr2Img from "@/assets/rb-agr2-amazing-grace.webp";
import agr3Img from "@/assets/rb-agr3-amazing-grace.webp";
import agr4Img from "@/assets/rb-agr4-amazing-grace.webp";
import bapApImg from "@/assets/bap-ap-cartridge.webp";
import basaAcImg from "@/assets/basa-ac-salute-america.webp";
import basaAbImg from "@/assets/basa-ab-salute-america.webp";
import basaApImg from "@/assets/basa-ap-salute-america.webp";
import bastAcImg from "@/assets/bast-ac-statue-of-liberty.webp";
import rc308gRedImg from "@/assets/rc-308g-red.webp";
import rc308chrRedImg from "@/assets/rc-308chr-red.webp";
import rc308gunRedImg from "@/assets/rc-308gun-red.webp";
import rc308gPadImg from "@/assets/rc-308g-pad.webp";
import rc308chrPadImg from "@/assets/rc-308chr-pad.webp";
import rc308gunPadImg from "@/assets/rc-308gun-pad.webp";
import rc308gCedImg from "@/assets/rc-308g-ced.webp";
import rc308chrCedImg from "@/assets/rc-308chr-ced.webp";
import rc308gunCedImg from "@/assets/rc-308gun-ced.webp";
import rc308gMapImg from "@/assets/rc-308g-map.webp";
import rc308chrMapImg from "@/assets/rc-308chr-map.webp";
import rc308gunMapImg from "@/assets/rc-308gun-map.webp";
import rc308gAfzImg from "@/assets/rc-308g-afz.webp";
import rc308chrAfzImg from "@/assets/rc-308chr-afz.webp";
import rc308gunAfzImg from "@/assets/rc-308gun-afz.webp";
import rc3006AntlerGImg from "@/assets/rc-3006-antler-g.webp";
import rc3006AntlerChrImg from "@/assets/rc-3006-antler-chr.webp";
import rc3006AntlerGunImg from "@/assets/rc-3006-antler-gun.webp";
import rcM60gunCedImg from "@/assets/rc-m60gun-ced.webp";
import rcM60gunGeImg from "@/assets/rc-m60gun-ge.webp";
import rcM60gunRedImg from "@/assets/rc-m60gun-red.webp";
import rcM60gunMapImg from "@/assets/rc-m60gun-map.webp";
import rcM60gunPadImg from "@/assets/rc-m60gun-pad.webp";
import rcM60gunAfzImg from "@/assets/rc-m60gun-afz.webp";
import ppgSumImg from "@/assets/ppg-sum-sumac-combo.webp";
import ppgMesImg from "@/assets/ppg-mes-mesquite-combo.webp";
import ppgPadImg from "@/assets/ppg-pad-padauk-combo.webp";
import ppgAfzImg from "@/assets/ppg-afz-afzelia-combo.webp";
import cigChr1Img from "@/assets/cig-chr1.webp";
import cigChr2Img from "@/assets/cig-chr2.webp";
import cigChr3Img from "@/assets/cig-chr3.webp";
import cigGm1Img from "@/assets/cig-gm1.webp";
import cigGm2Img from "@/assets/cig-gm2.webp";
import cig24ktg1Img from "@/assets/cig-24ktg1.webp";
import cig24ktg2Img from "@/assets/cig-24ktg2.webp";
import cigGgm1Img from "@/assets/cig-ggm1.webp";
import cigGgm2Img from "@/assets/cig-ggm2.webp";
import cigGgm3Img from "@/assets/cig-ggm3.webp";
import ocncMaskRackImg from "@/assets/ocnc-mask-rack.webp";
import ocncKeyMaskRackImg from "@/assets/ocnc-key-mask-rack.webp";
import ocncTowelRackImg from "@/assets/ocnc-towel-rack.webp";
import ocncPlantHangerSetImg from "@/assets/ocnc-plant-hanger-set.webp";
import ocncAirPlant1Img from "@/assets/ocnc-air-plant-1.webp";
import ocncAirPlant2Img from "@/assets/ocnc-air-plant-2.webp";
import ocncAirPlant3Img from "@/assets/ocnc-air-plant-3.webp";
import ocncAirPlant4Img from "@/assets/ocnc-air-plant-4.webp";
import ocncAirPlant5Img from "@/assets/ocnc-air-plant-5.webp";
import ocncSmallCandleHolderImg from "@/assets/ocnc-small-candle-holder.webp";
import ocncHexCandleHolderImg from "@/assets/ocnc-hex-candle-holder.webp";
import ocncHexCandleHolderVotiveImg from "@/assets/ocnc-hex-candle-holder-votive.webp";
import ocncLargeCandleHolderImg from "@/assets/ocnc-large-candle-holder.webp";
import ocncStackedBowlImg from "@/assets/ocnc-stacked-bowl.webp";
import ocncSantaHatCandyDishImg from "@/assets/ocnc-santa-hat-candy-dish.webp";
import ocncSnowmanCandyDishImg from "@/assets/ocnc-snowman-candy-dish.webp";
import ocncPlatterImg from "@/assets/ocnc-platter.webp";
import ocncCuttingBoardImg from "@/assets/ocnc-cutting-board.webp";
import ocncHexTrivetImg from "@/assets/ocnc-hex-trivet.webp";
import ocncIdeasNotePadImg from "@/assets/ocnc-ideas-note-pad.webp";
import ocncSupermanImg from "@/assets/ocnc-superman.webp";
import ocncHenImg from "@/assets/ocnc-hen.webp";
import ocncRoosterImg from "@/assets/ocnc-rooster.webp";
import miscAntlerKeyChainImg from "@/assets/misc-antler-key-chain.webp";
import miscAntlerPendantImg from "@/assets/misc-antler-pendant.webp";
import cornholeRedImg from "@/assets/cornhole-red.webp";
import cornholeGreenImg from "@/assets/cornhole-green.webp";
import cornholeOrangeImg from "@/assets/cornhole-orange.webp";
import cornholeYellowImg from "@/assets/cornhole-yellow.webp";

export const categories: Record<
  CategorySlug,
  { slug: CategorySlug; label: string; to: string; blurb: string; image: string; alt: string }
> = {
  pens: {
    slug: "pens",
    label: "Pens and Pencils",
    to: "/custom-pens",
    blurb: "Fountain, rollerball, bolt-action, rifle cartridge, cigar style, pencils and classic ballpoints.",
    image: majf1Img,
    alt: "Majestic fountain pen handcrafted by Paul in figured wood with gold trim",
  },
  "lathe-gifts": {
    slug: "lathe-gifts",
    label: "Lathe-Turned Gifts",
    to: "/lathe-turned-gifts",
    blurb: "Bottle stoppers, duck calls and turned keepsakes shaped one at a time.",
    image: bs1Img,
    alt: "Red and pink cast bottle stopper turned by Paul on a stainless steel base",
  },
  cnc: {
    slug: "cnc",
    label: "CNC & Engraved",
    to: "/cnc-engraved",
    blurb: "Signs, 3D relief carvings and personalized engraving cut in Paul's shop.",
    image: carvDishEagle1Img,
    alt: "CNC-carved dished eagle relief panel made in Paul's shop",
  },
  other: {
    slug: "other",
    label: "Other Creations",
    to: "/other-creations",
    blurb: "Fidget spinners, cornhole boards and the projects that do not fit a category.",
    image: cornholeRedImg,
    alt: "Red custom cornhole boards built and finished by Paul",
  },
  "pen-turners": {
    slug: "pen-turners",
    label: "For Pen Turners",
    to: "/for-pen-turners",
    blurb: "Blanks, components and resources for makers working at their own lathe.",
    image: "/fordite-pen-blank-three-quarter.webp",
    alt: "Fordite pen blank cut square and ready to turn",
  },
};

/**
 * Pricing note: prices from the previous site are pending confirmation with
 * Paul, so every record ships as `quote` until the price list is verified.
 * The template already renders `fixed` ($50) and `from` (From $50) types —
 * set `price` and `priceType` per record once confirmed.
 */
export const products: Product[] = [
  {
    id: "p144",
    featured: true,
    slug: "cig-chr1-chrome-cigar-pen-with-coffee-bean-barrels",
    name: "Chrome Cigar Pen with Coffee Bean Barrels",
    internalCode: "cig-chr1",
    category: "pens",
    subcategory: "Cigar Style",
    shortDescription: "Cigar style pen with chrome trim and fittings and having barrels made with coffee beans embedded in a mint resin.",
    fullDescription: "These pens use a Parker refill and come in a variety of barrel materials and platings. Cigar style pen with chrome trim and fittings and having barrels made with coffee beans embedded in a mint resin.",
    price: 60,
    priceType: "fixed",
    status: "available",
    materials: ["Coffee beans", "Mint resin"],
    finishes: ["Chrome trim"],
    customizable: true,
    images: [img(cigChr1Img, "Chrome Cigar Pen with Coffee Bean Barrels handcrafted by Paul's Pens n Things", 360, 271)],
    tags: ["cigar", "ballpoint", "pens"],
    occasions: ["Birthday", "Graduation", "Just because"],
    relatedProducts: ["p145", "p146", "p147"],
    seoTitle: "Chrome Cigar Pen with Coffee Bean Barrels | Paul's Pens n Things",
    seoDescription: "Cigar style pen with chrome trim and fittings and having barrels made with coffee beans embedded in a mint resin. Handcrafted in Paragould, Arkansas.",
  },
  {
    id: "p145",
    slug: "cig-chr2-chrome-cigar-pen-with-colorwood-barrels",
    name: "Chrome Cigar Pen with Colorwood Barrels",
    internalCode: "cig-chr2",
    category: "pens",
    subcategory: "Cigar Style",
    shortDescription: "Cigar style pen with chrome trim and fittings and having barrels made with colorwood.",
    fullDescription: "These pens use a Parker refill and come in a variety of barrel materials and platings. Cigar style pen with chrome trim and fittings and having barrels made with colorwood.",
    price: 60,
    priceType: "fixed",
    status: "available",
    materials: ["Colorwood"],
    finishes: ["Chrome trim"],
    customizable: true,
    featured: false,
    images: [img(cigChr2Img, "Chrome Cigar Pen with Colorwood Barrels handcrafted by Paul's Pens n Things", 360, 271)],
    tags: ["cigar", "ballpoint", "pens"],
    occasions: ["Birthday", "Graduation", "Just because"],
    relatedProducts: ["p146", "p147", "p148"],
    seoTitle: "Chrome Cigar Pen with Colorwood Barrels | Paul's Pens n Things",
    seoDescription: "Cigar style pen with chrome trim and fittings and having barrels made with colorwood. Handcrafted in Paragould, Arkansas.",
  },
  {
    id: "p146",
    slug: "cig-chr3-chrome-cigar-pen-with-pasta-shells-barrels",
    name: "Chrome Cigar Pen with Pasta Shells Barrels",
    internalCode: "cig-chr3",
    category: "pens",
    subcategory: "Cigar Style",
    shortDescription: "Cigar style pen with chrome trim and fittings and having barrels made with pasta shells embedded in a blue resin.",
    fullDescription: "These pens use a Parker refill and come in a variety of barrel materials and platings. Cigar style pen with chrome trim and fittings and having barrels made with pasta shells embedded in a blue resin.",
    price: 60,
    priceType: "fixed",
    status: "available",
    materials: ["Pasta shells", "Blue resin"],
    finishes: ["Chrome trim"],
    customizable: true,
    featured: false,
    images: [img(cigChr3Img, "Chrome Cigar Pen with Pasta Shells Barrels handcrafted by Paul's Pens n Things", 360, 271)],
    tags: ["cigar", "ballpoint", "pens"],
    occasions: ["Birthday", "Graduation", "Just because"],
    relatedProducts: ["p147", "p148", "p149"],
    seoTitle: "Chrome Cigar Pen with Pasta Shells Barrels | Paul's Pens n Things",
    seoDescription: "Cigar style pen with chrome trim and fittings and having barrels made with pasta shells embedded in a blue resin. Handcrafted in Paragould, Arkansas.",
  },
  {
    id: "p147",
    slug: "cig-gm1-gun-metal-cigar-pen-with-pasta-rotini-barrels",
    name: "Gun Metal Cigar Pen with Pasta Rotini Barrels",
    internalCode: "cig-gm1",
    category: "pens",
    subcategory: "Cigar Style",
    shortDescription: "Cigar style pen with gun metal trim and fittings and having barrels made with pasta rotini embedded in a red-blue resin.",
    fullDescription: "These pens use a Parker refill and come in a variety of barrel materials and platings. Cigar style pen with gun metal trim and fittings and having barrels made with pasta rotini embedded in a red-blue resin.",
    price: 60,
    priceType: "fixed",
    status: "available",
    materials: ["Pasta rotini", "Red-blue resin"],
    finishes: ["Gun metal trim"],
    customizable: true,
    featured: false,
    images: [img(cigGm1Img, "Gun Metal Cigar Pen with Pasta Rotini Barrels handcrafted by Paul's Pens n Things", 360, 271)],
    tags: ["cigar", "ballpoint", "pens"],
    occasions: ["Birthday", "Graduation", "Just because"],
    relatedProducts: ["p148", "p149", "p150"],
    seoTitle: "Gun Metal Cigar Pen with Pasta Rotini Barrels | Paul's Pens n Things",
    seoDescription: "Cigar style pen with gun metal trim and fittings and having barrels made with pasta rotini embedded in a red-blue resin. Handcrafted in Paragould, Arkansas.",
  },
  {
    id: "p148",
    slug: "cig-gm2-gun-metal-cigar-pen-with-pine-cone-barrels",
    name: "Gun Metal Cigar Pen with Pine Cone Barrels",
    internalCode: "cig-gm2",
    category: "pens",
    subcategory: "Cigar Style",
    shortDescription: "Cigar style pen with gun metal trim and fittings and having barrels made with pine cones embedded in a green resin.",
    fullDescription: "These pens use a Parker refill and come in a variety of barrel materials and platings. Cigar style pen with gun metal trim and fittings and having barrels made with pine cones embedded in a green resin.",
    price: 60,
    priceType: "fixed",
    status: "available",
    materials: ["Pine cones", "Green resin"],
    finishes: ["Gun metal trim"],
    customizable: true,
    featured: false,
    images: [img(cigGm2Img, "Gun Metal Cigar Pen with Pine Cone Barrels handcrafted by Paul's Pens n Things", 360, 271)],
    tags: ["cigar", "ballpoint", "pens"],
    occasions: ["Birthday", "Graduation", "Just because"],
    relatedProducts: ["p149", "p150", "p151"],
    seoTitle: "Gun Metal Cigar Pen with Pine Cone Barrels | Paul's Pens n Things",
    seoDescription: "Cigar style pen with gun metal trim and fittings and having barrels made with pine cones embedded in a green resin. Handcrafted in Paragould, Arkansas.",
  },
  {
    id: "p149",
    slug: "cig-24ktg1-24kt-gold-cigar-pen-with-sweetgum-ball-barrels",
    name: "24kt Gold Cigar Pen with Sweetgum Ball Barrels",
    internalCode: "cig-24ktg1",
    category: "pens",
    subcategory: "Cigar Style",
    shortDescription: "Cigar style pen with 24kt gold trim and fittings and having barrels made with sweetgum balls embedded in a blue resin.",
    fullDescription: "These pens use a Parker refill and come in a variety of barrel materials and platings. Cigar style pen with 24kt gold trim and fittings and having barrels made with sweetgum balls embedded in a blue resin.",
    price: 60,
    priceType: "fixed",
    status: "available",
    materials: ["Sweetgum balls", "Blue resin"],
    finishes: ["24kt gold trim"],
    customizable: true,
    featured: false,
    images: [img(cig24ktg1Img, "24kt Gold Cigar Pen with Sweetgum Ball Barrels handcrafted by Paul's Pens n Things", 360, 271)],
    tags: ["cigar", "ballpoint", "pens"],
    occasions: ["Birthday", "Graduation", "Just because"],
    relatedProducts: ["p150", "p151", "p152"],
    seoTitle: "24kt Gold Cigar Pen with Sweetgum Ball Barrels | Paul's Pens n Things",
    seoDescription: "Cigar style pen with 24kt gold trim and fittings and having barrels made with sweetgum balls embedded in a blue resin. Handcrafted in Paragould, Arkansas.",
  },
  {
    id: "p150",
    slug: "cig-24ktg2-24kt-gold-cigar-pen-with-pasta-elbow-barrels",
    name: "24kt Gold Cigar Pen with Pasta Elbow Barrels",
    internalCode: "cig-24ktg2",
    category: "pens",
    subcategory: "Cigar Style",
    shortDescription: "Cigar style pen with 24kt gold trim and fittings and having barrels made with pasta elbows embedded in a red-blue resin.",
    fullDescription: "These pens use a Parker refill and come in a variety of barrel materials and platings. Cigar style pen with 24kt gold trim and fittings and having barrels made with pasta elbows embedded in a red-blue resin.",
    price: 60,
    priceType: "fixed",
    status: "available",
    materials: ["Pasta elbows", "Red-blue resin"],
    finishes: ["24kt gold trim"],
    customizable: true,
    featured: false,
    images: [img(cig24ktg2Img, "24kt Gold Cigar Pen with Pasta Elbow Barrels handcrafted by Paul's Pens n Things", 360, 271)],
    tags: ["cigar", "ballpoint", "pens"],
    occasions: ["Birthday", "Graduation", "Just because"],
    relatedProducts: ["p151", "p152", "p153"],
    seoTitle: "24kt Gold Cigar Pen with Pasta Elbow Barrels | Paul's Pens n Things",
    seoDescription: "Cigar style pen with 24kt gold trim and fittings and having barrels made with pasta elbows embedded in a red-blue resin. Handcrafted in Paragould, Arkansas.",
  },
  {
    id: "p151",
    slug: "cig-ggm1-24kt-gold-gun-metal-cigar-pen-with-fordite-barrels",
    name: "24kt Gold & Gun Metal Cigar Pen with Fordite Barrels",
    internalCode: "cig-ggm1",
    category: "pens",
    subcategory: "Cigar Style",
    shortDescription: "Cigar style pen with 24kt gold & gun metal trim and fittings and having barrels made with fordite.",
    fullDescription: "These pens use a Parker refill and come in a variety of barrel materials and platings. Cigar style pen with 24kt gold & gun metal trim and fittings and having barrels made with fordite.",
    price: 80,
    priceType: "fixed",
    status: "available",
    materials: ["Fordite"],
    finishes: ["24kt gold trim", "Gun metal trim"],
    customizable: true,
    featured: false,
    images: [img(cigGgm1Img, "24kt Gold & Gun Metal Cigar Pen with Fordite Barrels handcrafted by Paul's Pens n Things", 360, 271)],
    tags: ["cigar", "ballpoint", "pens"],
    occasions: ["Birthday", "Graduation", "Just because"],
    relatedProducts: ["p152", "p153", "p144"],
    seoTitle: "24kt Gold & Gun Metal Cigar Pen with Fordite Barrels | Paul's Pens n Things",
    seoDescription: "Cigar style pen with 24kt gold & gun metal trim and fittings and having barrels made with fordite. Handcrafted in Paragould, Arkansas.",
  },
  {
    id: "p152",
    slug: "cig-ggm2-24kt-gold-gun-metal-cigar-pen-with-pasta-elbow-barrels",
    name: "24kt Gold & Gun Metal Cigar Pen with Pasta Elbow Barrels",
    internalCode: "cig-ggm2",
    category: "pens",
    subcategory: "Cigar Style",
    shortDescription: "Cigar style pen with 24kt gold & gun metal trim and fittings and having barrels made with pasta elbows embedded in a green resin.",
    fullDescription: "These pens use a Parker refill and come in a variety of barrel materials and platings. Cigar style pen with 24kt gold & gun metal trim and fittings and having barrels made with pasta elbows embedded in a green resin.",
    price: 60,
    priceType: "fixed",
    status: "available",
    materials: ["Pasta elbows", "Green resin"],
    finishes: ["24kt gold trim", "Gun metal trim"],
    customizable: true,
    featured: false,
    images: [img(cigGgm2Img, "24kt Gold & Gun Metal Cigar Pen with Pasta Elbow Barrels handcrafted by Paul's Pens n Things", 360, 271)],
    tags: ["cigar", "ballpoint", "pens"],
    occasions: ["Birthday", "Graduation", "Just because"],
    relatedProducts: ["p153", "p144", "p145"],
    seoTitle: "24kt Gold & Gun Metal Cigar Pen with Pasta Elbow Barrels | Paul's Pens n Things",
    seoDescription: "Cigar style pen with 24kt gold & gun metal trim and fittings and having barrels made with pasta elbows embedded in a green resin. Handcrafted in Paragould, Arkansas.",
  },
  {
    id: "p153",
    slug: "cig-ggm3-24kt-gold-gun-metal-cigar-pen-with-acorn-cap-barrels",
    name: "24kt Gold & Gun Metal Cigar Pen with Acorn Cap Barrels",
    internalCode: "cig-ggm3",
    category: "pens",
    subcategory: "Cigar Style",
    shortDescription: "Cigar style pen with 24kt gold & gun metal trim and fittings and having barrels made with acorn caps embedded in a red resin.",
    fullDescription: "These pens use a Parker refill and come in a variety of barrel materials and platings. Cigar style pen with 24kt gold & gun metal trim and fittings and having barrels made with acorn caps embedded in a red resin.",
    price: 60,
    priceType: "fixed",
    status: "available",
    materials: ["Acorn caps", "Red resin"],
    finishes: ["24kt gold trim", "Gun metal trim"],
    customizable: true,
    featured: false,
    images: [img(cigGgm3Img, "24kt Gold & Gun Metal Cigar Pen with Acorn Cap Barrels handcrafted by Paul's Pens n Things", 360, 271)],
    tags: ["cigar", "ballpoint", "pens"],
    occasions: ["Birthday", "Graduation", "Just because"],
    relatedProducts: ["p144", "p145", "p146"],
    seoTitle: "24kt Gold & Gun Metal Cigar Pen with Acorn Cap Barrels | Paul's Pens n Things",
    seoDescription: "Cigar style pen with 24kt gold & gun metal trim and fittings and having barrels made with acorn caps embedded in a red resin. Handcrafted in Paragould, Arkansas.",
  },
  {
    id: "p138",
    slug: "cigp-p-cigar-style-pen-and-pencil-set",
    name: "Cigar Style Pen and Pencil Set",
    internalCode: "CIGP&P",
    category: "pens",
    subcategory: "Pen & Pencil Sets",
    shortDescription: "This cigar style pen and pencil set is finished in 24kt gold and made with unknown wood barrels coated in CA.",
    fullDescription: "A matched cigar style pen and pencil set. This cigar style pen and pencil set is finished in 24kt gold and made with unknown wood barrels coated in CA. This set has sold; Paul can make something similar in your own materials.",
    price: 90,
    priceType: "fixed",
    status: "previously-created",
    materials: ["Unknown wood"],
    finishes: ["24kt gold trim", "CA finish"],
    customizable: true,
    featured: false,
    images: [img(ppgMesImg, "Cigar style pen and pencil set in 24kt gold by Paul's Pens n Things", 1200, 900)],
    tags: ["set", "pencil", "wood", "cigar"],
    occasions: ["Retirement", "Graduation", "Anniversary"],
    relatedProducts: ["p139", "p140", "p141"],
    seoTitle: "Cigar Style Pen and Pencil Set | Paul's Pens n Things",
    seoDescription: "A cigar style pen and pencil set finished in 24kt gold with wood barrels coated in CA. Handcrafted in Paragould, Arkansas.",
  },
  {
    id: "p139",
    slug: "clap-p-classic-style-pen-and-pencil-set",
    name: "Classic Style Pen and Pencil Set",
    internalCode: "CLAP&P",
    category: "pens",
    subcategory: "Pen & Pencil Sets",
    shortDescription: "This classic style pen and pencil set is finished in 24kt gold and made with unknown wood barrels coated in CA.",
    fullDescription: "A matched classic style pen and pencil set. This classic style pen and pencil set is finished in 24kt gold and made with unknown wood barrels coated in CA. This set has sold; Paul can make something similar in your own materials.",
    price: 90,
    priceType: "fixed",
    status: "previously-created",
    materials: ["Unknown wood"],
    finishes: ["24kt gold trim", "CA finish"],
    customizable: true,
    featured: false,
    images: [img(ppgPadImg, "Classic style pen and pencil set in 24kt gold by Paul's Pens n Things", 1200, 900)],
    tags: ["set", "pencil", "wood", "classic"],
    occasions: ["Retirement", "Graduation", "Anniversary"],
    relatedProducts: ["p138", "p140", "p142"],
    seoTitle: "Classic Style Pen and Pencil Set | Paul's Pens n Things",
    seoDescription: "A classic style pen and pencil set finished in 24kt gold with wood barrels coated in CA. Handcrafted in Paragould, Arkansas.",
  },
  {
    id: "p140",
    slug: "ppg-sum-pen-and-pencil-combo-sumac",
    name: "Pen & Pencil Combo with a Sumac Barrel",
    internalCode: "ppg-sum",
    category: "pens",
    subcategory: "Pen & Pencil Sets",
    shortDescription: "This pen and pencil combo is made of sumac that is finished with CA.",
    fullDescription:
      "Combination pen and pencil. Twist one way it is a pen, twist the other way it is a click pencil. The fittings and trim are finished in 24kt gold. This pen and pencil combo is made of sumac that is finished with CA. This set has sold; Paul can make something similar in your own materials.",
    price: 55,
    priceType: "fixed",
    status: "previously-created",
    materials: ["Sumac"],
    finishes: ["24kt gold trim", "CA finish"],
    customizable: true,
    featured: false,
    images: [img(ppgSumImg, "Pen and pencil combo with a sumac barrel handcrafted by Paul's Pens n Things", 360, 271)],
    tags: ["combo", "pencil", "wood", "set"],
    occasions: ["Retirement", "Graduation", "Just because"],
    relatedProducts: ["p141", "p142", "p143"],
    seoTitle: "Sumac Pen & Pencil Combo | Paul's Pens n Things",
    seoDescription: "A twist pen and click pencil combo turned from sumac with 24kt gold fittings. Handcrafted in Paragould, Arkansas.",
  },
  {
    id: "p141",
    slug: "ppg-mes-pen-and-pencil-combo-mesquite",
    name: "Pen & Pencil Combo with a Mesquite Barrel",
    internalCode: "ppg-mes",
    category: "pens",
    subcategory: "Pen & Pencil Sets",
    shortDescription: "This pen and pencil combo is made of mesquite that is finished with CA.",
    fullDescription:
      "Combination pen and pencil. Twist one way it is a pen, twist the other way it is a click pencil. The fittings and trim are finished in 24kt gold. This pen and pencil combo is made of mesquite that is finished with CA. This set has sold; Paul can make something similar in your own materials.",
    price: 55,
    priceType: "fixed",
    status: "previously-created",
    materials: ["Mesquite"],
    finishes: ["24kt gold trim", "CA finish"],
    customizable: true,
    featured: false,
    images: [img(ppgMesImg, "Pen and pencil combo with a mesquite barrel handcrafted by Paul's Pens n Things", 360, 271)],
    tags: ["combo", "pencil", "wood", "set"],
    occasions: ["Retirement", "Graduation", "Just because"],
    relatedProducts: ["p140", "p142", "p143"],
    seoTitle: "Mesquite Pen & Pencil Combo | Paul's Pens n Things",
    seoDescription: "A twist pen and click pencil combo turned from mesquite with 24kt gold fittings. Handcrafted in Paragould, Arkansas.",
  },
  {
    id: "p142",
    slug: "ppg-pad-pen-and-pencil-combo-padauk",
    name: "Pen & Pencil Combo with a Padauk Barrel",
    internalCode: "ppg-pad",
    category: "pens",
    subcategory: "Pen & Pencil Sets",
    shortDescription: "This pen and pencil combo is made of padauk that is finished with CA.",
    fullDescription:
      "Combination pen and pencil. Twist one way it is a pen, twist the other way it is a click pencil. The fittings and trim are finished in 24kt gold. This pen and pencil combo is made of padauk that is finished with CA. This set has sold; Paul can make something similar in your own materials.",
    price: 55,
    priceType: "fixed",
    status: "previously-created",
    materials: ["Padauk"],
    finishes: ["24kt gold trim", "CA finish"],
    customizable: true,
    featured: false,
    images: [img(ppgPadImg, "Pen and pencil combo with a padauk barrel handcrafted by Paul's Pens n Things", 360, 271)],
    tags: ["combo", "pencil", "wood", "set"],
    occasions: ["Retirement", "Graduation", "Just because"],
    relatedProducts: ["p140", "p141", "p143"],
    seoTitle: "Padauk Pen & Pencil Combo | Paul's Pens n Things",
    seoDescription: "A twist pen and click pencil combo turned from padauk with 24kt gold fittings. Handcrafted in Paragould, Arkansas.",
  },
  {
    id: "p143",
    slug: "ppg-afz-pen-and-pencil-combo-afzelia",
    name: "Pen & Pencil Combo with an Afzelia Barrel",
    internalCode: "ppg-afz",
    category: "pens",
    subcategory: "Pen & Pencil Sets",
    shortDescription: "This pen and pencil combo is made of afzelia that is finished with CA.",
    fullDescription:
      "Combination pen and pencil. Twist one way it is a pen, twist the other way it is a click pencil. The fittings and trim are finished in 24kt gold. This pen and pencil combo is made of afzelia that is finished with CA. This set has sold; Paul can make something similar in your own materials.",
    price: 55,
    priceType: "fixed",
    status: "previously-created",
    materials: ["Afzelia"],
    finishes: ["24kt gold trim", "CA finish"],
    customizable: true,
    featured: false,
    images: [img(ppgAfzImg, "Pen and pencil combo with an afzelia barrel handcrafted by Paul's Pens n Things", 360, 271)],
    tags: ["combo", "pencil", "wood", "set"],
    occasions: ["Retirement", "Graduation", "Just because"],
    relatedProducts: ["p140", "p141", "p142"],
    seoTitle: "Afzelia Pen & Pencil Combo | Paul's Pens n Things",
    seoDescription: "A twist pen and click pencil combo turned from afzelia with 24kt gold fittings. Handcrafted in Paragould, Arkansas.",
  },
  {
    id: "p16",
    slug: "fordite-pen-blanks",
    name: "Fordite Pen Blanks",
    internalCode: "PT-FRD",
    category: "pen-turners",
    subcategory: "Fordite & Colorwood",
    shortDescription: "Layered automotive paint slag, cut and stabilized for turning.",
    fullDescription:
      "Fordite is built up from many layers of baked automotive paint. It cuts cleanly at low speed and polishes to a deep shine. Sizes and color runs vary — ask Paul what is on the bench right now.",
    price: null,
    priceType: "quote",
    status: "available",
    materials: ["Fordite"],
    finishes: ["Unfinished blank"],
    customizable: false,
    featured: false,
    images: [img("/fordite-pen-blank-three-quarter.webp", "Colorful layered fordite pen blanks on a workbench")],
    tags: ["blanks", "specialty"],
    occasions: [],
    relatedProducts: ["p17", "p18", "p19"],
    seoTitle: "Fordite Pen Blanks | Paul's Pens n Things",
    seoDescription: "Fordite and colorwood pen blanks for pen turners. Ask about current availability.",
  },
  {
    id: "p17",
    slug: "30-and-50-cal-components",
    name: ".30 and .50 Caliber Components",
    internalCode: "PT-CAL",
    category: "pen-turners",
    subcategory: "Components",
    shortDescription: "Cartridge-based pen kit components for .30 and .50 caliber builds.",
    fullDescription:
      "Cases and matching hardware for cartridge pen builds. Availability moves with what Paul can source, so check before planning a batch.",
    price: null,
    priceType: "quote",
    status: "available",
    materials: ["Brass cartridge cases", "Pen hardware"],
    finishes: ["As supplied"],
    customizable: false,
    featured: false,
    images: [img("/comp-50cal-case.webp", "Brass cartridge cases and pen hardware components on a bench")],
    tags: ["components", "specialty"],
    occasions: [],
    relatedProducts: ["p16", "p18", "p19"],
    seoTitle: ".30 and .50 Caliber Pen Components | Paul's Pens n Things",
    seoDescription: "Cartridge pen components in .30 and .50 caliber for pen turners.",
  },
  {
    id: "p18",
    slug: "tube-on-clear-cast-blanks",
    name: "Tube-On Clear-Cast Blanks",
    internalCode: "PT-TOC",
    category: "pen-turners",
    subcategory: "Clear Cast",
    shortDescription: "Blanks cast in clear resin directly onto the tube, ready to turn.",
    fullDescription:
      "Casting onto the tube removes the drilling step and keeps whatever is suspended in the resin exactly where it was placed. Turn slowly and finish through fine grits for the clearest result.",
    price: null,
    priceType: "quote",
    status: "available",
    materials: ["Clear casting resin", "Pen tube"],
    finishes: ["Unfinished blank"],
    customizable: true,
    featured: false,
    images: [img("/tube-on-carbon-fiber-sierra.webp", "Clear-cast pen blanks with tubes already set inside the resin")],
    tags: ["blanks", "resin"],
    occasions: [],
    relatedProducts: ["p19", "p16", "p20"],
    seoTitle: "Tube-On Clear-Cast Pen Blanks | Paul's Pens n Things",
    seoDescription: "Tube-on clear-cast pen blanks ready to turn, from Paul's Pens n Things.",
  },
  {
    id: "p19",
    slug: "embedded-object-blanks",
    name: "Embedded Object Blanks",
    internalCode: "PT-EMB",
    category: "pen-turners",
    subcategory: "Embedded Objects",
    shortDescription: "Cast blanks holding small meaningful objects suspended in clear resin.",
    fullDescription:
      "Coins, shell fragments, fabric, dried flowers and similar keepsakes can be cast into a blank. Send Paul the object and he will advise whether it will survive casting and turning.",
    price: null,
    priceType: "quote",
    status: "made-to-order",
    materials: ["Clear casting resin", "Customer-supplied object"],
    finishes: ["Unfinished blank"],
    customizable: true,
    featured: false,
    images: [img("/embed-acorn-cap-red.webp", "Cast pen blanks with small objects suspended inside clear resin")],
    tags: ["blanks", "resin", "specialty"],
    occasions: ["Memorial", "Anniversary"],
    relatedProducts: ["p18", "p16", "p20"],
    seoTitle: "Embedded Object Pen Blanks | Paul's Pens n Things",
    seoDescription: "Custom cast pen blanks with embedded keepsake objects, made to order.",
  },
  {
    id: "p20",
    slug: "bottle-stopper-blanks",
    name: "Bottle Stopper Blanks",
    internalCode: "PT-BSB",
    category: "pen-turners",
    subcategory: "Bottle Stopper Blanks",
    shortDescription:
      "Porcelain roses and fishing flies cast over a solid color base, sized for a standard stopper mandrel.",
    fullDescription:
      "Clear-topped polyester resin blanks with embedded porcelain roses, paper roses or fishing flies over a solid color base. Each blank is about 1 1/2 inches in diameter by 2 1/2 inches long.",
    price: null,
    priceType: "quote",
    status: "available",
    materials: ["Polyester resin"],
    finishes: ["Unfinished blank"],
    customizable: false,
    featured: false,
    images: [
      img(
        "/bslppr-red.webp",
        "Cast bottle stopper blank with a large pink porcelain rose over a red base",
        360,
        480,
      ),
    ],
    tags: ["blanks"],
    occasions: [],
    relatedProducts: ["p16", "p18", "p19"],
    seoTitle: "Bottle Stopper Blanks | Paul's Pens n Things",
    seoDescription:
      "Cast bottle stopper blanks with porcelain roses, paper roses and fishing flies. Ask about current stock.",
  },
  {
    id: "p23",
    slug: "dtgun-oo-designer-twist-pen",
    name: "Designer Twist Pen in Osage Orange",
    internalCode: "DTGUN-OO",
    category: "pens",
    subcategory: "Designer",
    shortDescription: "Osage orange barrels finished with CA, with gun metal fittings and trim.",
    fullDescription:
      "Designed similar to a Mont Blanc pen. The barrels of this pen are made with osage orange and finished with CA. The fittings and trim are finished in gun metal. This pen has sold; Paul can make something similar in your own materials.",
    price: 50,
    priceType: "fixed",
    status: "previously-created",
    materials: ["Osage orange"],
    finishes: ["Gun metal trim", "CA finish"],
    customizable: true,
    featured: false,
    images: [
      img(dtGunOo, "Designer twist pen turned from osage orange with gun metal trim", 360, 271),
    ],
    tags: ["designer", "wood", "twist"],
    occasions: ["Retirement", "Anniversary", "Recognition"],
    relatedProducts: ["p27", "p24", "p28"],
    seoTitle: "Osage Orange Designer Twist Pen | Paul's Pens n Things",
    seoDescription:
      "A handcrafted designer twist pen in osage orange with gun metal trim. Handcrafted in Paragould, Arkansas.",
  },
  {
    id: "p24",
    slug: "dtchr-she-designer-twist-pen",
    name: "Designer Twist Pen in Sheetum",
    internalCode: "DTCHR-SHE",
    category: "pens",
    subcategory: "Designer",
    shortDescription: "Sheetum barrels finished with CA, with chrome fittings and trim.",
    fullDescription:
      "Designed similar to a Mont Blanc pen. The barrels of this pen are made with sheetum and finished with CA. The fittings and trim are finished in chrome. This pen has sold; Paul can make something similar in your own materials.",
    price: 50,
    priceType: "fixed",
    status: "previously-created",
    materials: ["Sheetum"],
    finishes: ["Chrome trim", "CA finish"],
    customizable: true,
    featured: false,
    images: [
      img(dtChrShe, "Designer twist pen turned from sheetum with chrome trim", 360, 271),
    ],
    tags: ["designer", "wood", "twist"],
    occasions: ["Retirement", "Anniversary", "Just because"],
    relatedProducts: ["p23", "p25", "p28"],
    seoTitle: "Sheetum Designer Twist Pen | Paul's Pens n Things",
    seoDescription:
      "A handcrafted designer twist pen in sheetum with chrome trim. Handcrafted in Paragould, Arkansas.",
  },
  {
    id: "p25",
    slug: "dtr4-ia125-designer-twist-pen",
    name: "Designer Twist Pen in Inlace Acrylester 125",
    internalCode: "DTR4-IA125",
    category: "pens",
    subcategory: "Designer",
    shortDescription: "Inlace acrylester 125 resin barrels with 24kt gold fittings and trim.",
    fullDescription:
      "Designed similar to a Mont Blanc pen. The barrels of this pen are made with inlace acrylester 125 resin. The fittings and trim are finished in 24kt gold.",
    price: 50,
    priceType: "fixed",
    status: "available",
    materials: ["Inlace acrylester 125 resin"],
    finishes: ["24kt gold trim", "Polished to a mirror"],
    customizable: true,
    featured: false,
    images: [
      img(dtR4Ia125, "Designer twist pen in inlace acrylester 125 resin with 24kt gold trim", 360, 271),
    ],
    tags: ["designer", "resin", "twist"],
    occasions: ["Graduation", "Holiday", "Recognition"],
    relatedProducts: ["p26", "p28", "p23"],
    seoTitle: "Inlace Acrylester 125 Designer Twist Pen | Paul's Pens n Things",
    seoDescription:
      "A handcrafted designer twist pen in inlace acrylester 125 resin with 24kt gold trim. Handcrafted in Paragould, Arkansas.",
  },
  {
    id: "p26",
    slug: "dtr1-ia119-designer-twist-pen",
    name: "Designer Twist Pen in Inlace Acrylester 119",
    internalCode: "DTr1-IA119",
    category: "pens",
    subcategory: "Designer",
    shortDescription: "Inlace acrylester 119 resin barrels with 24kt gold fittings and trim.",
    fullDescription:
      "Designed similar to a Mont Blanc pen. The barrels of this pen are made with inlace acrylester 119 resin. The fittings and trim are finished in 24kt gold.",
    price: 50,
    priceType: "fixed",
    status: "available",
    materials: ["Inlace acrylester 119 resin"],
    finishes: ["24kt gold trim", "Polished to a mirror"],
    customizable: true,
    featured: false,
    images: [
      img(dtR1Ia119, "Designer twist pen in inlace acrylester 119 resin with 24kt gold trim", 360, 271),
    ],
    tags: ["designer", "resin", "twist"],
    occasions: ["Graduation", "Holiday", "Just because"],
    relatedProducts: ["p25", "p27", "p23"],
    seoTitle: "Inlace Acrylester 119 Designer Twist Pen | Paul's Pens n Things",
    seoDescription:
      "A handcrafted designer twist pen in inlace acrylester 119 resin with 24kt gold trim. Handcrafted in Paragould, Arkansas.",
  },
  {
    id: "p27",
    slug: "dtg-oc-designer-twist-pen",
    name: "Designer Twist Pen in Orange Crush Resin",
    internalCode: "DTG-OC",
    category: "pens",
    subcategory: "Designer",
    shortDescription: "Orange crush resin barrels with 24kt gold fittings and trim.",
    fullDescription:
      "Designed similar to a Mont Blanc pen. The barrels of this pen are made with orange crush resin. The fittings and trim are finished in 24kt gold. This pen has sold; Paul can make something similar in your own materials.",
    price: 50,
    priceType: "fixed",
    status: "previously-created",
    materials: ["Orange crush resin"],
    finishes: ["24kt gold trim", "Polished to a mirror"],
    customizable: true,
    featured: false,
    images: [
      img(dtGOc, "Designer twist pen in orange crush resin with 24kt gold trim", 360, 271),
    ],
    tags: ["designer", "resin", "twist"],
    occasions: ["Holiday", "Graduation", "Just because"],
    relatedProducts: ["p25", "p26", "p28"],
    seoTitle: "Orange Crush Designer Twist Pen | Paul's Pens n Things",
    seoDescription:
      "A handcrafted designer twist pen in orange crush resin with 24kt gold trim. Handcrafted in Paragould, Arkansas.",
  },
  {
    id: "p28",
    slug: "dtg-afz-designer-twist-pen",
    name: "Designer Twist Pen in Afzelia",
    internalCode: "DTG-AFZ",
    category: "pens",
    subcategory: "Designer",
    shortDescription: "Afzelia barrels finished with CA, with 24kt gold fittings and trim.",
    fullDescription:
      "Designed similar to a Mont Blanc pen. The barrels of this pen are made with afzelia and finished with CA. The fittings and trim are finished in 24kt gold. This pen has sold; Paul can make something similar in your own materials.",
    price: 50,
    priceType: "fixed",
    status: "previously-created",
    materials: ["Afzelia"],
    finishes: ["24kt gold trim", "CA finish"],
    customizable: true,
    featured: false,
    images: [
      img(dtGAfz, "Designer twist pen turned from afzelia with 24kt gold trim", 360, 271),
    ],
    tags: ["designer", "wood", "twist"],
    occasions: ["Retirement", "Anniversary", "Recognition"],
    relatedProducts: ["p23", "p24", "p27"],
    seoTitle: "Afzelia Designer Twist Pen | Paul's Pens n Things",
    seoDescription:
      "A handcrafted designer twist pen in afzelia with 24kt gold trim. Handcrafted in Paragould, Arkansas.",
  },

  {
    id: "p29",
    featured: true,
    slug: "fp-1-majestic-fountain-pen",
    name: "Majestic Fountain Pen in Maple Burl",
    internalCode: "FP-1",
    category: "pens",
    subcategory: "Fountain & Rollerball",
    shortDescription: "A majestic fountain pen with fittings and trim in 22kt gold and rhodium.",
    fullDescription: "A majestic fountain pen with fittings and trim in 22kt gold and rhodium. The barrels are turned from maple burl. This pen has sold; Paul can make something similar in your own materials.",
    price: 215,
    priceType: "fixed",
    status: "previously-created",
    materials: ["Maple burl"],
    finishes: ["22kt gold and rhodium trim"],
    customizable: true,
    images: [img(fp1Img, "Majestic fountain pen in maple burl with 22kt gold and rhodium trim", 360, 271)],
    tags: ["fountain", "wood", "pens"],
    occasions: ["Graduation", "Retirement", "Anniversary"],
    relatedProducts: ["p30", "p31"],
    seoTitle: "Majestic Fountain Pen in Maple Burl | Paul's Pens n Things",
    seoDescription: "A majestic fountain pen with fittings and trim in 22kt gold and rhodium. Handcrafted in Paragould, Arkansas.",
  },
  {
    id: "p30",
    slug: "fp-2-euro-fountain-pen",
    name: "Euro Fountain Pen in Gold Pearl Resin",
    internalCode: "FP-2",
    category: "pens",
    subcategory: "Fountain & Rollerball",
    shortDescription: "A euro style fountain pen with fittings and trim in 24kt gold.",
    fullDescription: "A euro style fountain pen with fittings and trim in 24kt gold. The barrels are made of gold pearl resin. This pen has sold; Paul can make something similar in your own materials.",
    price: 75,
    priceType: "fixed",
    status: "previously-created",
    materials: ["Gold pearl resin"],
    finishes: ["24kt gold trim"],
    customizable: true,
    featured: false,
    images: [img(fp2Img, "Euro style fountain pen in gold pearl resin with 24kt gold trim", 360, 271)],
    tags: ["fountain", "resin", "pens"],
    occasions: ["Graduation", "Retirement", "Anniversary"],
    relatedProducts: ["p31", "p32"],
    seoTitle: "Euro Fountain Pen in Gold Pearl Resin | Paul's Pens n Things",
    seoDescription: "A euro style fountain pen with fittings and trim in 24kt gold. Handcrafted in Paragould, Arkansas.",
  },
  {
    id: "p31",
    slug: "fp-3-el-grande-fountain-pen",
    name: "El Grande Fountain Pen in Orange Crush Resin",
    internalCode: "FP-3",
    category: "pens",
    subcategory: "Fountain & Rollerball",
    shortDescription: "An el-grande style fountain pen with trim and fittings in 24kt gold.",
    fullDescription: "An el-grande style fountain pen with trim and fittings in 24kt gold. The barrels are made of orange crush resin. This pen has sold; Paul can make something similar in your own materials.",
    price: 70,
    priceType: "fixed",
    status: "previously-created",
    materials: ["Orange crush resin"],
    finishes: ["24kt gold trim"],
    customizable: true,
    featured: false,
    images: [img(fp3Img, "El Grande fountain pen in orange crush resin with 24kt gold trim", 360, 271)],
    tags: ["fountain", "resin", "pens"],
    occasions: ["Graduation", "Retirement", "Anniversary"],
    relatedProducts: ["p32", "p33"],
    seoTitle: "El Grande Fountain Pen in Orange Crush Resin | Paul's Pens n Things",
    seoDescription: "An el-grande style fountain pen with trim and fittings in 24kt gold. Handcrafted in Paragould, Arkansas.",
  },
  {
    id: "p32",
    slug: "fp-4-el-grande-fountain-pen-wood",
    name: "El Grande Fountain Pen in Hardwood",
    internalCode: "FP-4",
    category: "pens",
    subcategory: "Fountain & Rollerball",
    shortDescription: "An el-grande style fountain pen with fittings and trim in 24kt gold.",
    fullDescription: "An el-grande style fountain pen with fittings and trim in 24kt gold. The barrels are turned from an unknown wood. This pen has sold; Paul can make something similar in your own materials.",
    price: 70,
    priceType: "fixed",
    status: "previously-created",
    materials: ["Hardwood (unidentified)"],
    finishes: ["24kt gold trim"],
    customizable: true,
    featured: false,
    images: [img(fp4Img, "El Grande fountain pen turned from hardwood with 24kt gold trim", 360, 271)],
    tags: ["fountain", "wood", "pens"],
    occasions: ["Graduation", "Retirement", "Anniversary"],
    relatedProducts: ["p33", "p34"],
    seoTitle: "El Grande Fountain Pen in Hardwood | Paul's Pens n Things",
    seoDescription: "An el-grande style fountain pen with fittings and trim in 24kt gold. Handcrafted in Paragould, Arkansas.",
  },
  {
    id: "p33",
    slug: "majf-1-majestic-fountain-pen",
    name: "Majestic Fountain Pen in Maple Burl Hybrid",
    internalCode: "MAJF-1",
    category: "pens",
    subcategory: "Fountain & Rollerball",
    shortDescription: "A majestic fountain pen with fittings and trim in black titanium nitride and rhodium.",
    fullDescription: "A majestic fountain pen with fittings and trim in black titanium nitride and rhodium. The barrels are a maple burl and resin hybrid, with a Swarovski crystal set in the clip. The screw-on cap keeps the ink from drying out between writing sessions. This pen has sold; Paul can make something similar in your own materials.",
    price: 225,
    priceType: "fixed",
    status: "previously-created",
    materials: ["Maple burl and resin hybrid"],
    finishes: ["Black titanium nitride and rhodium trim", "Swarovski crystal clip"],
    customizable: true,
    featured: false,
    images: [img(majf1Img, "Majestic fountain pen in maple burl hybrid with black titanium nitride trim", 360, 271)],
    tags: ["fountain", "wood", "specialty", "pens"],
    occasions: ["Graduation", "Retirement", "Anniversary"],
    relatedProducts: ["p34", "p261", "p262"],
    seoTitle: "Majestic Fountain Pen in Maple Burl Hybrid | Paul's Pens n Things",
    seoDescription: "A majestic fountain pen with fittings and trim in black titanium nitride and rhodium. Handcrafted in Paragould, Arkansas.",
  },
  {
    id: "p34",
    slug: "majf-2-majestic-fountain-pen",
    name: "Majestic Fountain Pen in Maple Burl Hybrid II",
    internalCode: "MAJF-2",
    category: "pens",
    subcategory: "Fountain & Rollerball",
    shortDescription: "A majestic fountain pen with fittings and trim in black titanium nitride and rhodium.",
    fullDescription: "A majestic fountain pen with fittings and trim in black titanium nitride and rhodium. The barrels are a maple burl and resin hybrid, with a Swarovski crystal set in the clip. The screw-on cap keeps the ink from drying out between writing sessions. This pen has sold; Paul can make something similar in your own materials.",
    price: 225,
    priceType: "fixed",
    status: "previously-created",
    materials: ["Maple burl and resin hybrid"],
    finishes: ["Black titanium nitride and rhodium trim", "Swarovski crystal clip"],
    customizable: true,
    featured: false,
    images: [img(majf2Img, "Majestic fountain pen in maple burl and resin hybrid with rhodium trim", 360, 271)],
    tags: ["fountain", "wood", "specialty", "pens"],
    occasions: ["Graduation", "Retirement", "Anniversary"],
    relatedProducts: ["p261", "p262", "p263"],
    seoTitle: "Majestic Fountain Pen in Maple Burl Hybrid II | Paul's Pens n Things",
    seoDescription: "A majestic fountain pen with fittings and trim in black titanium nitride and rhodium. Handcrafted in Paragould, Arkansas.",
  },
  {
    id: "p261",
    slug: "majf-3-majestic-fountain-pen",
    name: "Majestic Fountain Pen in Red Mallee Burl Hybrid",
    internalCode: "MAJF-3",
    category: "pens",
    subcategory: "Fountain & Rollerball",
    shortDescription: "A majestic fountain pen with fittings and trim in chrome and gun metal.",
    fullDescription:
      "A majestic fountain pen with fittings and trim in chrome and gun metal. The barrels are a red mallee burl and resin hybrid, with a Swarovski crystal set in the clip. The screw-on cap keeps the ink from drying out between writing sessions.",
    price: 200,
    priceType: "fixed",
    status: "available",
    materials: ["Red mallee burl and resin hybrid"],
    finishes: ["Chrome and gun metal trim", "Swarovski crystal clip"],
    customizable: true,
    featured: false,
    images: [img(majf3Img, "Majestic fountain pen in red mallee burl and resin hybrid with chrome and gun metal trim", 800, 598)],
    tags: ["fountain", "wood", "specialty", "pens"],
    occasions: ["Graduation", "Retirement", "Anniversary"],
    relatedProducts: ["p262", "p263", "p33"],
    seoTitle: "Majestic Fountain Pen in Red Mallee Burl Hybrid | Paul's Pens n Things",
    seoDescription:
      "A majestic fountain pen with fittings and trim in chrome and gun metal. Handcrafted in Paragould, Arkansas.",
  },
  {
    id: "p262",
    slug: "majf-4-majestic-fountain-pen",
    name: "Majestic Fountain Pen in Red Mallee Burl Hybrid with Gold",
    internalCode: "MAJF-4",
    category: "pens",
    subcategory: "Fountain & Rollerball",
    shortDescription: "A majestic fountain pen with fittings and trim in chrome and 22kt gold.",
    fullDescription:
      "A majestic fountain pen with fittings and trim in chrome and 22kt gold. The barrels are a red mallee burl and resin hybrid, with a Swarovski crystal set in the clip. The screw-on cap keeps the ink from drying out between writing sessions.",
    price: 225,
    priceType: "fixed",
    status: "available",
    materials: ["Red mallee burl and resin hybrid"],
    finishes: ["Chrome and 22kt gold trim", "Swarovski crystal clip"],
    customizable: true,
    featured: false,
    images: [img(majf4Img, "Majestic fountain pen in red mallee burl and resin hybrid with chrome and 22kt gold trim", 800, 591)],
    tags: ["fountain", "wood", "specialty", "pens"],
    occasions: ["Graduation", "Retirement", "Anniversary"],
    relatedProducts: ["p263", "p264", "p261"],
    seoTitle: "Majestic Fountain Pen in Red Mallee Burl Hybrid with Gold | Paul's Pens n Things",
    seoDescription:
      "A majestic fountain pen with fittings and trim in chrome and 22kt gold. Handcrafted in Paragould, Arkansas.",
  },
  {
    id: "p263",
    slug: "majf-5-majestic-fountain-pen",
    name: "Majestic Fountain Pen in Red Mallee Burl and Blue Resin Hybrid",
    internalCode: "MAJF-5",
    category: "pens",
    subcategory: "Fountain & Rollerball",
    shortDescription: "A majestic fountain pen with fittings and trim in chrome and 22kt gold.",
    fullDescription:
      "A majestic fountain pen with fittings and trim in chrome and 22kt gold. The barrels are a red mallee burl and blue resin hybrid, with a Swarovski crystal set in the clip. The screw-on cap keeps the ink from drying out between writing sessions.",
    price: 225,
    priceType: "fixed",
    status: "available",
    materials: ["Red mallee burl and blue resin hybrid"],
    finishes: ["Chrome and 22kt gold trim", "Swarovski crystal clip"],
    customizable: true,
    featured: false,
    images: [img(majf5Img, "Majestic fountain pen in red mallee burl and blue resin hybrid with chrome and 22kt gold trim", 800, 600)],
    tags: ["fountain", "wood", "specialty", "pens"],
    occasions: ["Graduation", "Retirement", "Anniversary"],
    relatedProducts: ["p264", "p261", "p262"],
    seoTitle: "Majestic Fountain Pen in Red Mallee Burl and Blue Resin Hybrid | Paul's Pens n Things",
    seoDescription:
      "A majestic fountain pen with fittings and trim in chrome and 22kt gold. Handcrafted in Paragould, Arkansas.",
  },
  {
    id: "p264",
    slug: "majf-6-majestic-fountain-pen",
    name: "Majestic Fountain Pen in Buckeye Burl Hybrid",
    internalCode: "MAJF-6",
    category: "pens",
    subcategory: "Fountain & Rollerball",
    shortDescription: "A majestic fountain pen with fittings and trim in chrome and gun metal.",
    fullDescription:
      "A majestic fountain pen with fittings and trim in chrome and gun metal. The barrels are a buckeye burl and silver red resin hybrid, with a Swarovski crystal set in the clip. The screw-on cap keeps the ink from drying out between writing sessions.",
    price: 200,
    priceType: "fixed",
    status: "available",
    materials: ["Buckeye burl and silver red resin hybrid"],
    finishes: ["Chrome and gun metal trim", "Swarovski crystal clip"],
    customizable: true,
    featured: false,
    images: [img(majf6Img, "Majestic fountain pen in buckeye burl and silver red resin hybrid with chrome and gun metal trim", 800, 600)],
    tags: ["fountain", "wood", "specialty", "pens"],
    occasions: ["Graduation", "Retirement", "Anniversary"],
    relatedProducts: ["p261", "p262", "p269"],
    seoTitle: "Majestic Fountain Pen in Buckeye Burl Hybrid | Paul's Pens n Things",
    seoDescription:
      "A majestic fountain pen with fittings and trim in chrome and gun metal. Handcrafted in Paragould, Arkansas.",
  },
  {
    id: "p269",
    slug: "majrb-1-majestic-rollerball",
    name: "Majestic Rollerball in Buckeye Burl Hybrid",
    internalCode: "MAJRB-1",
    category: "pens",
    subcategory: "Fountain & Rollerball",
    shortDescription: "A majestic rollerball with fittings and trim in rhodium and black titanium nitride.",
    fullDescription:
      "A majestic rollerball with fittings and trim in rhodium and black titanium nitride. The barrels are a buckeye burl and silver blue resin hybrid, with a Swarovski crystal set in the clip. The screw-on cap keeps the ink from drying out between writing sessions.",
    price: 225,
    priceType: "fixed",
    status: "available",
    materials: ["Buckeye burl and silver blue resin hybrid"],
    finishes: ["Rhodium and black titanium nitride trim", "Swarovski crystal clip"],
    customizable: true,
    featured: false,
    images: [img(majrb1Img, "Majestic rollerball in buckeye burl and silver blue resin hybrid with rhodium and black titanium nitride trim", 800, 598)],
    tags: ["rollerball", "wood", "specialty", "pens"],
    occasions: ["Graduation", "Retirement", "Anniversary"],
    relatedProducts: ["p270", "p271", "p33"],
    seoTitle: "Majestic Rollerball in Buckeye Burl Hybrid | Paul's Pens n Things",
    seoDescription:
      "A majestic rollerball with fittings and trim in rhodium and black titanium nitride. Handcrafted in Paragould, Arkansas.",
  },
  {
    id: "p270",
    slug: "majrb-2-majestic-rollerball",
    name: "Majestic Rollerball in Buckeye Burl Hybrid with Gold",
    internalCode: "MAJRB-2",
    category: "pens",
    subcategory: "Fountain & Rollerball",
    shortDescription: "A majestic rollerball with fittings and trim in rhodium and 22kt gold.",
    fullDescription:
      "A majestic rollerball with fittings and trim in rhodium and 22kt gold. The barrels are a buckeye burl and silver blue resin hybrid, with a Swarovski crystal set in the clip. The screw-on cap keeps the ink from drying out between writing sessions.",
    price: 240,
    priceType: "fixed",
    status: "available",
    materials: ["Buckeye burl and silver blue resin hybrid"],
    finishes: ["Rhodium and 22kt gold trim", "Swarovski crystal clip"],
    customizable: true,
    featured: false,
    images: [img(majrb2Img, "Majestic rollerball in buckeye burl and silver blue resin hybrid with rhodium and 22kt gold trim", 800, 618)],
    tags: ["rollerball", "wood", "specialty", "pens"],
    occasions: ["Graduation", "Retirement", "Anniversary"],
    relatedProducts: ["p271", "p272", "p269"],
    seoTitle: "Majestic Rollerball in Buckeye Burl Hybrid with Gold | Paul's Pens n Things",
    seoDescription:
      "A majestic rollerball with fittings and trim in rhodium and 22kt gold. Handcrafted in Paragould, Arkansas.",
  },
  {
    id: "p271",
    slug: "majrb-3-majestic-rollerball",
    name: "Majestic Rollerball in Buckeye Burl Hybrid II",
    internalCode: "MAJRB-3",
    category: "pens",
    subcategory: "Fountain & Rollerball",
    shortDescription: "A majestic rollerball with fittings and trim in rhodium and 22kt gold.",
    fullDescription:
      "A majestic rollerball with fittings and trim in rhodium and 22kt gold. The barrels are a buckeye burl and silver blue resin hybrid, with a Swarovski crystal set in the clip. The screw-on cap keeps the ink from drying out between writing sessions.",
    price: 240,
    priceType: "fixed",
    status: "available",
    materials: ["Buckeye burl and silver blue resin hybrid"],
    finishes: ["Rhodium and 22kt gold trim", "Swarovski crystal clip"],
    customizable: true,
    featured: false,
    images: [img(majrb3Img, "Majestic rollerball in buckeye burl and silver blue resin hybrid with rhodium and 22kt gold trim", 800, 601)],
    tags: ["rollerball", "wood", "specialty", "pens"],
    occasions: ["Graduation", "Retirement", "Anniversary"],
    relatedProducts: ["p272", "p269", "p270"],
    seoTitle: "Majestic Rollerball in Buckeye Burl Hybrid II | Paul's Pens n Things",
    seoDescription:
      "A majestic rollerball with fittings and trim in rhodium and 22kt gold. Handcrafted in Paragould, Arkansas.",
  },
  {
    id: "p272",
    slug: "majrb-4-majestic-rollerball",
    name: "Majestic Rollerball in Red Mallee Burl and Blue Resin Hybrid",
    internalCode: "MAJRB-4",
    category: "pens",
    subcategory: "Fountain & Rollerball",
    shortDescription: "A majestic rollerball with fittings and trim in chrome and gun metal.",
    fullDescription:
      "A majestic rollerball with fittings and trim in chrome and gun metal. The barrels are a red mallee burl and blue resin hybrid, with a Swarovski crystal set in the clip. The screw-on cap keeps the ink from drying out between writing sessions.",
    price: 200,
    priceType: "fixed",
    status: "available",
    materials: ["Red mallee burl and blue resin hybrid"],
    finishes: ["Chrome and gun metal trim", "Swarovski crystal clip"],
    customizable: true,
    featured: false,
    images: [img(majrb4Img, "Majestic rollerball in red mallee burl and blue resin hybrid with chrome and gun metal trim", 800, 598)],
    tags: ["rollerball", "wood", "specialty", "pens"],
    occasions: ["Graduation", "Retirement", "Anniversary"],
    relatedProducts: ["p269", "p270", "p271"],
    seoTitle: "Majestic Rollerball in Red Mallee Burl and Blue Resin Hybrid | Paul's Pens n Things",
    seoDescription:
      "A majestic rollerball with fittings and trim in chrome and gun metal. Handcrafted in Paragould, Arkansas.",
  },
  {
    id: "p35",
    slug: "majjrf-1-majestic-jr-fountain-pen",
    name: "Majestic JR Fountain Pen in IA115 Resin",
    internalCode: "MAJJRF-1",
    category: "pens",
    subcategory: "Fountain & Rollerball",
    shortDescription: "A majestic JR fountain pen with fittings and trim in 22kt gold and rhodium.",
    fullDescription: "A majestic JR fountain pen with fittings and trim in 22kt gold and rhodium. The barrels are made of IA115 resin, with a Swarovski crystal set in the clip. The screw-on cap keeps the ink from drying out between writing sessions. This pen has sold; Paul can make something similar in your own materials.",
    price: 180,
    priceType: "fixed",
    status: "previously-created",
    materials: ["IA115 resin"],
    finishes: ["22kt gold and rhodium trim", "Swarovski crystal clip"],
    customizable: true,
    featured: false,
    images: [img(majjrf1Img, "Majestic JR fountain pen in IA115 resin with gold and rhodium trim", 360, 271)],
    tags: ["fountain", "resin", "pens"],
    occasions: ["Graduation", "Retirement", "Anniversary"],
    relatedProducts: ["p36", "p265", "p266"],
    seoTitle: "Majestic JR Fountain Pen in IA115 Resin | Paul's Pens n Things",
    seoDescription: "A majestic JR fountain pen with fittings and trim in 22kt gold and rhodium. Handcrafted in Paragould, Arkansas.",
  },
  {
    id: "p36",
    slug: "majjrf-2-majestic-jr-fountain-pen",
    name: "Majestic JR Fountain Pen in Maple Burl Hybrid",
    internalCode: "MAJJRF-2",
    category: "pens",
    subcategory: "Fountain & Rollerball",
    shortDescription: "A majestic JR fountain pen with fittings and trim in 22kt gold and rhodium.",
    fullDescription: "A majestic JR fountain pen with fittings and trim in 22kt gold and rhodium. The barrels are a maple burl and resin hybrid, with a Swarovski crystal set in the clip. The screw-on cap keeps the ink from drying out between writing sessions. This pen has sold; Paul can make something similar in your own materials.",
    price: 190,
    priceType: "fixed",
    status: "previously-created",
    materials: ["Maple burl and resin hybrid"],
    finishes: ["22kt gold and rhodium trim", "Swarovski crystal clip"],
    customizable: true,
    featured: false,
    images: [img(majjrf2Img, "Majestic JR fountain pen in maple burl hybrid with 22kt gold trim", 360, 271)],
    tags: ["fountain", "wood", "specialty", "pens"],
    occasions: ["Graduation", "Retirement", "Anniversary"],
    relatedProducts: ["p265", "p266", "p267"],
    seoTitle: "Majestic JR Fountain Pen in Maple Burl Hybrid | Paul's Pens n Things",
    seoDescription: "A majestic JR fountain pen with fittings and trim in 22kt gold and rhodium. Handcrafted in Paragould, Arkansas.",
  },
  {
    id: "p265",
    slug: "majjrf-3-majestic-jr-fountain-pen",
    name: "Majestic JR Fountain Pen in Red Mallee Burl Hybrid",
    internalCode: "MAJJRF-3",
    category: "pens",
    subcategory: "Fountain & Rollerball",
    shortDescription: "A majestic JR fountain pen with fittings and trim in chrome and 22kt gold.",
    fullDescription:
      "A majestic JR fountain pen with fittings and trim in chrome and 22kt gold. The barrels are a red mallee burl and resin hybrid, with a Swarovski crystal set in the clip. The screw-on cap keeps the ink from drying out between writing sessions.",
    price: 205,
    priceType: "fixed",
    status: "available",
    materials: ["Red mallee burl and resin hybrid"],
    finishes: ["Chrome and 22kt gold trim", "Swarovski crystal clip"],
    customizable: true,
    featured: false,
    images: [img(majjrf3Img, "Majestic JR fountain pen in red mallee burl and resin hybrid with chrome and 22kt gold trim", 800, 601)],
    tags: ["fountain", "wood", "specialty", "pens"],
    occasions: ["Graduation", "Retirement", "Anniversary"],
    relatedProducts: ["p266", "p267", "p35"],
    seoTitle: "Majestic JR Fountain Pen in Red Mallee Burl Hybrid | Paul's Pens n Things",
    seoDescription:
      "A majestic JR fountain pen with fittings and trim in chrome and 22kt gold. Handcrafted in Paragould, Arkansas.",
  },
  {
    id: "p266",
    slug: "majjrf-4-majestic-jr-fountain-pen",
    name: "Majestic JR Fountain Pen in Red Mallee Burl Hybrid with Gun Metal",
    internalCode: "MAJJRF-4",
    category: "pens",
    subcategory: "Fountain & Rollerball",
    shortDescription: "A majestic JR fountain pen with fittings and trim in chrome and gun metal.",
    fullDescription:
      "A majestic JR fountain pen with fittings and trim in chrome and gun metal. The barrels are a red mallee burl and resin hybrid, with a Swarovski crystal set in the clip. The screw-on cap keeps the ink from drying out between writing sessions.",
    price: 180,
    priceType: "fixed",
    status: "available",
    materials: ["Red mallee burl and resin hybrid"],
    finishes: ["Chrome and gun metal trim", "Swarovski crystal clip"],
    customizable: true,
    featured: false,
    images: [img(majjrf4Img, "Majestic JR fountain pen in red mallee burl and resin hybrid with chrome and gun metal trim", 800, 601)],
    tags: ["fountain", "wood", "specialty", "pens"],
    occasions: ["Graduation", "Retirement", "Anniversary"],
    relatedProducts: ["p267", "p268", "p265"],
    seoTitle: "Majestic JR Fountain Pen in Red Mallee Burl Hybrid with Gun Metal | Paul's Pens n Things",
    seoDescription:
      "A majestic JR fountain pen with fittings and trim in chrome and gun metal. Handcrafted in Paragould, Arkansas.",
  },
  {
    id: "p267",
    slug: "majjrf-5-majestic-jr-fountain-pen",
    name: "Majestic JR Fountain Pen in Red Mallee Burl Hybrid II",
    internalCode: "MAJJRF-5",
    category: "pens",
    subcategory: "Fountain & Rollerball",
    shortDescription: "A majestic JR fountain pen with fittings and trim in chrome and 22kt gold.",
    fullDescription:
      "A majestic JR fountain pen with fittings and trim in chrome and 22kt gold. The barrels are a red mallee burl and resin hybrid, with a Swarovski crystal set in the clip. The screw-on cap keeps the ink from drying out between writing sessions.",
    price: 200,
    priceType: "fixed",
    status: "available",
    materials: ["Red mallee burl and resin hybrid"],
    finishes: ["Chrome and 22kt gold trim", "Swarovski crystal clip"],
    customizable: true,
    featured: false,
    images: [img(majjrf5Img, "Majestic JR fountain pen in red mallee burl and resin hybrid with chrome and 22kt gold trim", 800, 600)],
    tags: ["fountain", "wood", "specialty", "pens"],
    occasions: ["Graduation", "Retirement", "Anniversary"],
    relatedProducts: ["p268", "p265", "p266"],
    seoTitle: "Majestic JR Fountain Pen in Red Mallee Burl Hybrid II | Paul's Pens n Things",
    seoDescription:
      "A majestic JR fountain pen with fittings and trim in chrome and 22kt gold. Handcrafted in Paragould, Arkansas.",
  },
  {
    id: "p268",
    slug: "majjrf-6-majestic-jr-fountain-pen",
    name: "Majestic JR Fountain Pen in Red Mallee Burl and Black Resin Hybrid",
    internalCode: "MAJJRF-6",
    category: "pens",
    subcategory: "Fountain & Rollerball",
    shortDescription: "A majestic JR fountain pen with fittings and trim in chrome and gun metal.",
    fullDescription:
      "A majestic JR fountain pen with fittings and trim in chrome and gun metal. The barrels are a red mallee burl and black resin hybrid, with a Swarovski crystal set in the clip. The screw-on cap keeps the ink from drying out between writing sessions.",
    price: 180,
    priceType: "fixed",
    status: "available",
    materials: ["Red mallee burl and black resin hybrid"],
    finishes: ["Chrome and gun metal trim", "Swarovski crystal clip"],
    customizable: true,
    featured: false,
    images: [img(majjrf6Img, "Majestic JR fountain pen in red mallee burl and black resin hybrid with chrome and gun metal trim", 800, 600)],
    tags: ["fountain", "wood", "specialty", "pens"],
    occasions: ["Graduation", "Retirement", "Anniversary"],
    relatedProducts: ["p265", "p266", "p273"],
    seoTitle: "Majestic JR Fountain Pen in Red Mallee Burl and Black Resin Hybrid | Paul's Pens n Things",
    seoDescription:
      "A majestic JR fountain pen with fittings and trim in chrome and gun metal. Handcrafted in Paragould, Arkansas.",
  },
  {
    id: "p273",
    slug: "majjrrb-1-majestic-jr-rollerball",
    name: "Majestic JR Rollerball in Red Mallee Burl Hybrid",
    internalCode: "MAJJRRB-1",
    category: "pens",
    subcategory: "Fountain & Rollerball",
    shortDescription: "A majestic JR rollerball with fittings and trim in rhodium and 22kt gold.",
    fullDescription:
      "A majestic JR rollerball with fittings and trim in rhodium and 22kt gold. The barrels are a red mallee burl and resin hybrid, with a Swarovski crystal set in the clip. The screw-on cap keeps the ink from drying out between writing sessions.",
    price: 225,
    priceType: "fixed",
    status: "available",
    materials: ["Red mallee burl and resin hybrid"],
    finishes: ["Rhodium and 22kt gold trim", "Swarovski crystal clip"],
    customizable: true,
    featured: false,
    images: [img(majjrrb1Img, "Majestic JR rollerball in red mallee burl and resin hybrid with rhodium and 22kt gold trim", 800, 600)],
    tags: ["rollerball", "wood", "specialty", "pens"],
    occasions: ["Graduation", "Retirement", "Anniversary"],
    relatedProducts: ["p274", "p275", "p35"],
    seoTitle: "Majestic JR Rollerball in Red Mallee Burl Hybrid | Paul's Pens n Things",
    seoDescription:
      "A majestic JR rollerball with fittings and trim in rhodium and 22kt gold. Handcrafted in Paragould, Arkansas.",
  },
  {
    id: "p274",
    slug: "majjrrb-2-majestic-jr-rollerball",
    name: "Majestic JR Rollerball in Red Mallee Burl Hybrid with Black Titanium",
    internalCode: "MAJJRRB-2",
    category: "pens",
    subcategory: "Fountain & Rollerball",
    shortDescription: "A majestic JR rollerball with fittings and trim in rhodium and black titanium nitride.",
    fullDescription:
      "A majestic JR rollerball with fittings and trim in rhodium and black titanium nitride. The barrels are a red mallee burl and resin hybrid, with a Swarovski crystal set in the clip. The screw-on cap keeps the ink from drying out between writing sessions.",
    price: 200,
    priceType: "fixed",
    status: "available",
    materials: ["Red mallee burl and resin hybrid"],
    finishes: ["Rhodium and black titanium nitride trim", "Swarovski crystal clip"],
    customizable: true,
    featured: false,
    images: [img(majjrrb2Img, "Majestic JR rollerball in red mallee burl and resin hybrid with rhodium and black titanium nitride trim", 800, 576)],
    tags: ["rollerball", "wood", "specialty", "pens"],
    occasions: ["Graduation", "Retirement", "Anniversary"],
    relatedProducts: ["p275", "p276", "p273"],
    seoTitle: "Majestic JR Rollerball in Red Mallee Burl Hybrid with Black Titanium | Paul's Pens n Things",
    seoDescription:
      "A majestic JR rollerball with fittings and trim in rhodium and black titanium nitride. Handcrafted in Paragould, Arkansas.",
  },
  {
    id: "p275",
    slug: "majjrrb-3-majestic-jr-rollerball",
    name: "Majestic JR Rollerball in Red Mallee Burl and Black Resin Hybrid",
    internalCode: "MAJJRRB-3",
    category: "pens",
    subcategory: "Fountain & Rollerball",
    shortDescription: "A majestic JR rollerball with fittings and trim in rhodium and 22kt gold.",
    fullDescription:
      "A majestic JR rollerball with fittings and trim in rhodium and 22kt gold. The barrels are a red mallee burl and black resin hybrid, with a Swarovski crystal set in the clip. The screw-on cap keeps the ink from drying out between writing sessions.",
    price: 225,
    priceType: "fixed",
    status: "available",
    materials: ["Red mallee burl and black resin hybrid"],
    finishes: ["Rhodium and 22kt gold trim", "Swarovski crystal clip"],
    customizable: true,
    featured: false,
    images: [img(majjrrb3Img, "Majestic JR rollerball in red mallee burl and black resin hybrid with rhodium and 22kt gold trim", 800, 601)],
    tags: ["rollerball", "wood", "specialty", "pens"],
    occasions: ["Graduation", "Retirement", "Anniversary"],
    relatedProducts: ["p276", "p273", "p274"],
    seoTitle: "Majestic JR Rollerball in Red Mallee Burl and Black Resin Hybrid | Paul's Pens n Things",
    seoDescription:
      "A majestic JR rollerball with fittings and trim in rhodium and 22kt gold. Handcrafted in Paragould, Arkansas.",
  },
  {
    id: "p276",
    slug: "majjrrb-4-majestic-jr-rollerball",
    name: "Majestic JR Rollerball in Red Mallee Burl and Green Resin Hybrid",
    internalCode: "MAJJRRB-4",
    category: "pens",
    subcategory: "Fountain & Rollerball",
    shortDescription: "A majestic JR rollerball with fittings and trim in rhodium and black titanium nitride.",
    fullDescription:
      "A majestic JR rollerball with fittings and trim in rhodium and black titanium nitride. The barrels are a red mallee burl and green resin hybrid, with a Swarovski crystal set in the clip. The screw-on cap keeps the ink from drying out between writing sessions.",
    price: 200,
    priceType: "fixed",
    status: "available",
    materials: ["Red mallee burl and green resin hybrid"],
    finishes: ["Rhodium and black titanium nitride trim", "Swarovski crystal clip"],
    customizable: true,
    featured: false,
    images: [img(majjrrb4Img, "Majestic JR rollerball in red mallee burl and green resin hybrid with rhodium and black titanium nitride trim", 800, 593)],
    tags: ["rollerball", "wood", "specialty", "pens"],
    occasions: ["Graduation", "Retirement", "Anniversary"],
    relatedProducts: ["p273", "p274", "p275"],
    seoTitle: "Majestic JR Rollerball in Red Mallee Burl and Green Resin Hybrid | Paul's Pens n Things",
    seoDescription:
      "A majestic JR rollerball with fittings and trim in rhodium and black titanium nitride. Handcrafted in Paragould, Arkansas.",
  },
  {
    id: "p37",
    slug: "dkf1-diamond-knurl-fountain-pen",
    name: "Diamond Knurl Fountain Pen in Maple",
    internalCode: "DKF1",
    category: "pens",
    subcategory: "Fountain & Rollerball",
    shortDescription: "A diamond knurl style fountain pen with black chrome trim and fittings.",
    fullDescription: "A diamond knurl style fountain pen with black chrome trim and fittings. The barrels are turned from maple. The screw-on cap keeps the ink from drying out between writing sessions.",
    price: 100,
    priceType: "fixed",
    status: "available",
    materials: ["Maple"],
    finishes: ["Black chrome trim"],
    customizable: true,
    featured: false,
    images: [img(dkf1Img, "Diamond knurl fountain pen in maple with black chrome trim", 360, 271)],
    tags: ["fountain", "wood", "pens"],
    occasions: ["Graduation", "Retirement", "Anniversary"],
    relatedProducts: ["p38", "p39"],
    seoTitle: "Diamond Knurl Fountain Pen in Maple | Paul's Pens n Things",
    seoDescription: "A diamond knurl style fountain pen with black chrome trim and fittings. Handcrafted in Paragould, Arkansas.",
  },
  {
    id: "p38",
    slug: "dkf2-diamond-knurl-fountain-pen",
    name: "Diamond Knurl Fountain Pen in Hardwood",
    internalCode: "DKF2",
    category: "pens",
    subcategory: "Fountain & Rollerball",
    shortDescription: "A diamond knurl style fountain pen with black chrome trim and fittings.",
    fullDescription: "A diamond knurl style fountain pen with black chrome trim and fittings. The barrels are turned from an unknown wood. The screw-on cap keeps the ink from drying out between writing sessions.",
    price: 100,
    priceType: "fixed",
    status: "available",
    materials: ["Hardwood (unidentified)"],
    finishes: ["Black chrome trim"],
    customizable: true,
    featured: false,
    images: [img(dkf2Img, "Diamond knurl fountain pen in hardwood with black chrome trim", 360, 271)],
    tags: ["fountain", "wood", "pens"],
    occasions: ["Graduation", "Retirement", "Anniversary"],
    relatedProducts: ["p39", "p40"],
    seoTitle: "Diamond Knurl Fountain Pen in Hardwood | Paul's Pens n Things",
    seoDescription: "A diamond knurl style fountain pen with black chrome trim and fittings. Handcrafted in Paragould, Arkansas.",
  },
  {
    id: "p39",
    slug: "claf1-classic-fountain-pen",
    name: "Classic Fountain Pen in Resin",
    internalCode: "CLAF1",
    category: "pens",
    subcategory: "Fountain & Rollerball",
    shortDescription: "A classic style fountain pen with chrome trim and fittings.",
    fullDescription: "A classic style fountain pen with chrome trim and fittings. The barrels are made of an unknown resin. The screw-on cap keeps the ink from drying out between writing sessions.",
    price: 75,
    priceType: "fixed",
    status: "available",
    materials: ["Cast resin"],
    finishes: ["Chrome trim"],
    customizable: true,
    featured: false,
    images: [img(claf1Img, "Classic style fountain pen in cast resin with chrome trim", 360, 271)],
    tags: ["fountain", "resin", "pens"],
    occasions: ["Graduation", "Retirement", "Anniversary"],
    relatedProducts: ["p40", "p41"],
    seoTitle: "Classic Fountain Pen in Resin | Paul's Pens n Things",
    seoDescription: "A classic style fountain pen with chrome trim and fittings. Handcrafted in Paragould, Arkansas.",
  },
  {
    id: "p40",
    slug: "claf2-classic-fountain-pen",
    name: "Classic Fountain Pen in AC16 Resin",
    internalCode: "CLAF2",
    category: "pens",
    subcategory: "Fountain & Rollerball",
    shortDescription: "A classic style fountain pen with chrome trim and fittings.",
    fullDescription: "A classic style fountain pen with chrome trim and fittings. The barrels are made of AC16 resin. The screw-on cap keeps the ink from drying out between writing sessions.",
    price: 75,
    priceType: "fixed",
    status: "available",
    materials: ["AC16 resin"],
    finishes: ["Chrome trim"],
    customizable: true,
    featured: false,
    images: [img(claf2Img, "Classic style fountain pen in AC16 resin with chrome trim", 360, 271)],
    tags: ["fountain", "resin", "pens"],
    occasions: ["Graduation", "Retirement", "Anniversary"],
    relatedProducts: ["p41", "p42"],
    seoTitle: "Classic Fountain Pen in AC16 Resin | Paul's Pens n Things",
    seoDescription: "A classic style fountain pen with chrome trim and fittings. Handcrafted in Paragould, Arkansas.",
  },
  {
    id: "p41",
    slug: "claf3-classic-fountain-pen",
    name: "Classic Fountain Pen in IA46 Resin",
    internalCode: "CLAF3",
    category: "pens",
    subcategory: "Fountain & Rollerball",
    shortDescription: "A classic style fountain pen with chrome trim and fittings.",
    fullDescription: "A classic style fountain pen with chrome trim and fittings. The barrels are made of IA46 resin. The screw-on cap keeps the ink from drying out between writing sessions.",
    price: 75,
    priceType: "fixed",
    status: "available",
    materials: ["IA46 resin"],
    finishes: ["Chrome trim"],
    customizable: true,
    featured: false,
    images: [img(claf3Img, "Classic style fountain pen in IA46 resin with chrome trim", 360, 271)],
    tags: ["fountain", "resin", "pens"],
    occasions: ["Graduation", "Retirement", "Anniversary"],
    relatedProducts: ["p42", "p43"],
    seoTitle: "Classic Fountain Pen in IA46 Resin | Paul's Pens n Things",
    seoDescription: "A classic style fountain pen with chrome trim and fittings. Handcrafted in Paragould, Arkansas.",
  },
  {
    id: "p42",
    slug: "claf4-classic-fountain-pen",
    name: "Classic Fountain Pen in Hardwood",
    internalCode: "CLAF4",
    category: "pens",
    subcategory: "Fountain & Rollerball",
    shortDescription: "A classic style fountain pen with chrome trim and fittings.",
    fullDescription: "A classic style fountain pen with chrome trim and fittings. The barrels are turned from an unknown wood. The screw-on cap keeps the ink from drying out between writing sessions. This pen has sold; Paul can make something similar in your own materials.",
    price: 75,
    priceType: "fixed",
    status: "previously-created",
    materials: ["Hardwood (unidentified)"],
    finishes: ["Chrome trim"],
    customizable: true,
    featured: false,
    images: [img(claf4Img, "Classic style fountain pen turned from hardwood with chrome trim", 360, 271)],
    tags: ["fountain", "wood", "pens"],
    occasions: ["Graduation", "Retirement", "Anniversary"],
    relatedProducts: ["p43", "p44"],
    seoTitle: "Classic Fountain Pen in Hardwood | Paul's Pens n Things",
    seoDescription: "A classic style fountain pen with chrome trim and fittings. Handcrafted in Paragould, Arkansas.",
  },
  {
    id: "p43",
    slug: "claf5-classic-fountain-pen",
    name: "Classic Fountain Pen in Two-Tone Purple Heart",
    internalCode: "CLAF5",
    category: "pens",
    subcategory: "Fountain & Rollerball",
    shortDescription: "A classic style fountain pen with chrome trim and fittings.",
    fullDescription: "A classic style fountain pen with chrome trim and fittings. The barrels are turned from two-tone purple heart. The screw-on cap keeps the ink from drying out between writing sessions. This pen has sold; Paul can make something similar in your own materials.",
    price: 75,
    priceType: "fixed",
    status: "previously-created",
    materials: ["Two-tone purple heart"],
    finishes: ["Chrome trim"],
    customizable: true,
    featured: false,
    images: [img(claf5Img, "Classic style fountain pen in two-tone purple heart with chrome trim", 360, 271)],
    tags: ["fountain", "wood", "pens"],
    occasions: ["Graduation", "Retirement", "Anniversary"],
    relatedProducts: ["p44", "p45"],
    seoTitle: "Classic Fountain Pen in Two-Tone Purple Heart | Paul's Pens n Things",
    seoDescription: "A classic style fountain pen with chrome trim and fittings. Handcrafted in Paragould, Arkansas.",
  },
  {
    id: "p44",
    slug: "drf1-dragon-fountain-pen",
    name: "Dragon Fountain Pen in Zebra Wood",
    internalCode: "DRF1",
    category: "pens",
    subcategory: "Fountain & Rollerball",
    shortDescription: "A dragon fountain pen with antique copper trim and fittings, turned from zebra wood.",
    fullDescription: "A dragon fountain pen with antique copper trim and fittings, turned from zebra wood. The clip is shaped like a dragon, a dragon claw wraps the centerband, and a tiger's eye stone is set in the cap. The screw-on cap keeps the ink from drying out between writing sessions.",
    price: 100,
    priceType: "fixed",
    status: "available",
    materials: ["Zebra wood", "Tiger's eye stone"],
    finishes: ["Antique copper trim", "Dragon clip and claw centerband"],
    customizable: true,
    featured: false,
    images: [img(drf1Img, "Dragon fountain pen in zebra wood with antique copper dragon clip", 360, 271)],
    tags: ["fountain", "wood", "specialty", "pens"],
    occasions: ["Graduation", "Retirement", "Anniversary"],
    relatedProducts: ["p45", "p46"],
    seoTitle: "Dragon Fountain Pen in Zebra Wood | Paul's Pens n Things",
    seoDescription: "A dragon fountain pen with antique copper trim and fittings, turned from zebra wood. Handcrafted in Paragould, Arkansas.",
  },
  {
    id: "p45",
    slug: "drf2-dragon-fountain-pen",
    name: "Dragon Fountain Pen in Resin",
    internalCode: "DRF2",
    category: "pens",
    subcategory: "Fountain & Rollerball",
    shortDescription: "A dragon fountain pen with antique brass trim and fittings, turned from resin.",
    fullDescription: "A dragon fountain pen with antique brass trim and fittings, turned from resin. The clip is shaped like a dragon, a dragon claw wraps the centerband, and a tiger's eye stone is set in the cap. The screw-on cap keeps the ink from drying out between writing sessions.",
    price: 100,
    priceType: "fixed",
    status: "available",
    materials: ["Cast resin", "Tiger's eye stone"],
    finishes: ["Antique brass trim", "Dragon clip and claw centerband"],
    customizable: true,
    featured: false,
    images: [img(drf2Img, "Dragon fountain pen in resin with antique brass dragon clip", 360, 271)],
    tags: ["fountain", "resin", "specialty", "pens"],
    occasions: ["Graduation", "Retirement", "Anniversary"],
    relatedProducts: ["p46", "p47"],
    seoTitle: "Dragon Fountain Pen in Resin | Paul's Pens n Things",
    seoDescription: "A dragon fountain pen with antique brass trim and fittings, turned from resin. Handcrafted in Paragould, Arkansas.",
  },
  {
    id: "p46",
    slug: "drf3-dragon-fountain-pen",
    name: "Dragon Fountain Pen in Resin with Pewter",
    internalCode: "DRF3",
    category: "pens",
    subcategory: "Fountain & Rollerball",
    shortDescription: "A dragon fountain pen with antique pewter trim and fittings, turned from resin.",
    fullDescription: "A dragon fountain pen with antique pewter trim and fittings, turned from resin. The clip is shaped like a dragon, a dragon claw wraps the centerband, and a tiger's eye stone is set in the cap. The screw-on cap keeps the ink from drying out between writing sessions.",
    price: 100,
    priceType: "fixed",
    status: "available",
    materials: ["Cast resin", "Tiger's eye stone"],
    finishes: ["Antique pewter trim", "Dragon clip and claw centerband"],
    customizable: true,
    featured: false,
    images: [img(drf3Img, "Dragon fountain pen in resin with antique pewter dragon clip", 360, 271)],
    tags: ["fountain", "resin", "specialty", "pens"],
    occasions: ["Graduation", "Retirement", "Anniversary"],
    relatedProducts: ["p47", "p48"],
    seoTitle: "Dragon Fountain Pen in Resin with Pewter | Paul's Pens n Things",
    seoDescription: "A dragon fountain pen with antique pewter trim and fittings, turned from resin. Handcrafted in Paragould, Arkansas.",
  },
  {
    id: "p47",
    slug: "rb-3-nouveau-sceptre-rollerball",
    name: "Nouveau Sceptre Rollerball in Maple Burl",
    internalCode: "RB-3",
    category: "pens",
    subcategory: "Fountain & Rollerball",
    shortDescription: "A nouveau sceptre style rollerball with 22kt gold and rhodium fittings and trim.",
    fullDescription: "A nouveau sceptre style rollerball with 22kt gold and rhodium fittings and trim. The barrels are turned from maple burl. The screw-on cap keeps the ink from drying out between writing sessions.",
    price: 100,
    priceType: "fixed",
    status: "available",
    materials: ["Maple burl"],
    finishes: ["22kt gold and rhodium trim"],
    customizable: true,
    featured: false,
    images: [img(rb3Img, "Nouveau sceptre rollerball in maple burl with gold and rhodium trim", 360, 271)],
    tags: ["rollerball", "wood", "pens"],
    occasions: ["Graduation", "Retirement", "Anniversary"],
    relatedProducts: ["p48", "p49"],
    seoTitle: "Nouveau Sceptre Rollerball in Maple Burl | Paul's Pens n Things",
    seoDescription: "A nouveau sceptre style rollerball with 22kt gold and rhodium fittings and trim. Handcrafted in Paragould, Arkansas.",
  },
  {
    id: "p48",
    slug: "rb-4-robusto-rollerball",
    name: "Robusto Rollerball in Hardwood",
    internalCode: "RB-4",
    category: "pens",
    subcategory: "Fountain & Rollerball",
    shortDescription: "A robusto style rollerball with 24kt gold fittings and trim.",
    fullDescription: "A robusto style rollerball with 24kt gold fittings and trim. The barrels are turned from an unknown wood. The screw-on cap keeps the ink from drying out between writing sessions. This pen has sold; Paul can make something similar in your own materials.",
    price: 70,
    priceType: "fixed",
    status: "previously-created",
    materials: ["Hardwood (unidentified)"],
    finishes: ["24kt gold trim"],
    customizable: true,
    featured: false,
    images: [img(rb4Img, "Robusto style rollerball turned from hardwood with 24kt gold trim", 360, 271)],
    tags: ["rollerball", "wood", "pens"],
    occasions: ["Graduation", "Retirement", "Anniversary"],
    relatedProducts: ["p49", "p50"],
    seoTitle: "Robusto Rollerball in Hardwood | Paul's Pens n Things",
    seoDescription: "A robusto style rollerball with 24kt gold fittings and trim. Handcrafted in Paragould, Arkansas.",
  },
  {
    id: "p49",
    slug: "rb-6-el-grande-rollerball",
    name: "El Grande Rollerball in Hardwood",
    internalCode: "RB-6",
    category: "pens",
    subcategory: "Fountain & Rollerball",
    shortDescription: "An el grande style rollerball with 24kt gold fittings and trim.",
    fullDescription: "An el grande style rollerball with 24kt gold fittings and trim. The barrels are turned from an unknown wood. The screw-on cap keeps the ink from drying out between writing sessions. This pen has sold; Paul can make something similar in your own materials.",
    price: 60,
    priceType: "fixed",
    status: "previously-created",
    materials: ["Hardwood (unidentified)"],
    finishes: ["24kt gold trim"],
    customizable: true,
    featured: false,
    images: [img(rb6Img, "El Grande rollerball turned from hardwood with 24kt gold trim", 360, 271)],
    tags: ["rollerball", "wood", "pens"],
    occasions: ["Graduation", "Retirement", "Anniversary"],
    relatedProducts: ["p50", "p51"],
    seoTitle: "El Grande Rollerball in Hardwood | Paul's Pens n Things",
    seoDescription: "An el grande style rollerball with 24kt gold fittings and trim. Handcrafted in Paragould, Arkansas.",
  },
  {
    id: "p50",
    slug: "rb-8-churchill-rollerball",
    name: "Churchill Rollerball in Cocobolo",
    internalCode: "RB-8",
    category: "pens",
    subcategory: "Fountain & Rollerball",
    shortDescription: "A churchill style rollerball with 24kt gold trim and fittings.",
    fullDescription: "A churchill style rollerball with 24kt gold trim and fittings. The barrels are turned from cocobolo. The screw-on cap keeps the ink from drying out between writing sessions.",
    price: 65,
    priceType: "fixed",
    status: "available",
    materials: ["Cocobolo"],
    finishes: ["24kt gold trim"],
    customizable: true,
    featured: false,
    images: [img(rb8Img, "Churchill style rollerball in cocobolo with 24kt gold trim", 360, 271)],
    tags: ["rollerball", "wood", "pens"],
    occasions: ["Graduation", "Retirement", "Anniversary"],
    relatedProducts: ["p51", "p52"],
    seoTitle: "Churchill Rollerball in Cocobolo | Paul's Pens n Things",
    seoDescription: "A churchill style rollerball with 24kt gold trim and fittings. Handcrafted in Paragould, Arkansas.",
  },
  {
    id: "p51",
    slug: "rb-9-el-grande-rollerball-mesquite",
    name: "El Grande Rollerball in Mesquite",
    internalCode: "RB-9",
    category: "pens",
    subcategory: "Fountain & Rollerball",
    shortDescription: "An el grande style rollerball with chrome trim and fittings.",
    fullDescription: "An el grande style rollerball with chrome trim and fittings. The barrels are turned from mesquite. The screw-on cap keeps the ink from drying out between writing sessions.",
    price: 60,
    priceType: "fixed",
    status: "available",
    materials: ["Mesquite"],
    finishes: ["Chrome trim"],
    customizable: true,
    featured: false,
    images: [img(rb9Img, "El Grande rollerball in mesquite with chrome trim", 360, 271)],
    tags: ["rollerball", "wood", "pens"],
    occasions: ["Graduation", "Retirement", "Anniversary"],
    relatedProducts: ["p52", "p53"],
    seoTitle: "El Grande Rollerball in Mesquite | Paul's Pens n Things",
    seoDescription: "An el grande style rollerball with chrome trim and fittings. Handcrafted in Paragould, Arkansas.",
  },
  {
    id: "p52",
    slug: "rb-10-parker-rollerball",
    name: "Parker Style Rollerball in Mesquite",
    internalCode: "RB-10",
    category: "pens",
    subcategory: "Fountain & Rollerball",
    shortDescription: "A parker style rollerball with 24kt gold fittings and trim.",
    fullDescription: "A parker style rollerball with 24kt gold fittings and trim. The barrels are turned from mesquite. This pen has sold; Paul can make something similar in your own materials.",
    price: 60,
    priceType: "fixed",
    status: "previously-created",
    materials: ["Mesquite"],
    finishes: ["24kt gold trim"],
    customizable: true,
    featured: false,
    images: [img(rb10Img, "Parker style rollerball in mesquite with 24kt gold trim", 360, 271)],
    tags: ["rollerball", "wood", "pens"],
    occasions: ["Graduation", "Retirement", "Anniversary"],
    relatedProducts: ["p53", "p54"],
    seoTitle: "Parker Style Rollerball in Mesquite | Paul's Pens n Things",
    seoDescription: "A parker style rollerball with 24kt gold fittings and trim. Handcrafted in Paragould, Arkansas.",
  },
  {
    id: "p53",
    slug: "drr-ab-dragon-rollerball",
    name: "Dragon Rollerball in Marble Wood",
    internalCode: "DRR-AB",
    category: "pens",
    subcategory: "Fountain & Rollerball",
    shortDescription: "A dragon style rollerball with antique brass trim and fittings, turned from marble wood.",
    fullDescription: "A dragon style rollerball with antique brass trim and fittings, turned from marble wood. The clip is shaped like a dragon, a claw surrounds the center band, and a tiger's eye stone is set in the cap. The screw-on cap keeps the ink from drying out between writing sessions.",
    price: 90,
    priceType: "fixed",
    status: "available",
    materials: ["Marble wood", "Tiger's eye stone"],
    finishes: ["Antique brass trim", "Dragon clip and claw centerband"],
    customizable: true,
    featured: false,
    images: [img(drrabImg, "Dragon rollerball in marble wood with antique brass dragon clip", 360, 271)],
    tags: ["rollerball", "wood", "specialty", "pens"],
    occasions: ["Graduation", "Retirement", "Anniversary"],
    relatedProducts: ["p54", "p55"],
    seoTitle: "Dragon Rollerball in Marble Wood | Paul's Pens n Things",
    seoDescription: "A dragon style rollerball with antique brass trim and fittings, turned from marble wood. Handcrafted in Paragould, Arkansas.",
  },
  {
    id: "p54",
    featured: true,
    slug: "drr-ab2-dragon-rollerball",
    name: "Dragon Rollerball in Resin",
    internalCode: "DRR-AB2",
    category: "pens",
    subcategory: "Fountain & Rollerball",
    shortDescription: "A dragon style rollerball with antique brass trim and fittings, turned from resin.",
    fullDescription: "A dragon style rollerball with antique brass trim and fittings, turned from resin. The clip is shaped like a dragon, a claw surrounds the center band, and a tiger's eye stone is set in the cap. This pen has sold; Paul can make something similar in your own materials.",
    price: 90,
    priceType: "fixed",
    status: "previously-created",
    materials: ["Cast resin", "Tiger's eye stone"],
    finishes: ["Antique brass trim", "Dragon clip and claw centerband"],
    customizable: true,
    images: [img(drrab2Img, "Dragon rollerball in resin with antique brass dragon clip", 360, 271)],
    tags: ["rollerball", "resin", "specialty", "pens"],
    occasions: ["Graduation", "Retirement", "Anniversary"],
    relatedProducts: ["p55", "p56"],
    seoTitle: "Dragon Rollerball in Resin | Paul's Pens n Things",
    seoDescription: "A dragon style rollerball with antique brass trim and fittings, turned from resin. Handcrafted in Paragould, Arkansas.",
  },
  {
    id: "p55",
    slug: "drr-ac-dragon-rollerball",
    name: "Dragon Rollerball in Spalted Maple",
    internalCode: "DRR-AC",
    category: "pens",
    subcategory: "Fountain & Rollerball",
    shortDescription: "A dragon style rollerball with antique copper trim and fittings, turned from spalted maple.",
    fullDescription: "A dragon style rollerball with antique copper trim and fittings, turned from spalted maple. The clip is shaped like a dragon, a claw surrounds the center band, and a tiger's eye stone is set in the cap. The screw-on cap keeps the ink from drying out between writing sessions.",
    price: 90,
    priceType: "fixed",
    status: "available",
    materials: ["Spalted maple", "Tiger's eye stone"],
    finishes: ["Antique copper trim", "Dragon clip and claw centerband"],
    customizable: true,
    featured: false,
    images: [img(drracImg, "Dragon rollerball in spalted maple with antique copper dragon clip", 360, 271)],
    tags: ["rollerball", "wood", "specialty", "pens"],
    occasions: ["Graduation", "Retirement", "Anniversary"],
    relatedProducts: ["p56", "p57"],
    seoTitle: "Dragon Rollerball in Spalted Maple | Paul's Pens n Things",
    seoDescription: "A dragon style rollerball with antique copper trim and fittings, turned from spalted maple. Handcrafted in Paragould, Arkansas.",
  },
  {
    id: "p56",
    slug: "dkrb1-diamond-knurl-rollerball-stainless",
    name: "Diamond Knurl Rollerball with Stainless Steel Barrels",
    internalCode: "DKRB1",
    category: "pens",
    subcategory: "Fountain & Rollerball",
    shortDescription: "A diamond knurl style rollerball with gold titanium nitride trim and fittings.",
    fullDescription: "A diamond knurl style rollerball with gold titanium nitride trim and fittings. The barrels are braided stainless steel embedded in clear resin. The screw-on cap keeps the ink from drying out between writing sessions.",
    price: 90,
    priceType: "fixed",
    status: "available",
    materials: ["Braided stainless steel", "Clear resin"],
    finishes: ["Gold titanium nitride trim"],
    customizable: true,
    featured: false,
    images: [img(dkrb1Img, "Diamond knurl rollerball with braided stainless steel in clear resin", 360, 271)],
    tags: ["rollerball", "specialty", "resin", "pens"],
    occasions: ["Graduation", "Retirement", "Anniversary"],
    relatedProducts: ["p57", "p58"],
    seoTitle: "Diamond Knurl Rollerball with Stainless Steel Barrels | Paul's Pens n Things",
    seoDescription: "A diamond knurl style rollerball with gold titanium nitride trim and fittings. Handcrafted in Paragould, Arkansas.",
  },
  {
    id: "p57",
    slug: "dkrb2-diamond-knurl-rollerball-copper",
    name: "Diamond Knurl Rollerball with Copper Barrels",
    internalCode: "DKRB2",
    category: "pens",
    subcategory: "Fountain & Rollerball",
    shortDescription: "A diamond knurl style rollerball with gold titanium nitride trim and fittings.",
    fullDescription: "A diamond knurl style rollerball with gold titanium nitride trim and fittings. The barrels are braided copper embedded in clear resin. The screw-on cap keeps the ink from drying out between writing sessions.",
    price: 90,
    priceType: "fixed",
    status: "available",
    materials: ["Braided copper", "Clear resin"],
    finishes: ["Gold titanium nitride trim"],
    customizable: true,
    featured: false,
    images: [img(dkrb2Img, "Diamond knurl rollerball with braided copper in clear resin", 360, 271)],
    tags: ["rollerball", "specialty", "resin", "pens"],
    occasions: ["Graduation", "Retirement", "Anniversary"],
    relatedProducts: ["p58", "p59"],
    seoTitle: "Diamond Knurl Rollerball with Copper Barrels | Paul's Pens n Things",
    seoDescription: "A diamond knurl style rollerball with gold titanium nitride trim and fittings. Handcrafted in Paragould, Arkansas.",
  },
  {
    id: "p58",
    slug: "dkrb3-diamond-knurl-rollerball-carbon-fiber",
    name: "Diamond Knurl Rollerball with Carbon Fiber Barrels",
    internalCode: "DKRB3",
    category: "pens",
    subcategory: "Fountain & Rollerball",
    shortDescription: "A diamond knurl style rollerball with gold titanium nitride trim and fittings.",
    fullDescription: "A diamond knurl style rollerball with gold titanium nitride trim and fittings. The barrels are braided carbon fiber embedded in clear resin. The screw-on cap keeps the ink from drying out between writing sessions.",
    price: 90,
    priceType: "fixed",
    status: "available",
    materials: ["Braided carbon fiber", "Clear resin"],
    finishes: ["Gold titanium nitride trim"],
    customizable: true,
    featured: false,
    images: [img(dkrb3Img, "Diamond knurl rollerball with braided carbon fiber in clear resin", 360, 271)],
    tags: ["rollerball", "specialty", "resin", "pens"],
    occasions: ["Graduation", "Retirement", "Anniversary"],
    relatedProducts: ["p59", "p60"],
    seoTitle: "Diamond Knurl Rollerball with Carbon Fiber Barrels | Paul's Pens n Things",
    seoDescription: "A diamond knurl style rollerball with gold titanium nitride trim and fittings. Handcrafted in Paragould, Arkansas.",
  },
  {
    id: "p59",
    slug: "dkrb4-diamond-knurl-rollerball-purple-heart",
    name: "Diamond Knurl Rollerball in Two-Tone Purple Heart",
    internalCode: "DKRB4",
    category: "pens",
    subcategory: "Fountain & Rollerball",
    shortDescription: "A diamond knurl style rollerball with gold titanium nitride trim and fittings.",
    fullDescription: "A diamond knurl style rollerball with gold titanium nitride trim and fittings. The barrels are turned from two-tone purple heart. The screw-on cap keeps the ink from drying out between writing sessions.",
    price: 90,
    priceType: "fixed",
    status: "available",
    materials: ["Two-tone purple heart"],
    finishes: ["Gold titanium nitride trim"],
    customizable: true,
    featured: false,
    images: [img(dkrb4Img, "Diamond knurl rollerball in two-tone purple heart", 360, 271)],
    tags: ["rollerball", "wood", "pens"],
    occasions: ["Graduation", "Retirement", "Anniversary"],
    relatedProducts: ["p60", "p61"],
    seoTitle: "Diamond Knurl Rollerball in Two-Tone Purple Heart | Paul's Pens n Things",
    seoDescription: "A diamond knurl style rollerball with gold titanium nitride trim and fittings. Handcrafted in Paragould, Arkansas.",
  },
  {
    id: "p60",
    slug: "dkrb5-diamond-knurl-rollerball-hardwood",
    name: "Diamond Knurl Rollerball in Hardwood",
    internalCode: "DKRB5",
    category: "pens",
    subcategory: "Fountain & Rollerball",
    shortDescription: "A diamond knurl style rollerball with gold titanium nitride trim and fittings.",
    fullDescription: "A diamond knurl style rollerball with gold titanium nitride trim and fittings. The barrels are turned from an unknown wood. The screw-on cap keeps the ink from drying out between writing sessions.",
    price: 90,
    priceType: "fixed",
    status: "available",
    materials: ["Hardwood (unidentified)"],
    finishes: ["Gold titanium nitride trim"],
    customizable: true,
    featured: false,
    images: [img(dkrb5Img, "Diamond knurl rollerball turned from hardwood with gold titanium trim", 360, 271)],
    tags: ["rollerball", "wood", "pens"],
    occasions: ["Graduation", "Retirement", "Anniversary"],
    relatedProducts: ["p61", "p62"],
    seoTitle: "Diamond Knurl Rollerball in Hardwood | Paul's Pens n Things",
    seoDescription: "A diamond knurl style rollerball with gold titanium nitride trim and fittings. Handcrafted in Paragould, Arkansas.",
  },
  {
    id: "p61",
    slug: "agr1-amazing-grace-rollerball",
    name: "Amazing Grace Rollerball in Bethlehem Olive Wood",
    internalCode: "AGR1",
    category: "pens",
    subcategory: "Fountain & Rollerball",
    shortDescription: "An amazing grace style rollerball with gunmetal trim and fittings, turned from Bethlehem olive wood.",
    fullDescription: "An amazing grace style rollerball with gunmetal trim and fittings, turned from Bethlehem olive wood. The clip is shaped like a cross with a dove resting on it. The screw-on cap keeps the ink from drying out between writing sessions. This pen has sold; Paul can make something similar in your own materials.",
    price: 80,
    priceType: "fixed",
    status: "previously-created",
    materials: ["Bethlehem olive wood"],
    finishes: ["Gunmetal trim", "Cross and dove clip"],
    customizable: true,
    featured: false,
    images: [img(agr1Img, "Amazing Grace rollerball in Bethlehem olive wood with cross and dove clip", 360, 271)],
    tags: ["rollerball", "wood", "specialty", "pens"],
    occasions: ["Graduation", "Retirement", "Anniversary"],
    relatedProducts: ["p62", "p63"],
    seoTitle: "Amazing Grace Rollerball in Bethlehem Olive Wood | Paul's Pens n Things",
    seoDescription: "An amazing grace style rollerball with gunmetal trim and fittings, turned from Bethlehem olive wood. Handcrafted in Paragould, Arkansas.",
  },
  {
    id: "p62",
    slug: "agr2-amazing-grace-rollerball",
    name: "Amazing Grace Rollerball in Bethlehem Olive Wood II",
    internalCode: "AGR2",
    category: "pens",
    subcategory: "Fountain & Rollerball",
    shortDescription: "An amazing grace style rollerball with gunmetal trim and fittings, turned from Bethlehem olive wood.",
    fullDescription: "An amazing grace style rollerball with gunmetal trim and fittings, turned from Bethlehem olive wood. The clip is shaped like a cross with a dove resting on it. The screw-on cap keeps the ink from drying out between writing sessions. This pen has sold; Paul can make something similar in your own materials.",
    price: 80,
    priceType: "fixed",
    status: "previously-created",
    materials: ["Bethlehem olive wood"],
    finishes: ["Gunmetal trim", "Cross and dove clip"],
    customizable: true,
    featured: false,
    images: [img(agr2Img, "Amazing Grace rollerball in Bethlehem olive wood with gunmetal trim", 360, 271)],
    tags: ["rollerball", "wood", "specialty", "pens"],
    occasions: ["Graduation", "Retirement", "Anniversary"],
    relatedProducts: ["p63", "p64"],
    seoTitle: "Amazing Grace Rollerball in Bethlehem Olive Wood II | Paul's Pens n Things",
    seoDescription: "An amazing grace style rollerball with gunmetal trim and fittings, turned from Bethlehem olive wood. Handcrafted in Paragould, Arkansas.",
  },
  {
    id: "p63",
    slug: "agr3-amazing-grace-rollerball",
    name: "Amazing Grace Rollerball in Bethlehem Olive Wood III",
    internalCode: "AGR3",
    category: "pens",
    subcategory: "Fountain & Rollerball",
    shortDescription: "An amazing grace style rollerball with gunmetal trim and fittings, turned from Bethlehem olive wood.",
    fullDescription: "An amazing grace style rollerball with gunmetal trim and fittings, turned from Bethlehem olive wood. The clip is shaped like a cross with a dove resting on it. The screw-on cap keeps the ink from drying out between writing sessions.",
    price: 80,
    priceType: "fixed",
    status: "available",
    materials: ["Bethlehem olive wood"],
    finishes: ["Gunmetal trim", "Cross and dove clip"],
    customizable: true,
    featured: false,
    images: [img(agr3Img, "Amazing Grace rollerball turned from Bethlehem olive wood", 360, 271)],
    tags: ["rollerball", "wood", "specialty", "pens"],
    occasions: ["Graduation", "Retirement", "Anniversary"],
    relatedProducts: ["p64", "p29"],
    seoTitle: "Amazing Grace Rollerball in Bethlehem Olive Wood III | Paul's Pens n Things",
    seoDescription: "An amazing grace style rollerball with gunmetal trim and fittings, turned from Bethlehem olive wood. Handcrafted in Paragould, Arkansas.",
  },
  {
    id: "p64",
    slug: "agr4-amazing-grace-rollerball",
    name: "Amazing Grace Rollerball in Bethlehem Olive Wood IV",
    internalCode: "AGR4",
    category: "pens",
    subcategory: "Fountain & Rollerball",
    shortDescription: "An amazing grace style rollerball with gunmetal trim and fittings, turned from Bethlehem olive wood.",
    fullDescription: "An amazing grace style rollerball with gunmetal trim and fittings, turned from Bethlehem olive wood. The clip is shaped like a cross with a dove resting on it. The screw-on cap keeps the ink from drying out between writing sessions.",
    price: 80,
    priceType: "fixed",
    status: "available",
    materials: ["Bethlehem olive wood"],
    finishes: ["Gunmetal trim", "Cross and dove clip"],
    customizable: true,
    featured: false,
    images: [img(agr4Img, "Amazing Grace rollerball in Bethlehem olive wood with dove clip", 360, 271)],
    tags: ["rollerball", "wood", "specialty", "pens"],
    occasions: ["Graduation", "Retirement", "Anniversary"],
    relatedProducts: ["p29", "p30"],
    seoTitle: "Amazing Grace Rollerball in Bethlehem Olive Wood IV | Paul's Pens n Things",
    seoDescription: "An amazing grace style rollerball with gunmetal trim and fittings, turned from Bethlehem olive wood. Handcrafted in Paragould, Arkansas.",
  },
  {
    id: "p65",
    featured: true,
    slug: "bap-ap-bolt-action-cartridge-pen",
    name: "Bolt-Action Cartridge Pen in Camo Resin",
    internalCode: "BAP-AP",
    category: "pens",
    subcategory: "Bolt-Action",
    shortDescription: "A bolt-action cartridge pen with a replica .30 caliber rifle cartridge and a camo resin barrel.",
    fullDescription: "This pen is made with a replica of a 30 caliber rifle cartridge and a camo resin barrel. The finish is antique pewter. The bolt-action mechanism advances and retracts the ink refill, and the pen case is shaped like a gun case.",
    price: 65,
    priceType: "fixed",
    status: "previously-created",
    materials: ["Camo resin", "Replica .30 caliber cartridge"],
    finishes: ["Antique pewter"],
    customizable: true,
    images: [img(bapApImg, "Bolt-action cartridge pen with camo resin barrel and antique pewter finish", 360, 271)],
    tags: ["bolt-action", "rifle cartridge", "resin", "pens"],
    occasions: ["Recognition", "Retirement", "Holiday"],
    relatedProducts: ["p66", "p67", "p68"],
    seoTitle: "Bolt-Action Cartridge Pen in Camo Resin | Paul's Pens n Things",
    seoDescription: "A bolt-action cartridge pen with a replica .30 caliber rifle cartridge and a camo resin barrel. Handcrafted in Paragould, Arkansas.",
  },
  {
    id: "p66",
    slug: "basa-ac-bolt-action-salute-america-pen",
    name: "Bolt-Action Salute America Pen in Antique Copper",
    internalCode: "BASA-AC",
    category: "pens",
    subcategory: "Bolt-Action",
    shortDescription: "A Salute America bolt-action pen finished in antique copper with a flag clip and saluting soldier tip.",
    fullDescription: "This pen is made with a salute America theme. The clip is a flag, \"salute the troops\" is engraved on the cap, and there is a saluting soldier on the tip. It is finished in antique copper. The bolt-action mechanism advances and retracts the ink refill.",
    price: 115,
    priceType: "fixed",
    status: "available",
    materials: ["Turned barrel"],
    finishes: ["Antique copper", "Flag clip", "Engraved cap"],
    customizable: true,
    featured: false,
    images: [img(basaAcImg, "Salute America bolt-action pen finished in antique copper with a flag clip", 360, 271)],
    tags: ["bolt-action", "military", "patriotic", "pens"],
    occasions: ["Recognition", "Retirement", "Veterans Day"],
    relatedProducts: ["p67", "p68", "p69"],
    seoTitle: "Bolt-Action Salute America Pen in Antique Copper | Paul's Pens n Things",
    seoDescription: "A Salute America bolt-action pen finished in antique copper with a flag clip and saluting soldier tip. Handcrafted in Paragould, Arkansas.",
  },
  {
    id: "p67",
    slug: "basa-ab-bolt-action-salute-america-pen",
    name: "Bolt-Action Salute America Pen in Antique Brass",
    internalCode: "BASA-AB",
    category: "pens",
    subcategory: "Bolt-Action",
    shortDescription: "A Salute America bolt-action pen finished in antique brass with a flag clip and saluting soldier tip.",
    fullDescription: "This pen is made with a salute America theme. The clip is a flag, \"salute the troops\" is engraved on the cap, and there is a saluting soldier on the tip. It is finished in antique brass. The bolt-action mechanism advances and retracts the ink refill.",
    price: 115,
    priceType: "fixed",
    status: "available",
    materials: ["Turned barrel"],
    finishes: ["Antique brass", "Flag clip", "Engraved cap"],
    customizable: true,
    featured: false,
    images: [img(basaAbImg, "Salute America bolt-action pen finished in antique brass with a flag clip", 360, 271)],
    tags: ["bolt-action", "military", "patriotic", "pens"],
    occasions: ["Recognition", "Retirement", "Veterans Day"],
    relatedProducts: ["p66", "p68", "p69"],
    seoTitle: "Bolt-Action Salute America Pen in Antique Brass | Paul's Pens n Things",
    seoDescription: "A Salute America bolt-action pen finished in antique brass with a flag clip and saluting soldier tip. Handcrafted in Paragould, Arkansas.",
  },
  {
    id: "p68",
    slug: "basa-ap-bolt-action-salute-america-pen",
    name: "Bolt-Action Salute America Pen in Antique Pewter",
    internalCode: "BASA-AP",
    category: "pens",
    subcategory: "Bolt-Action",
    shortDescription: "A Salute America bolt-action pen finished in antique pewter with a flag clip and saluting soldier tip.",
    fullDescription: "This pen is made with a salute America theme. The clip is a flag, \"salute the troops\" is engraved on the cap, and there is a saluting soldier on the tip. It is finished in antique pewter. The bolt-action mechanism advances and retracts the ink refill.",
    price: 115,
    priceType: "fixed",
    status: "available",
    materials: ["Turned barrel"],
    finishes: ["Antique pewter", "Flag clip", "Engraved cap"],
    customizable: true,
    featured: false,
    images: [img(basaApImg, "Salute America bolt-action pen finished in antique pewter with a flag clip", 360, 271)],
    tags: ["bolt-action", "military", "patriotic", "pens"],
    occasions: ["Recognition", "Retirement", "Veterans Day"],
    relatedProducts: ["p66", "p67", "p69"],
    seoTitle: "Bolt-Action Salute America Pen in Antique Pewter | Paul's Pens n Things",
    seoDescription: "A Salute America bolt-action pen finished in antique pewter with a flag clip and saluting soldier tip. Handcrafted in Paragould, Arkansas.",
  },
  {
    id: "p69",
    slug: "bast-ac-bolt-action-statue-of-liberty-pen",
    name: "Bolt-Action Statue of Liberty Pen in Antique Copper",
    internalCode: "BAST-AC",
    category: "pens",
    subcategory: "Bolt-Action",
    shortDescription: "A Statue of Liberty bolt-action pen in antique copper with a flag clip and engraved cap.",
    fullDescription: "This pen is made with a Statue of Liberty theme. The clip is a flag, \"God bless America\" is engraved on the cap, and there is a Statue of Liberty on the tip. It is finished in antique copper. The bolt-action mechanism advances and retracts the ink refill.",
    price: 115,
    priceType: "fixed",
    status: "previously-created",
    materials: ["Turned barrel"],
    finishes: ["Antique copper", "Flag clip", "Engraved cap"],
    customizable: true,
    featured: false,
    images: [img(bastAcImg, "Statue of Liberty bolt-action pen finished in antique copper", 360, 271)],
    tags: ["bolt-action", "patriotic", "specialty", "pens"],
    occasions: ["Recognition", "Holiday", "Just because"],
    relatedProducts: ["p66", "p67", "p68"],
    seoTitle: "Bolt-Action Statue of Liberty Pen in Antique Copper | Paul's Pens n Things",
    seoDescription: "A Statue of Liberty bolt-action pen in antique copper with a flag clip and engraved cap. Handcrafted in Paragould, Arkansas.",
  },
  {
    id: "p70",
    slug: "rifle-cartridge-pen-308-redwood-gold",
    name: ".308 Rifle Cartridge Pen in Redwood with 24kt Gold",
    internalCode: "308G-RED",
    category: "pens",
    subcategory: "Rifle Cartridge",
    shortDescription: "A .308 rifle cartridge pen in redwood with a 24kt gold clip and cap.",
    fullDescription: "This pen is made with a .308 rifle cartridge and redwood finished with CA. The clip and cap are finished in 24kt gold. The cartridge is a once-fired case paired with a military bullet, polished and powder-coated to prevent tarnishing, and the clip is shaped like a rifle.",
    price: 50,
    priceType: "fixed",
    status: "previously-created",
    materials: [".308 once-fired cartridge case", "Redwood"],
    finishes: ["24kt Gold", "CA finish"],
    customizable: true,
    featured: false,
    images: [img(rc308gRedImg, ".308 rifle cartridge pen in redwood with a 24kt gold clip and cap", 360, 271)],
    tags: ["rifle cartridge", "308", "outdoors", "pens"],
    occasions: ["Recognition", "Retirement", "Holiday"],
    relatedProducts: ["p71", "p72", "p73"],
    seoTitle: ".308 Rifle Cartridge Pen in Redwood with 24kt Gold | Paul's Pens n Things",
    seoDescription: "A .308 rifle cartridge pen in redwood with a 24kt gold clip and cap. Handcrafted in Paragould, Arkansas.",
  },
  {
    id: "p71",
    slug: "rifle-cartridge-pen-308-redwood-chrome",
    name: ".308 Rifle Cartridge Pen in Redwood with Chrome",
    internalCode: "308CHR-RED",
    category: "pens",
    subcategory: "Rifle Cartridge",
    shortDescription: "A .308 rifle cartridge pen in redwood with a chrome clip and cap.",
    fullDescription: "This pen is made with a .308 rifle cartridge and redwood finished with CA. The clip and cap are finished in chrome. The cartridge is a once-fired case paired with a military bullet, polished and powder-coated to prevent tarnishing, and the clip is shaped like a rifle.",
    price: 50,
    priceType: "fixed",
    status: "previously-created",
    materials: [".308 once-fired cartridge case", "Redwood"],
    finishes: ["Chrome", "CA finish"],
    customizable: true,
    featured: false,
    images: [img(rc308chrRedImg, ".308 rifle cartridge pen in redwood with a chrome clip and cap", 360, 271)],
    tags: ["rifle cartridge", "308", "outdoors", "pens"],
    occasions: ["Recognition", "Retirement", "Holiday"],
    relatedProducts: ["p72", "p73", "p74"],
    seoTitle: ".308 Rifle Cartridge Pen in Redwood with Chrome | Paul's Pens n Things",
    seoDescription: "A .308 rifle cartridge pen in redwood with a chrome clip and cap. Handcrafted in Paragould, Arkansas.",
  },
  {
    id: "p72",
    slug: "rifle-cartridge-pen-308-redwood-gun-metal",
    name: ".308 Rifle Cartridge Pen in Redwood with Gun Metal",
    internalCode: "308GUN-RED",
    category: "pens",
    subcategory: "Rifle Cartridge",
    shortDescription: "A .308 rifle cartridge pen in redwood with a gun metal clip and cap.",
    fullDescription: "This pen is made with a .308 rifle cartridge and redwood finished with CA. The clip and cap are finished in gun metal. The cartridge is a once-fired case paired with a military bullet, polished and powder-coated to prevent tarnishing, and the clip is shaped like a rifle.",
    price: 50,
    priceType: "fixed",
    status: "previously-created",
    materials: [".308 once-fired cartridge case", "Redwood"],
    finishes: ["Gun Metal", "CA finish"],
    customizable: true,
    featured: false,
    images: [img(rc308gunRedImg, ".308 rifle cartridge pen in redwood with a gun metal clip and cap", 360, 271)],
    tags: ["rifle cartridge", "308", "outdoors", "pens"],
    occasions: ["Recognition", "Retirement", "Holiday"],
    relatedProducts: ["p73", "p74", "p75"],
    seoTitle: ".308 Rifle Cartridge Pen in Redwood with Gun Metal | Paul's Pens n Things",
    seoDescription: "A .308 rifle cartridge pen in redwood with a gun metal clip and cap. Handcrafted in Paragould, Arkansas.",
  },
  {
    id: "p73",
    slug: "rifle-cartridge-pen-308-pad-gold",
    name: ".308 Rifle Cartridge Pen in Padauk with 24kt Gold",
    internalCode: "308G-PAD",
    category: "pens",
    subcategory: "Rifle Cartridge",
    shortDescription: "A .308 rifle cartridge pen in padauk with a 24kt gold clip and cap.",
    fullDescription: "This pen is made with a .308 rifle cartridge and padauk finished with CA. The clip and cap are finished in 24kt gold. The cartridge is a once-fired case paired with a military bullet, polished and powder-coated to prevent tarnishing, and the clip is shaped like a rifle.",
    price: 50,
    priceType: "fixed",
    status: "available",
    materials: [".308 once-fired cartridge case", "Padauk"],
    finishes: ["24kt Gold", "CA finish"],
    customizable: true,
    featured: false,
    images: [img(rc308gPadImg, ".308 rifle cartridge pen in padauk with a 24kt gold clip and cap", 360, 271)],
    tags: ["rifle cartridge", "308", "outdoors", "pens"],
    occasions: ["Recognition", "Retirement", "Holiday"],
    relatedProducts: ["p74", "p75", "p76"],
    seoTitle: ".308 Rifle Cartridge Pen in Padauk with 24kt Gold | Paul's Pens n Things",
    seoDescription: "A .308 rifle cartridge pen in padauk with a 24kt gold clip and cap. Handcrafted in Paragould, Arkansas.",
  },
  {
    id: "p74",
    slug: "rifle-cartridge-pen-308-pad-chrome",
    name: ".308 Rifle Cartridge Pen in Padauk with Chrome",
    internalCode: "308CHR-PAD",
    category: "pens",
    subcategory: "Rifle Cartridge",
    shortDescription: "A .308 rifle cartridge pen in padauk with a chrome clip and cap.",
    fullDescription: "This pen is made with a .308 rifle cartridge and padauk finished with CA. The clip and cap are finished in chrome. The cartridge is a once-fired case paired with a military bullet, polished and powder-coated to prevent tarnishing, and the clip is shaped like a rifle.",
    price: 50,
    priceType: "fixed",
    status: "previously-created",
    materials: [".308 once-fired cartridge case", "Padauk"],
    finishes: ["Chrome", "CA finish"],
    customizable: true,
    featured: false,
    images: [img(rc308chrPadImg, ".308 rifle cartridge pen in padauk with a chrome clip and cap", 360, 271)],
    tags: ["rifle cartridge", "308", "outdoors", "pens"],
    occasions: ["Recognition", "Retirement", "Holiday"],
    relatedProducts: ["p75", "p76", "p77"],
    seoTitle: ".308 Rifle Cartridge Pen in Padauk with Chrome | Paul's Pens n Things",
    seoDescription: "A .308 rifle cartridge pen in padauk with a chrome clip and cap. Handcrafted in Paragould, Arkansas.",
  },
  {
    id: "p75",
    slug: "rifle-cartridge-pen-308-pad-gun-metal",
    name: ".308 Rifle Cartridge Pen in Padauk with Gun Metal",
    internalCode: "308GUN-PAD",
    category: "pens",
    subcategory: "Rifle Cartridge",
    shortDescription: "A .308 rifle cartridge pen in padauk with a gun metal clip and cap.",
    fullDescription: "This pen is made with a .308 rifle cartridge and padauk finished with CA. The clip and cap are finished in gun metal. The cartridge is a once-fired case paired with a military bullet, polished and powder-coated to prevent tarnishing, and the clip is shaped like a rifle.",
    price: 50,
    priceType: "fixed",
    status: "previously-created",
    materials: [".308 once-fired cartridge case", "Padauk"],
    finishes: ["Gun Metal", "CA finish"],
    customizable: true,
    featured: false,
    images: [img(rc308gunPadImg, ".308 rifle cartridge pen in padauk with a gun metal clip and cap", 360, 271)],
    tags: ["rifle cartridge", "308", "outdoors", "pens"],
    occasions: ["Recognition", "Retirement", "Holiday"],
    relatedProducts: ["p76", "p77", "p78"],
    seoTitle: ".308 Rifle Cartridge Pen in Padauk with Gun Metal | Paul's Pens n Things",
    seoDescription: "A .308 rifle cartridge pen in padauk with a gun metal clip and cap. Handcrafted in Paragould, Arkansas.",
  },
  {
    id: "p76",
    slug: "rifle-cartridge-pen-308-ced-gold",
    name: ".308 Rifle Cartridge Pen in Cedar with 24kt Gold",
    internalCode: "308G-CED",
    category: "pens",
    subcategory: "Rifle Cartridge",
    shortDescription: "A .308 rifle cartridge pen in cedar with a 24kt gold clip and cap.",
    fullDescription: "This pen is made with a .308 rifle cartridge and cedar finished with CA. The clip and cap are finished in 24kt gold. The cartridge is a once-fired case paired with a military bullet, polished and powder-coated to prevent tarnishing, and the clip is shaped like a rifle.",
    price: 50,
    priceType: "fixed",
    status: "previously-created",
    materials: [".308 once-fired cartridge case", "Cedar"],
    finishes: ["24kt Gold", "CA finish"],
    customizable: true,
    featured: false,
    images: [img(rc308gCedImg, ".308 rifle cartridge pen in cedar with a 24kt gold clip and cap", 360, 271)],
    tags: ["rifle cartridge", "308", "outdoors", "pens"],
    occasions: ["Recognition", "Retirement", "Holiday"],
    relatedProducts: ["p77", "p78", "p79"],
    seoTitle: ".308 Rifle Cartridge Pen in Cedar with 24kt Gold | Paul's Pens n Things",
    seoDescription: "A .308 rifle cartridge pen in cedar with a 24kt gold clip and cap. Handcrafted in Paragould, Arkansas.",
  },
  {
    id: "p77",
    slug: "rifle-cartridge-pen-308-ced-chrome",
    name: ".308 Rifle Cartridge Pen in Cedar with Chrome",
    internalCode: "308CHR-CED",
    category: "pens",
    subcategory: "Rifle Cartridge",
    shortDescription: "A .308 rifle cartridge pen in cedar with a chrome clip and cap.",
    fullDescription: "This pen is made with a .308 rifle cartridge and cedar finished with CA. The clip and cap are finished in chrome. The cartridge is a once-fired case paired with a military bullet, polished and powder-coated to prevent tarnishing, and the clip is shaped like a rifle.",
    price: 50,
    priceType: "fixed",
    status: "available",
    materials: [".308 once-fired cartridge case", "Cedar"],
    finishes: ["Chrome", "CA finish"],
    customizable: true,
    featured: false,
    images: [img(rc308chrCedImg, ".308 rifle cartridge pen in cedar with a chrome clip and cap", 360, 271)],
    tags: ["rifle cartridge", "308", "outdoors", "pens"],
    occasions: ["Recognition", "Retirement", "Holiday"],
    relatedProducts: ["p78", "p79", "p80"],
    seoTitle: ".308 Rifle Cartridge Pen in Cedar with Chrome | Paul's Pens n Things",
    seoDescription: "A .308 rifle cartridge pen in cedar with a chrome clip and cap. Handcrafted in Paragould, Arkansas.",
  },
  {
    id: "p78",
    slug: "rifle-cartridge-pen-308-ced-gun-metal",
    name: ".308 Rifle Cartridge Pen in Cedar with Gun Metal",
    internalCode: "308GUN-CED",
    category: "pens",
    subcategory: "Rifle Cartridge",
    shortDescription: "A .308 rifle cartridge pen in cedar with a gun metal clip and cap.",
    fullDescription: "This pen is made with a .308 rifle cartridge and cedar finished with CA. The clip and cap are finished in gun metal. The cartridge is a once-fired case paired with a military bullet, polished and powder-coated to prevent tarnishing, and the clip is shaped like a rifle.",
    price: 50,
    priceType: "fixed",
    status: "available",
    materials: [".308 once-fired cartridge case", "Cedar"],
    finishes: ["Gun Metal", "CA finish"],
    customizable: true,
    featured: false,
    images: [img(rc308gunCedImg, ".308 rifle cartridge pen in cedar with a gun metal clip and cap", 360, 271)],
    tags: ["rifle cartridge", "308", "outdoors", "pens"],
    occasions: ["Recognition", "Retirement", "Holiday"],
    relatedProducts: ["p79", "p80", "p81"],
    seoTitle: ".308 Rifle Cartridge Pen in Cedar with Gun Metal | Paul's Pens n Things",
    seoDescription: "A .308 rifle cartridge pen in cedar with a gun metal clip and cap. Handcrafted in Paragould, Arkansas.",
  },
  {
    id: "p79",
    slug: "rifle-cartridge-pen-308-map-gold",
    name: ".308 Rifle Cartridge Pen in Maple with 24kt Gold",
    internalCode: "308G-MAP",
    category: "pens",
    subcategory: "Rifle Cartridge",
    shortDescription: "A .308 rifle cartridge pen in maple with a 24kt gold clip and cap.",
    fullDescription: "This pen is made with a .308 rifle cartridge and maple finished with CA. The clip and cap are finished in 24kt gold. The cartridge is a once-fired case paired with a military bullet, polished and powder-coated to prevent tarnishing, and the clip is shaped like a rifle.",
    price: 50,
    priceType: "fixed",
    status: "previously-created",
    materials: [".308 once-fired cartridge case", "Maple"],
    finishes: ["24kt Gold", "CA finish"],
    customizable: true,
    featured: false,
    images: [img(rc308gMapImg, ".308 rifle cartridge pen in maple with a 24kt gold clip and cap", 360, 271)],
    tags: ["rifle cartridge", "308", "outdoors", "pens"],
    occasions: ["Recognition", "Retirement", "Holiday"],
    relatedProducts: ["p80", "p81", "p82"],
    seoTitle: ".308 Rifle Cartridge Pen in Maple with 24kt Gold | Paul's Pens n Things",
    seoDescription: "A .308 rifle cartridge pen in maple with a 24kt gold clip and cap. Handcrafted in Paragould, Arkansas.",
  },
  {
    id: "p80",
    slug: "rifle-cartridge-pen-308-map-chrome",
    name: ".308 Rifle Cartridge Pen in Maple with Chrome",
    internalCode: "308CHR-MAP",
    category: "pens",
    subcategory: "Rifle Cartridge",
    shortDescription: "A .308 rifle cartridge pen in maple with a chrome clip and cap.",
    fullDescription: "This pen is made with a .308 rifle cartridge and maple finished with CA. The clip and cap are finished in chrome. The cartridge is a once-fired case paired with a military bullet, polished and powder-coated to prevent tarnishing, and the clip is shaped like a rifle.",
    price: 50,
    priceType: "fixed",
    status: "previously-created",
    materials: [".308 once-fired cartridge case", "Maple"],
    finishes: ["Chrome", "CA finish"],
    customizable: true,
    featured: false,
    images: [img(rc308chrMapImg, ".308 rifle cartridge pen in maple with a chrome clip and cap", 360, 271)],
    tags: ["rifle cartridge", "308", "outdoors", "pens"],
    occasions: ["Recognition", "Retirement", "Holiday"],
    relatedProducts: ["p81", "p82", "p83"],
    seoTitle: ".308 Rifle Cartridge Pen in Maple with Chrome | Paul's Pens n Things",
    seoDescription: "A .308 rifle cartridge pen in maple with a chrome clip and cap. Handcrafted in Paragould, Arkansas.",
  },
  {
    id: "p81",
    slug: "rifle-cartridge-pen-308-map-gun-metal",
    name: ".308 Rifle Cartridge Pen in Maple with Gun Metal",
    internalCode: "308GUN-MAP",
    category: "pens",
    subcategory: "Rifle Cartridge",
    shortDescription: "A .308 rifle cartridge pen in maple with a gun metal clip and cap.",
    fullDescription: "This pen is made with a .308 rifle cartridge and maple finished with CA. The clip and cap are finished in gun metal. The cartridge is a once-fired case paired with a military bullet, polished and powder-coated to prevent tarnishing, and the clip is shaped like a rifle.",
    price: 50,
    priceType: "fixed",
    status: "previously-created",
    materials: [".308 once-fired cartridge case", "Maple"],
    finishes: ["Gun Metal", "CA finish"],
    customizable: true,
    featured: false,
    images: [img(rc308gunMapImg, ".308 rifle cartridge pen in maple with a gun metal clip and cap", 360, 271)],
    tags: ["rifle cartridge", "308", "outdoors", "pens"],
    occasions: ["Recognition", "Retirement", "Holiday"],
    relatedProducts: ["p82", "p83", "p84"],
    seoTitle: ".308 Rifle Cartridge Pen in Maple with Gun Metal | Paul's Pens n Things",
    seoDescription: "A .308 rifle cartridge pen in maple with a gun metal clip and cap. Handcrafted in Paragould, Arkansas.",
  },
  {
    id: "p82",
    slug: "rifle-cartridge-pen-308-afz-gold",
    name: ".308 Rifle Cartridge Pen in Afzelia with 24kt Gold",
    internalCode: "308G-AFZ",
    category: "pens",
    subcategory: "Rifle Cartridge",
    shortDescription: "A .308 rifle cartridge pen in afzelia with a 24kt gold clip and cap.",
    fullDescription: "This pen is made with a .308 rifle cartridge and afzelia finished with CA. The clip and cap are finished in 24kt gold. The cartridge is a once-fired case paired with a military bullet, polished and powder-coated to prevent tarnishing, and the clip is shaped like a rifle.",
    price: 50,
    priceType: "fixed",
    status: "previously-created",
    materials: [".308 once-fired cartridge case", "Afzelia"],
    finishes: ["24kt Gold", "CA finish"],
    customizable: true,
    featured: false,
    images: [img(rc308gAfzImg, ".308 rifle cartridge pen in afzelia with a 24kt gold clip and cap", 360, 271)],
    tags: ["rifle cartridge", "308", "outdoors", "pens"],
    occasions: ["Recognition", "Retirement", "Holiday"],
    relatedProducts: ["p83", "p84", "p85"],
    seoTitle: ".308 Rifle Cartridge Pen in Afzelia with 24kt Gold | Paul's Pens n Things",
    seoDescription: "A .308 rifle cartridge pen in afzelia with a 24kt gold clip and cap. Handcrafted in Paragould, Arkansas.",
  },
  {
    id: "p83",
    slug: "rifle-cartridge-pen-308-afz-chrome",
    name: ".308 Rifle Cartridge Pen in Afzelia with Chrome",
    internalCode: "308CHR-AFZ",
    category: "pens",
    subcategory: "Rifle Cartridge",
    shortDescription: "A .308 rifle cartridge pen in afzelia with a chrome clip and cap.",
    fullDescription: "This pen is made with a .308 rifle cartridge and afzelia finished with CA. The clip and cap are finished in chrome. The cartridge is a once-fired case paired with a military bullet, polished and powder-coated to prevent tarnishing, and the clip is shaped like a rifle.",
    price: 50,
    priceType: "fixed",
    status: "available",
    materials: [".308 once-fired cartridge case", "Afzelia"],
    finishes: ["Chrome", "CA finish"],
    customizable: true,
    featured: false,
    images: [img(rc308chrAfzImg, ".308 rifle cartridge pen in afzelia with a chrome clip and cap", 360, 271)],
    tags: ["rifle cartridge", "308", "outdoors", "pens"],
    occasions: ["Recognition", "Retirement", "Holiday"],
    relatedProducts: ["p84", "p85", "p86"],
    seoTitle: ".308 Rifle Cartridge Pen in Afzelia with Chrome | Paul's Pens n Things",
    seoDescription: "A .308 rifle cartridge pen in afzelia with a chrome clip and cap. Handcrafted in Paragould, Arkansas.",
  },
  {
    id: "p84",
    slug: "rifle-cartridge-pen-308-afz-gun-metal",
    name: ".308 Rifle Cartridge Pen in Afzelia with Gun Metal",
    internalCode: "308GUN-AFZ",
    category: "pens",
    subcategory: "Rifle Cartridge",
    shortDescription: "A .308 rifle cartridge pen in afzelia with a gun metal clip and cap.",
    fullDescription: "This pen is made with a .308 rifle cartridge and afzelia finished with CA. The clip and cap are finished in gun metal. The cartridge is a once-fired case paired with a military bullet, polished and powder-coated to prevent tarnishing, and the clip is shaped like a rifle.",
    price: 50,
    priceType: "fixed",
    status: "previously-created",
    materials: [".308 once-fired cartridge case", "Afzelia"],
    finishes: ["Gun Metal", "CA finish"],
    customizable: true,
    featured: false,
    images: [img(rc308gunAfzImg, ".308 rifle cartridge pen in afzelia with a gun metal clip and cap", 360, 271)],
    tags: ["rifle cartridge", "308", "outdoors", "pens"],
    occasions: ["Recognition", "Retirement", "Holiday"],
    relatedProducts: ["p85", "p86", "p87"],
    seoTitle: ".308 Rifle Cartridge Pen in Afzelia with Gun Metal | Paul's Pens n Things",
    seoDescription: "A .308 rifle cartridge pen in afzelia with a gun metal clip and cap. Handcrafted in Paragould, Arkansas.",
  },
  {
    id: "p85",
    slug: "rifle-cartridge-pen-30-06-antler-gold",
    name: "30-06 Rifle Cartridge Pen in Deer Antler with 24kt Gold",
    internalCode: "ANTLER-G",
    category: "pens",
    subcategory: "Rifle Cartridge",
    shortDescription: "A 30-06 cartridge pen turned from deer antler with a deer-head clip in 24kt gold.",
    fullDescription: "This pen is made from a 30-06 rifle cartridge and deer antler that is finished with CA. The clip is in the shape of a deer head. The cap and clip are finished in 24kt gold. The cartridge is a once-fired case paired with a military bullet, polished and powder-coated to prevent tarnishing.",
    price: 65,
    priceType: "fixed",
    status: "available",
    materials: ["30-06 once-fired cartridge case", "Deer antler"],
    finishes: ["24kt Gold", "CA finish"],
    customizable: true,
    featured: false,
    images: [img(rc3006AntlerGImg, "30-06 rifle cartridge pen in deer antler with a deer-head clip finished in 24kt gold", 360, 271)],
    tags: ["rifle cartridge", "30-06", "antler", "hunting", "pens"],
    occasions: ["Recognition", "Retirement", "Holiday"],
    relatedProducts: ["p86", "p87", "p88"],
    seoTitle: "30-06 Rifle Cartridge Pen in Deer Antler with 24kt Gold | Paul's Pens n Things",
    seoDescription: "A 30-06 cartridge pen turned from deer antler with a deer-head clip in 24kt gold. Handcrafted in Paragould, Arkansas.",
  },
  {
    id: "p86",
    slug: "rifle-cartridge-pen-30-06-antler-chrome",
    name: "30-06 Rifle Cartridge Pen in Deer Antler with Chrome",
    internalCode: "ANTLER-CHR",
    category: "pens",
    subcategory: "Rifle Cartridge",
    shortDescription: "A 30-06 cartridge pen turned from deer antler with a deer-head clip in chrome.",
    fullDescription: "This pen is made from a 30-06 rifle cartridge and deer antler that is finished with CA. The clip is in the shape of a deer head. The cap and clip are finished in chrome. The cartridge is a once-fired case paired with a military bullet, polished and powder-coated to prevent tarnishing.",
    price: 65,
    priceType: "fixed",
    status: "available",
    materials: ["30-06 once-fired cartridge case", "Deer antler"],
    finishes: ["Chrome", "CA finish"],
    customizable: true,
    featured: false,
    images: [img(rc3006AntlerChrImg, "30-06 rifle cartridge pen in deer antler with a deer-head clip finished in chrome", 360, 271)],
    tags: ["rifle cartridge", "30-06", "antler", "hunting", "pens"],
    occasions: ["Recognition", "Retirement", "Holiday"],
    relatedProducts: ["p87", "p88", "p89"],
    seoTitle: "30-06 Rifle Cartridge Pen in Deer Antler with Chrome | Paul's Pens n Things",
    seoDescription: "A 30-06 cartridge pen turned from deer antler with a deer-head clip in chrome. Handcrafted in Paragould, Arkansas.",
  },
  {
    id: "p87",
    slug: "rifle-cartridge-pen-30-06-antler-gun-metal",
    name: "30-06 Rifle Cartridge Pen in Deer Antler with Gun Metal",
    internalCode: "ANTLER-GUN",
    category: "pens",
    subcategory: "Rifle Cartridge",
    shortDescription: "A 30-06 cartridge pen turned from deer antler with a deer-head clip in gun metal.",
    fullDescription: "This pen is made from a 30-06 rifle cartridge and deer antler that is finished with CA. The clip is in the shape of a deer head. The cap and clip are finished in gun metal. The cartridge is a once-fired case paired with a military bullet, polished and powder-coated to prevent tarnishing.",
    price: 65,
    priceType: "fixed",
    status: "available",
    materials: ["30-06 once-fired cartridge case", "Deer antler"],
    finishes: ["Gun Metal", "CA finish"],
    customizable: true,
    featured: false,
    images: [img(rc3006AntlerGunImg, "30-06 rifle cartridge pen in deer antler with a deer-head clip finished in gun metal", 360, 271)],
    tags: ["rifle cartridge", "30-06", "antler", "hunting", "pens"],
    occasions: ["Recognition", "Retirement", "Holiday"],
    relatedProducts: ["p88", "p89", "p90"],
    seoTitle: "30-06 Rifle Cartridge Pen in Deer Antler with Gun Metal | Paul's Pens n Things",
    seoDescription: "A 30-06 cartridge pen turned from deer antler with a deer-head clip in gun metal. Handcrafted in Paragould, Arkansas.",
  },
  {
    id: "p88",
    slug: "military-rifle-cartridge-pen-cedar",
    name: "Military Rifle Cartridge Pen in Cedar",
    internalCode: "M60GUN-CED",
    category: "pens",
    subcategory: "Rifle Cartridge",
    shortDescription: "A military rifle cartridge pen in cedar with a gun metal clip and a red, white, and blue Corian flag.",
    fullDescription: "This pen is made with a military rifle cartridge and cedar finished with CA. The clip and cap are finished in gun metal. The once-fired case and military bullet are polished and powder-coated to prevent tarnishing, and the barrel includes a red, white, and blue \"flag\" made of Corian.",
    price: 55,
    priceType: "fixed",
    status: "available",
    materials: ["Military once-fired cartridge case", "Cedar", "Corian flag inlay"],
    finishes: ["Gun Metal", "CA finish"],
    customizable: true,
    featured: false,
    images: [img(rcM60gunCedImg, "Military rifle cartridge pen in cedar with a gun metal clip and Corian flag inlay", 360, 271)],
    tags: ["rifle cartridge", "military", "patriotic", "pens"],
    occasions: ["Recognition", "Retirement", "Holiday"],
    relatedProducts: ["p89", "p90", "p91"],
    seoTitle: "Military Rifle Cartridge Pen in Cedar | Paul's Pens n Things",
    seoDescription: "A military rifle cartridge pen in cedar with a gun metal clip and a red, white, and blue Corian flag. Handcrafted in Paragould, Arkansas.",
  },
  {
    id: "p89",
    slug: "military-rifle-cartridge-pen-gaboon-ebony",
    name: "Military Rifle Cartridge Pen in Gaboon Ebony",
    internalCode: "M60GUN-GE",
    category: "pens",
    subcategory: "Rifle Cartridge",
    shortDescription: "A military rifle cartridge pen in gaboon ebony with a gun metal clip and a red, white, and blue Corian flag.",
    fullDescription: "This pen is made with a military rifle cartridge and gaboon ebony finished with CA. The clip and cap are finished in gun metal. The once-fired case and military bullet are polished and powder-coated to prevent tarnishing, and the barrel includes a red, white, and blue \"flag\" made of Corian.",
    price: 55,
    priceType: "fixed",
    status: "available",
    materials: ["Military once-fired cartridge case", "Gaboon Ebony", "Corian flag inlay"],
    finishes: ["Gun Metal", "CA finish"],
    customizable: true,
    featured: false,
    images: [img(rcM60gunGeImg, "Military rifle cartridge pen in gaboon ebony with a gun metal clip and Corian flag inlay", 360, 271)],
    tags: ["rifle cartridge", "military", "patriotic", "pens"],
    occasions: ["Recognition", "Retirement", "Holiday"],
    relatedProducts: ["p90", "p91", "p92"],
    seoTitle: "Military Rifle Cartridge Pen in Gaboon Ebony | Paul's Pens n Things",
    seoDescription: "A military rifle cartridge pen in gaboon ebony with a gun metal clip and a red, white, and blue Corian flag. Handcrafted in Paragould, Arkansas.",
  },
  {
    id: "p90",
    slug: "military-rifle-cartridge-pen-redwood",
    name: "Military Rifle Cartridge Pen in Redwood",
    internalCode: "M60GUN-RED",
    category: "pens",
    subcategory: "Rifle Cartridge",
    shortDescription: "A military rifle cartridge pen in redwood with a gun metal clip and a red, white, and blue Corian flag.",
    fullDescription: "This pen is made with a military rifle cartridge and redwood finished with CA. The clip and cap are finished in gun metal. The once-fired case and military bullet are polished and powder-coated to prevent tarnishing, and the barrel includes a red, white, and blue \"flag\" made of Corian.",
    price: 55,
    priceType: "fixed",
    status: "available",
    materials: ["Military once-fired cartridge case", "Redwood", "Corian flag inlay"],
    finishes: ["Gun Metal", "CA finish"],
    customizable: true,
    featured: false,
    images: [img(rcM60gunRedImg, "Military rifle cartridge pen in redwood with a gun metal clip and Corian flag inlay", 360, 271)],
    tags: ["rifle cartridge", "military", "patriotic", "pens"],
    occasions: ["Recognition", "Retirement", "Holiday"],
    relatedProducts: ["p91", "p92", "p93"],
    seoTitle: "Military Rifle Cartridge Pen in Redwood | Paul's Pens n Things",
    seoDescription: "A military rifle cartridge pen in redwood with a gun metal clip and a red, white, and blue Corian flag. Handcrafted in Paragould, Arkansas.",
  },
  {
    id: "p91",
    slug: "military-rifle-cartridge-pen-maple",
    name: "Military Rifle Cartridge Pen in Maple",
    internalCode: "M60GUN-MAP",
    category: "pens",
    subcategory: "Rifle Cartridge",
    shortDescription: "A military rifle cartridge pen in maple with a gun metal clip and a red, white, and blue Corian flag.",
    fullDescription: "This pen is made with a military rifle cartridge and maple finished with CA. The clip and cap are finished in gun metal. The once-fired case and military bullet are polished and powder-coated to prevent tarnishing, and the barrel includes a red, white, and blue \"flag\" made of Corian.",
    price: 55,
    priceType: "fixed",
    status: "available",
    materials: ["Military once-fired cartridge case", "Maple", "Corian flag inlay"],
    finishes: ["Gun Metal", "CA finish"],
    customizable: true,
    featured: false,
    images: [img(rcM60gunMapImg, "Military rifle cartridge pen in maple with a gun metal clip and Corian flag inlay", 360, 271)],
    tags: ["rifle cartridge", "military", "patriotic", "pens"],
    occasions: ["Recognition", "Retirement", "Holiday"],
    relatedProducts: ["p92", "p93", "p70"],
    seoTitle: "Military Rifle Cartridge Pen in Maple | Paul's Pens n Things",
    seoDescription: "A military rifle cartridge pen in maple with a gun metal clip and a red, white, and blue Corian flag. Handcrafted in Paragould, Arkansas.",
  },
  {
    id: "p92",
    slug: "military-rifle-cartridge-pen-padauk",
    name: "Military Rifle Cartridge Pen in Padauk",
    internalCode: "M60GUN-PAD",
    category: "pens",
    subcategory: "Rifle Cartridge",
    shortDescription: "A military rifle cartridge pen in padauk with a gun metal clip and a red, white, and blue Corian flag.",
    fullDescription: "This pen is made with a military rifle cartridge and padauk finished with CA. The clip and cap are finished in gun metal. The once-fired case and military bullet are polished and powder-coated to prevent tarnishing, and the barrel includes a red, white, and blue \"flag\" made of Corian.",
    price: 55,
    priceType: "fixed",
    status: "available",
    materials: ["Military once-fired cartridge case", "Padauk", "Corian flag inlay"],
    finishes: ["Gun Metal", "CA finish"],
    customizable: true,
    featured: false,
    images: [img(rcM60gunPadImg, "Military rifle cartridge pen in padauk with a gun metal clip and Corian flag inlay", 360, 271)],
    tags: ["rifle cartridge", "military", "patriotic", "pens"],
    occasions: ["Recognition", "Retirement", "Holiday"],
    relatedProducts: ["p93", "p70", "p71"],
    seoTitle: "Military Rifle Cartridge Pen in Padauk | Paul's Pens n Things",
    seoDescription: "A military rifle cartridge pen in padauk with a gun metal clip and a red, white, and blue Corian flag. Handcrafted in Paragould, Arkansas.",
  },
  {
    id: "p93",
    slug: "military-rifle-cartridge-pen-afzelia",
    name: "Military Rifle Cartridge Pen in Afzelia",
    internalCode: "M60GUN-AFZ",
    category: "pens",
    subcategory: "Rifle Cartridge",
    shortDescription: "A military rifle cartridge pen in afzelia with a gun metal clip and a red, white, and blue Corian flag.",
    fullDescription: "This pen is made with a military rifle cartridge and afzelia finished with CA. The clip and cap are finished in gun metal. The once-fired case and military bullet are polished and powder-coated to prevent tarnishing, and the barrel includes a red, white, and blue \"flag\" made of Corian.",
    price: 55,
    priceType: "fixed",
    status: "available",
    materials: ["Military once-fired cartridge case", "Afzelia", "Corian flag inlay"],
    finishes: ["Gun Metal", "CA finish"],
    customizable: true,
    featured: false,
    images: [img(rcM60gunAfzImg, "Military rifle cartridge pen in afzelia with a gun metal clip and Corian flag inlay", 360, 271)],
    tags: ["rifle cartridge", "military", "patriotic", "pens"],
    occasions: ["Recognition", "Retirement", "Holiday"],
    relatedProducts: ["p70", "p71", "p72"],
    seoTitle: "Military Rifle Cartridge Pen in Afzelia | Paul's Pens n Things",
    seoDescription: "A military rifle cartridge pen in afzelia with a gun metal clip and a red, white, and blue Corian flag. Handcrafted in Paragould, Arkansas.",
  },
  {
    id: "p94",
    slug: "sbp1-rhodium-sierra-coffee-beans",
    name: "Sierra Pen in Rhodium with Coffee Bean Resin",
    internalCode: "SBP1",
    category: "pens",
    subcategory: "Sierra Mesa Gatsby",
    shortDescription: "This pen is finished in rhodium and the barrel is made of coffee beans cast in resin.",
    fullDescription: "These pens are made in the sierra style. This pen is finished in rhodium and the barrel is made of coffee beans cast in resin.",
    price: 65,
    priceType: "fixed",
    status: "available",
    materials: ["Coffee beans cast in resin"],
    finishes: ["Rhodium trim"],
    customizable: true,
    featured: false,
    images: [img(sbp1Img, "Sierra pen finished in rhodium with a barrel of coffee beans cast in resin", 360, 271)],
    tags: ["resin", "sierra", "pens"],
    occasions: ["Graduation", "Holiday", "Just because"],
    relatedProducts: ["p95", "p96", "p97"],
    seoTitle: "Sierra Pen in Rhodium with Coffee Bean Resin | Paul's Pens n Things",
    seoDescription: "This pen is finished in rhodium and the barrel is made of coffee beans cast in resin. Handcrafted in Paragould, Arkansas.",
  },
  {
    id: "p95",
    slug: "sbp2-24kt-gold-sierra-carbon-fiber",
    name: "Sierra Pen in 24kt Gold with Carbon Fiber",
    internalCode: "SBP2",
    category: "pens",
    subcategory: "Sierra Mesa Gatsby",
    shortDescription: "This pen is finished in 24kt gold and the barrel is made of carbon fiber.",
    fullDescription: "These pens are made in the sierra style. This pen is finished in 24kt gold and the barrel is made of carbon fiber.",
    price: 55,
    priceType: "fixed",
    status: "available",
    materials: ["Carbon fiber"],
    finishes: ["24kt gold trim"],
    customizable: true,
    featured: false,
    images: [img(sbp2Img, "Sierra pen finished in 24kt gold with a carbon fiber barrel", 360, 271)],
    tags: ["carbon fiber", "sierra", "pens"],
    occasions: ["Graduation", "Holiday", "Just because"],
    relatedProducts: ["p96", "p277", "p279"],
    seoTitle: "Sierra Pen in 24kt Gold with Carbon Fiber | Paul's Pens n Things",
    seoDescription: "This pen is finished in 24kt gold and the barrel is made of carbon fiber. Handcrafted in Paragould, Arkansas.",
  },
  {
    id: "p96",
    slug: "sbp3-chrome-sierra-carbon-fiber",
    name: "Sierra Pen in Chrome with Carbon Fiber",
    internalCode: "SBP3",
    category: "pens",
    subcategory: "Sierra Mesa Gatsby",
    shortDescription: "This pen is finished in chrome and the barrel is made of carbon fiber.",
    fullDescription: "These pens are made in the sierra style. This pen is finished in chrome and the barrel is made of carbon fiber.",
    price: 65,
    priceType: "fixed",
    status: "available",
    materials: ["Carbon fiber"],
    finishes: ["Chrome trim"],
    customizable: true,
    featured: false,
    images: [img(sbp3Img, "Sierra pen finished in chrome with a carbon fiber barrel", 360, 271)],
    tags: ["carbon fiber", "sierra", "pens"],
    occasions: ["Graduation", "Holiday", "Just because"],
    relatedProducts: ["p97", "p98", "p99"],
    seoTitle: "Sierra Pen in Chrome with Carbon Fiber | Paul's Pens n Things",
    seoDescription: "This pen is finished in chrome and the barrel is made of carbon fiber. Handcrafted in Paragould, Arkansas.",
  },
  {
    id: "p97",
    slug: "sbp4-24kt-gold-sierra-resin",
    name: "Sierra Pen in 24kt Gold with Resin Barrel",
    internalCode: "SBP4",
    category: "pens",
    subcategory: "Sierra Mesa Gatsby",
    shortDescription: "This pen is finished in 24kt gold and the barrel is made of resin.",
    fullDescription: "These pens are made in the sierra style. This pen is finished in 24kt gold and the barrel is made of resin.",
    price: 60,
    priceType: "fixed",
    status: "available",
    materials: ["Cast resin"],
    finishes: ["24kt gold trim"],
    customizable: true,
    featured: false,
    images: [img(sbp4Img, "Sierra pen finished in 24kt gold with a cast resin barrel", 360, 271)],
    tags: ["resin", "sierra", "pens"],
    occasions: ["Graduation", "Holiday", "Just because"],
    relatedProducts: ["p98", "p99", "p100"],
    seoTitle: "Sierra Pen in 24kt Gold with Resin Barrel | Paul's Pens n Things",
    seoDescription: "This pen is finished in 24kt gold and the barrel is made of resin. Handcrafted in Paragould, Arkansas.",
  },
  {
    id: "p98",
    slug: "sbp5-black-titanium-nitride-sierra-resin",
    name: "Sierra Pen in Black Titanium Nitride with Resin Barrel",
    internalCode: "SBP5",
    category: "pens",
    subcategory: "Sierra Mesa Gatsby",
    shortDescription: "This pen is finished in black titanium nitride and the barrel is made of resin.",
    fullDescription: "These pens are made in the sierra style. This pen is finished in black titanium nitride and the barrel is made of resin.",
    price: 60,
    priceType: "fixed",
    status: "available",
    materials: ["Cast resin"],
    finishes: ["Black titanium nitride trim"],
    customizable: true,
    featured: false,
    images: [img(sbp5Img, "Sierra pen finished in black titanium nitride with a cast resin barrel", 360, 271)],
    tags: ["resin", "sierra", "pens"],
    occasions: ["Graduation", "Holiday", "Just because"],
    relatedProducts: ["p99", "p100", "p101"],
    seoTitle: "Sierra Pen in Black Titanium Nitride with Resin Barrel | Paul's Pens n Things",
    seoDescription: "This pen is finished in black titanium nitride and the barrel is made of resin. Handcrafted in Paragould, Arkansas.",
  },
  {
    id: "p99",
    slug: "sbp6-rhodium-sierra-elk-inlay",
    name: "Sierra Pen in Rhodium with Elk Inlay",
    internalCode: "SBP6",
    category: "pens",
    subcategory: "Sierra Mesa Gatsby",
    shortDescription: "This pen is finished in rhodium and the barrel is made of an elk inlay.",
    fullDescription: "These pens are made in the sierra style. This pen is finished in rhodium and the barrel is made of an elk inlay. This pen has sold; Paul can make something similar in your own materials.",
    price: 80,
    priceType: "fixed",
    status: "previously-created",
    materials: ["Elk inlay"],
    finishes: ["Rhodium trim"],
    customizable: true,
    featured: false,
    images: [img(sbp6Img, "Sierra pen finished in rhodium with an elk inlay barrel", 360, 271)],
    tags: ["inlay", "outdoors", "sierra", "pens"],
    occasions: ["Graduation", "Holiday", "Just because"],
    relatedProducts: ["p100", "p101", "p102"],
    seoTitle: "Sierra Pen in Rhodium with Elk Inlay | Paul's Pens n Things",
    seoDescription: "This pen is finished in rhodium and the barrel is made of an elk inlay. Handcrafted in Paragould, Arkansas.",
  },
  {
    id: "p100",
    slug: "sbp7-gold-titanium-nitride-paw-prints",
    name: "Sierra Pen in Gold Titanium Nitride with Paw Print Inlay",
    internalCode: "SBP7",
    category: "pens",
    subcategory: "Sierra Mesa Gatsby",
    shortDescription: "This pen is finished in gold titanium nitride and the barrel is made of an inlay of paw prints.",
    fullDescription: "These pens are made in the sierra style. This pen is finished in gold titanium nitride and the barrel is made of an inlay of paw prints.",
    price: 80,
    priceType: "fixed",
    status: "available",
    materials: ["Paw print inlay"],
    finishes: ["Gold titanium nitride trim"],
    customizable: true,
    featured: false,
    images: [img(sbp7Img, "Sierra pen finished in gold titanium nitride with a paw print inlay barrel", 360, 271)],
    tags: ["inlay", "sierra", "pens"],
    occasions: ["Graduation", "Holiday", "Just because"],
    relatedProducts: ["p101", "p102", "p103"],
    seoTitle: "Sierra Pen in Gold Titanium Nitride with Paw Print Inlay | Paul's Pens n Things",
    seoDescription: "This pen is finished in gold titanium nitride and the barrel is made of an inlay of paw prints. Handcrafted in Paragould, Arkansas.",
  },
  {
    id: "p101",
    slug: "sbp8-rhodium-sierra-herringbone",
    name: "Sierra Pen in Rhodium with Herringbone Barrel",
    internalCode: "SBP8",
    category: "pens",
    subcategory: "Sierra Mesa Gatsby",
    shortDescription: "This pen is finished in rhodium and the barrel is made of herringbone wood.",
    fullDescription: "These pens are made in the sierra style. This pen is finished in rhodium and the barrel is made of herringbone wood.",
    price: 75,
    priceType: "fixed",
    status: "available",
    materials: ["Herringbone wood"],
    finishes: ["Rhodium trim"],
    customizable: true,
    featured: false,
    images: [img(sbp8Img, "Sierra pen finished in rhodium with a herringbone wood barrel", 360, 271)],
    tags: ["wood", "sierra", "pens"],
    occasions: ["Graduation", "Holiday", "Just because"],
    relatedProducts: ["p102", "p103", "p94"],
    seoTitle: "Sierra Pen in Rhodium with Herringbone Barrel | Paul's Pens n Things",
    seoDescription: "This pen is finished in rhodium and the barrel is made of herringbone wood. Handcrafted in Paragould, Arkansas.",
  },
  {
    id: "p102",
    slug: "sbp10-24kt-gold-black-tn-sierra-resin",
    name: "Sierra Pen in 24kt Gold and Black Titanium Nitride with Resin Barrel",
    internalCode: "SBP10",
    category: "pens",
    subcategory: "Sierra Mesa Gatsby",
    shortDescription: "This pen is finished in black titanium nitride and gold and the barrel is made of resin.",
    fullDescription: "These pens are made in the sierra style. This pen is finished in black titanium nitride and gold and the barrel is made of resin.",
    price: 65,
    priceType: "fixed",
    status: "available",
    materials: ["Cast resin"],
    finishes: ["24kt gold trim", "Black titanium nitride trim"],
    customizable: true,
    featured: false,
    images: [img(sbp10Img, "Sierra pen finished in 24kt gold and black titanium nitride with a cast resin barrel", 360, 271)],
    tags: ["resin", "sierra", "pens"],
    occasions: ["Graduation", "Holiday", "Just because"],
    relatedProducts: ["p103", "p94", "p95"],
    seoTitle: "Sierra Pen in 24kt Gold and Black Titanium Nitride with Resin Barrel | Paul's Pens n Things",
    seoDescription: "This pen is finished in black titanium nitride and gold and the barrel is made of resin. Handcrafted in Paragould, Arkansas.",
  },
  {
    id: "p103",
    slug: "sbp11-gold-titanium-nitride-dragon-inlay",
    name: "Sierra Pen in Gold Titanium Nitride with Dragon Inlay",
    internalCode: "SBP11",
    category: "pens",
    subcategory: "Sierra Mesa Gatsby",
    shortDescription: "This pen is finished in gold titanium nitride and the barrel is made of an inlay of a dragon.",
    fullDescription: "These pens are made in the sierra style. This pen is finished in gold titanium nitride and the barrel is made of an inlay of a dragon.",
    price: 80,
    priceType: "fixed",
    status: "available",
    materials: ["Dragon inlay"],
    finishes: ["Gold titanium nitride trim"],
    customizable: true,
    featured: false,
    images: [img(sbp11Img, "Sierra pen finished in gold titanium nitride with a dragon inlay barrel", 360, 271)],
    tags: ["inlay", "sierra", "pens"],
    occasions: ["Graduation", "Holiday", "Just because"],
    relatedProducts: ["p94", "p95", "p96"],
    seoTitle: "Sierra Pen in Gold Titanium Nitride with Dragon Inlay | Paul's Pens n Things",
    seoDescription: "This pen is finished in gold titanium nitride and the barrel is made of an inlay of a dragon. Handcrafted in Paragould, Arkansas.",
  },
  {
    id: "p104",
    slug: "mesa1-24kt-gold-mesa-pen-fordite",
    name: "Mesa Pen in 24kt Gold with Fordite Barrel",
    internalCode: "MESA1",
    category: "pens",
    subcategory: "Sierra Mesa Gatsby",
    shortDescription: "Mesa style pen finished with 24kt gold trim and fittings and having a barrel made with fordite.",
    fullDescription: "These pens are made in the mesa style. Mesa style pen finished with 24kt gold trim and fittings and having a barrel made with fordite.",
    price: 80,
    priceType: "fixed",
    status: "available",
    materials: ["Fordite"],
    finishes: ["24kt gold trim"],
    customizable: true,
    featured: false,
    images: [img(mesa1Img, "Mesa style pen with 24kt gold trim and a fordite barrel", 360, 480)],
    tags: ["mesa", "resin", "pens"],
    occasions: ["Graduation", "Holiday", "Just because"],
    relatedProducts: ["p105", "p106", "p107"],
    seoTitle: "Mesa Pen in 24kt Gold with Fordite Barrel | Paul's Pens n Things",
    seoDescription: "Mesa style pen finished with 24kt gold trim and fittings and having a barrel made with fordite. Handcrafted in Paragould, Arkansas.",
  },
  {
    id: "p105",
    slug: "mesa2-chrome-mesa-pen-braided-stainless-steel",
    name: "Mesa Pen in Chrome with Braided Stainless Steel Barrel",
    internalCode: "MESA2",
    category: "pens",
    subcategory: "Sierra Mesa Gatsby",
    shortDescription: "Mesa style pen finished with chrome trim and fittings and having a barrel made with braided stainless steel embedded in clear resin.",
    fullDescription: "These pens are made in the mesa style. Mesa style pen finished with chrome trim and fittings and having a barrel made with braided stainless steel embedded in clear resin. This pen has sold; Paul can make something similar in your own materials.",
    price: 55,
    priceType: "fixed",
    status: "previously-created",
    materials: ["Braided stainless steel in clear resin"],
    finishes: ["Chrome trim"],
    customizable: true,
    featured: false,
    images: [img(mesa2Img, "Mesa style pen with chrome trim and a braided stainless steel barrel in clear resin", 360, 480)],
    tags: ["mesa", "resin", "pens"],
    occasions: ["Graduation", "Holiday", "Just because"],
    relatedProducts: ["p106", "p107", "p108"],
    seoTitle: "Mesa Pen in Chrome with Braided Stainless Steel Barrel | Paul's Pens n Things",
    seoDescription: "Mesa style pen finished with chrome trim and fittings and having a barrel made with braided stainless steel embedded in clear resin. Handcrafted in Paragould, Arkansas.",
  },
  {
    id: "p106",
    slug: "mesa3-24kt-gold-chrome-mesa-pen-braided-carbon-fiber",
    name: "Mesa Pen in 24kt Gold and Chrome with Braided Carbon Fiber Barrel",
    internalCode: "MESA3",
    category: "pens",
    subcategory: "Sierra Mesa Gatsby",
    shortDescription: "Mesa style pen finished with 24kt gold and chrome trim and fittings and having a barrel made with braided carbon fiber embedded in clear resin.",
    fullDescription: "These pens are made in the mesa style. Mesa style pen finished with 24kt gold and chrome trim and fittings and having a barrel made with braided carbon fiber embedded in clear resin.",
    price: 55,
    priceType: "fixed",
    status: "available",
    materials: ["Braided carbon fiber in clear resin"],
    finishes: ["24kt gold trim", "Chrome trim"],
    customizable: true,
    featured: false,
    images: [img(mesa3Img, "Mesa style pen with 24kt gold and chrome trim and a braided carbon fiber barrel", 360, 480)],
    tags: ["mesa", "resin", "pens"],
    occasions: ["Graduation", "Holiday", "Just because"],
    relatedProducts: ["p107", "p108", "p104"],
    seoTitle: "Mesa Pen in 24kt Gold and Chrome with Braided Carbon Fiber Barrel | Paul's Pens n Things",
    seoDescription: "Mesa style pen finished with 24kt gold and chrome trim and fittings and having a barrel made with braided carbon fiber embedded in clear resin. Handcrafted in Paragould, Arkansas.",
  },
  {
    id: "p107",
    slug: "mesa4-gunmetal-mesa-pen-denim",
    name: "Mesa Pen in Gun Metal with Denim Barrel",
    internalCode: "MESA4",
    category: "pens",
    subcategory: "Sierra Mesa Gatsby",
    shortDescription: "Mesa style pen finished with gun metal trim and fittings and having a barrel made with denim embedded in clear resin.",
    fullDescription: "These pens are made in the mesa style. Mesa style pen finished with gun metal trim and fittings and having a barrel made with denim embedded in clear resin.",
    price: 55,
    priceType: "fixed",
    status: "available",
    materials: ["Denim in clear resin"],
    finishes: ["Gun metal trim"],
    customizable: true,
    featured: false,
    images: [img(mesa4Img, "Mesa style pen with gun metal trim and a denim barrel cast in clear resin", 360, 480)],
    tags: ["mesa", "resin", "pens"],
    occasions: ["Graduation", "Holiday", "Just because"],
    relatedProducts: ["p108", "p104", "p277"],
    seoTitle: "Mesa Pen in Gun Metal with Denim Barrel | Paul's Pens n Things",
    seoDescription: "Mesa style pen finished with gun metal trim and fittings and having a barrel made with denim embedded in clear resin. Handcrafted in Paragould, Arkansas.",
  },
  {
    id: "p277",
    slug: "mcf1-chrome-mesa-pen-carbon-fiber",
    name: "Mesa Pen in Chrome with Carbon Fiber",
    internalCode: "MCF1",
    category: "pens",
    subcategory: "Sierra Mesa Gatsby",
    shortDescription: "Mesa style pen finished with chrome trim and fittings and having a barrel made of carbon fiber.",
    fullDescription:
      "These pens are made in the mesa style. Mesa style pen finished with chrome trim and fittings and having a barrel made of carbon fiber.",
    price: 55,
    priceType: "fixed",
    status: "available",
    materials: ["Carbon fiber"],
    finishes: ["Chrome trim"],
    customizable: true,
    featured: false,
    images: [img(mcf1Img, "Mesa style pen with chrome trim and a carbon fiber barrel", 1200, 1095)],
    tags: ["mesa", "carbon fiber", "pens"],
    occasions: ["Graduation", "Holiday", "Just because"],
    relatedProducts: ["p278", "p279", "p95"],
    seoTitle: "Mesa Pen in Chrome with Carbon Fiber | Paul's Pens n Things",
    seoDescription:
      "Mesa style pen finished with chrome trim and fittings and having a barrel made of carbon fiber. Handcrafted in Paragould, Arkansas.",
  },
  {
    id: "p278",
    slug: "mcf2-24kt-gold-gun-metal-mesa-pen-carbon-fiber",
    name: "Mesa Pen in 24kt Gold and Gun Metal with Carbon Fiber",
    internalCode: "MCF2",
    category: "pens",
    subcategory: "Sierra Mesa Gatsby",
    shortDescription:
      "Mesa style pen finished with 24kt gold and gun metal trim and fittings and having a barrel made of carbon fiber.",
    fullDescription:
      "These pens are made in the mesa style. Mesa style pen finished with 24kt gold and gun metal trim and fittings and having a barrel made of carbon fiber.",
    price: 55,
    priceType: "fixed",
    status: "available",
    materials: ["Carbon fiber"],
    finishes: ["24kt gold trim", "Gun metal trim"],
    customizable: true,
    featured: false,
    images: [img(mcf2Img, "Mesa style pen with 24kt gold and gun metal trim and a carbon fiber barrel", 1200, 1175)],
    tags: ["mesa", "carbon fiber", "pens"],
    occasions: ["Graduation", "Holiday", "Just because"],
    relatedProducts: ["p279", "p280", "p277"],
    seoTitle: "Mesa Pen in 24kt Gold and Gun Metal with Carbon Fiber | Paul's Pens n Things",
    seoDescription:
      "Mesa style pen finished with 24kt gold and gun metal trim and fittings and having a barrel made of carbon fiber. Handcrafted in Paragould, Arkansas.",
  },
  {
    id: "p279",
    slug: "mcf3-24kt-gold-mesa-pen-carbon-fiber",
    name: "Mesa Pen in 24kt Gold with Carbon Fiber",
    internalCode: "MCF3",
    category: "pens",
    subcategory: "Sierra Mesa Gatsby",
    shortDescription: "Mesa style pen finished with 24kt gold trim and fittings and having a barrel made of carbon fiber.",
    fullDescription:
      "These pens are made in the mesa style. Mesa style pen finished with 24kt gold trim and fittings and having a barrel made of carbon fiber.",
    price: 55,
    priceType: "fixed",
    status: "available",
    materials: ["Carbon fiber"],
    finishes: ["24kt gold trim"],
    customizable: true,
    featured: false,
    images: [img(mcf3Img, "Mesa style pen with 24kt gold trim and a carbon fiber barrel", 1200, 1087)],
    tags: ["mesa", "carbon fiber", "pens"],
    occasions: ["Graduation", "Holiday", "Just because"],
    relatedProducts: ["p280", "p281", "p278"],
    seoTitle: "Mesa Pen in 24kt Gold with Carbon Fiber | Paul's Pens n Things",
    seoDescription:
      "Mesa style pen finished with 24kt gold trim and fittings and having a barrel made of carbon fiber. Handcrafted in Paragould, Arkansas.",
  },
  {
    id: "p280",
    slug: "mcf4-24kt-gold-chrome-mesa-pen-carbon-fiber",
    name: "Mesa Pen in 24kt Gold and Chrome with Carbon Fiber",
    internalCode: "MCF4",
    category: "pens",
    subcategory: "Sierra Mesa Gatsby",
    shortDescription:
      "Mesa style pen finished with 24kt gold and chrome trim and fittings and having a barrel made of carbon fiber.",
    fullDescription:
      "These pens are made in the mesa style. Mesa style pen finished with 24kt gold and chrome trim and fittings and having a barrel made of carbon fiber.",
    price: 55,
    priceType: "fixed",
    status: "available",
    materials: ["Carbon fiber"],
    finishes: ["24kt gold trim", "Chrome trim"],
    customizable: true,
    featured: false,
    images: [img(mcf4Img, "Mesa style pen with 24kt gold and chrome trim and a carbon fiber barrel", 1200, 1100)],
    tags: ["mesa", "carbon fiber", "pens"],
    occasions: ["Graduation", "Holiday", "Just because"],
    relatedProducts: ["p281", "p277", "p279"],
    seoTitle: "Mesa Pen in 24kt Gold and Chrome with Carbon Fiber | Paul's Pens n Things",
    seoDescription:
      "Mesa style pen finished with 24kt gold and chrome trim and fittings and having a barrel made of carbon fiber. Handcrafted in Paragould, Arkansas.",
  },
  {
    id: "p281",
    slug: "mcf5-gun-metal-mesa-pen-carbon-fiber",
    name: "Mesa Pen in Gun Metal with Carbon Fiber",
    internalCode: "MCF5",
    category: "pens",
    subcategory: "Sierra Mesa Gatsby",
    shortDescription: "Mesa style pen finished with gun metal trim and fittings and having a barrel made of carbon fiber.",
    fullDescription:
      "These pens are made in the mesa style. Mesa style pen finished with gun metal trim and fittings and having a barrel made of carbon fiber.",
    price: 55,
    priceType: "fixed",
    status: "available",
    materials: ["Carbon fiber"],
    finishes: ["Gun metal trim"],
    customizable: true,
    featured: false,
    images: [img(mcf5Img, "Mesa style pen with gun metal trim and a carbon fiber barrel", 1198, 1200)],
    tags: ["mesa", "carbon fiber", "pens"],
    occasions: ["Graduation", "Holiday", "Just because"],
    relatedProducts: ["p277", "p278", "p280"],
    seoTitle: "Mesa Pen in Gun Metal with Carbon Fiber | Paul's Pens n Things",
    seoDescription:
      "Mesa style pen finished with gun metal trim and fittings and having a barrel made of carbon fiber. Handcrafted in Paragould, Arkansas.",
  },
  {
    id: "p108",
    slug: "wsii-1-copper-wall-st-ii-pen",
    name: "Wall St II Pen in Copper with Braided Copper Barrel",
    internalCode: "WSII-1",
    category: "pens",
    subcategory: "Sierra Mesa Gatsby",
    shortDescription: "Wall St II style pen with copper trim and fittings and having a barrel made with braided copper embedded in clear resin.",
    fullDescription: "These pens are made in the wall st II style. Wall St II style pen with copper trim and fittings and having a barrel made with braided copper embedded in clear resin.",
    price: 55,
    priceType: "fixed",
    status: "available",
    materials: ["Braided copper in clear resin"],
    finishes: ["Copper trim"],
    customizable: true,
    featured: false,
    images: [img(wsii1Img, "Wall St II style pen with copper trim and a braided copper barrel in clear resin", 360, 480)],
    tags: ["wall st ii", "resin", "pens"],
    occasions: ["Graduation", "Holiday", "Just because"],
    relatedProducts: ["p104", "p105", "p106"],
    seoTitle: "Wall St II Pen in Copper with Braided Copper Barrel | Paul's Pens n Things",
    seoDescription: "Wall St II style pen with copper trim and fittings and having a barrel made with braided copper embedded in clear resin. Handcrafted in Paragould, Arkansas.",
  },
  {
    id: "p109",
    slug: "ct1-classic-twist-pen-in-gun-metal",
    name: "Classic Twist Pen in Gun Metal",
    internalCode: "CT1",
    category: "pens",
    subcategory: "Other Ballpoint",
    shortDescription: "The barrels of this pen are made with camo resin. The fittings and trim are finished in gun metal.",
    fullDescription: "These pens are designed similar to a Parker pen. The barrels of this pen are made with camo resin. The fittings and trim are finished in gun metal.",
    price: 50,
    priceType: "fixed",
    status: "previously-created",
    materials: ["Camo resin"],
    finishes: ["Gun metal trim"],
    customizable: true,
    featured: false,
    images: [img(ct1Img, "Classic Twist Pen in Gun Metal handcrafted by Paul's Pens n Things", 360, 271)],
    tags: ["classic", "ballpoint", "pens"],
    occasions: ["Graduation", "Holiday", "Just because"],
    relatedProducts: ["p110", "p111", "p137"],
    seoTitle: "Classic Twist Pen in Gun Metal | Paul's Pens n Things",
    seoDescription: "The barrels of this pen are made with camo resin. The fittings and trim are finished in gun metal. Handcrafted in Paragould, Arkansas.",
  },
  {
    id: "p110",
    slug: "ct3-classic-twist-pen-in-satin-chrome",
    name: "Classic Twist Pen in Satin Chrome",
    internalCode: "CT3",
    category: "pens",
    subcategory: "Other Ballpoint",
    shortDescription: "The barrels of this pen are made with LB27 resin. The fittings and trim are finished in satin chrome.",
    fullDescription: "These pens are designed similar to a Parker pen. The barrels of this pen are made with LB27 resin. The fittings and trim are finished in satin chrome.",
    price: 50,
    priceType: "fixed",
    status: "available",
    materials: ["LB27 resin"],
    finishes: ["Satin chrome trim"],
    customizable: true,
    featured: false,
    images: [img(ct3Img, "Classic Twist Pen in Satin Chrome handcrafted by Paul's Pens n Things", 360, 271)],
    tags: ["classic", "ballpoint", "pens"],
    occasions: ["Graduation", "Holiday", "Just because"],
    relatedProducts: ["p111", "p112", "p109"],
    seoTitle: "Classic Twist Pen in Satin Chrome | Paul's Pens n Things",
    seoDescription: "The barrels of this pen are made with LB27 resin. The fittings and trim are finished in satin chrome. Handcrafted in Paragould, Arkansas.",
  },
  {
    id: "p111",
    slug: "ct4-classic-twist-pen-in-satin-chrome-with-lacewood",
    name: "Classic Twist Pen in Satin Chrome with Lacewood",
    internalCode: "CT4",
    category: "pens",
    subcategory: "Other Ballpoint",
    shortDescription: "The barrels of this pen are made with lacewood and finished with CA. The fittings and trim are finished in satin chrome.",
    fullDescription: "These pens are designed similar to a Parker pen. The barrels of this pen are made with lacewood and finished with CA. The fittings and trim are finished in satin chrome.",
    price: 50,
    priceType: "fixed",
    status: "available",
    materials: ["Lacewood"],
    finishes: ["CA finish", "Satin chrome trim"],
    customizable: true,
    featured: false,
    images: [img(ct4Img, "Classic Twist Pen in Satin Chrome with Lacewood handcrafted by Paul's Pens n Things", 360, 271)],
    tags: ["classic", "ballpoint", "pens"],
    occasions: ["Graduation", "Holiday", "Just because"],
    relatedProducts: ["p112", "p113", "p110"],
    seoTitle: "Classic Twist Pen in Satin Chrome with Lacewood | Paul's Pens n Things",
    seoDescription: "The barrels of this pen are made with lacewood and finished with CA. The fittings and trim are finished in satin chrome. Handcrafted in Paragould, Arkansas.",
  },
  {
    id: "p112",
    slug: "ap1-american-patriot-pen-in-chrome",
    name: "American Patriot Pen in Chrome",
    internalCode: "AP1",
    category: "pens",
    subcategory: "Other Ballpoint",
    shortDescription: "This American Patriot pen has chrome trim and fittings.",
    fullDescription: "These pens have an eagle on the clip and say 'God Bless America' around the center band. The barrels are made to look like a flag. This American Patriot pen has chrome trim and fittings.",
    price: 75,
    priceType: "fixed",
    status: "available",
    materials: ["Flag-pattern barrel"],
    finishes: ["Chrome trim"],
    customizable: true,
    featured: false,
    images: [img(ap1Img, "American Patriot Pen in Chrome handcrafted by Paul's Pens n Things", 360, 480)],
    tags: ["patriot", "ballpoint", "pens"],
    occasions: ["Graduation", "Holiday", "Just because"],
    relatedProducts: ["p113", "p114", "p111"],
    seoTitle: "American Patriot Pen in Chrome | Paul's Pens n Things",
    seoDescription: "This American Patriot pen has chrome trim and fittings. Handcrafted in Paragould, Arkansas.",
  },
  {
    id: "p113",
    slug: "ap2-american-patriot-pen-in-antique-pewter",
    name: "American Patriot Pen in Antique Pewter",
    internalCode: "AP2",
    category: "pens",
    subcategory: "Other Ballpoint",
    shortDescription: "This American Patriot pen has antique pewter trim and fittings.",
    fullDescription: "These pens have an eagle on the clip and say 'God Bless America' around the center band. The barrels are made to look like a flag. This American Patriot pen has antique pewter trim and fittings. This pen has sold; Paul can make something similar in your own materials.",
    price: 75,
    priceType: "fixed",
    status: "previously-created",
    materials: ["Flag-pattern barrel"],
    finishes: ["Antique pewter trim"],
    customizable: true,
    featured: false,
    images: [img(ap2Img, "American Patriot Pen in Antique Pewter handcrafted by Paul's Pens n Things", 360, 480)],
    tags: ["patriot", "ballpoint", "pens"],
    occasions: ["Graduation", "Holiday", "Just because"],
    relatedProducts: ["p114", "p115", "p112"],
    seoTitle: "American Patriot Pen in Antique Pewter | Paul's Pens n Things",
    seoDescription: "This American Patriot pen has antique pewter trim and fittings. Handcrafted in Paragould, Arkansas.",
  },
  {
    id: "p114",
    slug: "ap3-american-patriot-pen-in-antique-brass",
    name: "American Patriot Pen in Antique Brass",
    internalCode: "AP3",
    category: "pens",
    subcategory: "Other Ballpoint",
    shortDescription: "This American Patriot pen has antique brass trim and fittings.",
    fullDescription: "These pens have an eagle on the clip and say 'God Bless America' around the center band. The barrels are made to look like a flag. This American Patriot pen has antique brass trim and fittings.",
    price: 75,
    priceType: "fixed",
    status: "available",
    materials: ["Flag-pattern barrel"],
    finishes: ["Antique brass trim"],
    customizable: true,
    featured: false,
    images: [img(ap3Img, "American Patriot Pen in Antique Brass handcrafted by Paul's Pens n Things", 360, 480)],
    tags: ["patriot", "ballpoint", "pens"],
    occasions: ["Graduation", "Holiday", "Just because"],
    relatedProducts: ["p115", "p116", "p113"],
    seoTitle: "American Patriot Pen in Antique Brass | Paul's Pens n Things",
    seoDescription: "This American Patriot pen has antique brass trim and fittings. Handcrafted in Paragould, Arkansas.",
  },
  {
    id: "p115",
    slug: "drt-ac1-dragon-twist-pen-in-antique-copper",
    name: "Dragon Twist Pen in Antique Copper",
    internalCode: "DRT-AC1",
    category: "pens",
    subcategory: "Other Ballpoint",
    shortDescription: "Dragon twist pen with antique copper trim and fittings; the barrels are epoxy inlaid to resemble dragon scales.",
    fullDescription: "These dragon style twist pens have a dragon shaped clip, a claw going around the center band and a tiger's eye stone in the cap. Dragon twist pen with antique copper trim and fittings; the barrels are epoxy inlaid to resemble dragon scales.",
    price: 85,
    priceType: "fixed",
    status: "available",
    materials: ["Epoxy inlaid dragon scale barrel", "Tiger's eye stone"],
    finishes: ["Antique copper trim"],
    customizable: true,
    featured: false,
    images: [img(drtAc1Img, "Dragon Twist Pen in Antique Copper handcrafted by Paul's Pens n Things", 360, 480)],
    tags: ["dragon", "ballpoint", "pens"],
    occasions: ["Graduation", "Holiday", "Just because"],
    relatedProducts: ["p116", "p117", "p114"],
    seoTitle: "Dragon Twist Pen in Antique Copper | Paul's Pens n Things",
    seoDescription: "Dragon twist pen with antique copper trim and fittings; the barrels are epoxy inlaid to resemble dragon scales. Handcrafted in Paragould, Arkansas.",
  },
  {
    id: "p116",
    slug: "drt-ac2-dragon-twist-pen-in-antique-copper",
    name: "Dragon Twist Pen in Antique Copper",
    internalCode: "DRT-AC2",
    category: "pens",
    subcategory: "Other Ballpoint",
    shortDescription: "Dragon twist pen with antique copper trim and fittings; the barrels are epoxy inlaid to resemble dragon scales.",
    fullDescription: "These dragon style twist pens have a dragon shaped clip, a claw going around the center band and a tiger's eye stone in the cap. Dragon twist pen with antique copper trim and fittings; the barrels are epoxy inlaid to resemble dragon scales.",
    price: 85,
    priceType: "fixed",
    status: "available",
    materials: ["Epoxy inlaid dragon scale barrel", "Tiger's eye stone"],
    finishes: ["Antique copper trim"],
    customizable: true,
    featured: false,
    images: [img(drtAc2Img, "Dragon Twist Pen in Antique Copper handcrafted by Paul's Pens n Things", 360, 480)],
    tags: ["dragon", "ballpoint", "pens"],
    occasions: ["Graduation", "Holiday", "Just because"],
    relatedProducts: ["p117", "p118", "p115"],
    seoTitle: "Dragon Twist Pen in Antique Copper | Paul's Pens n Things",
    seoDescription: "Dragon twist pen with antique copper trim and fittings; the barrels are epoxy inlaid to resemble dragon scales. Handcrafted in Paragould, Arkansas.",
  },
  {
    id: "p117",
    slug: "drt-ab1-dragon-twist-pen-in-antique-brass",
    name: "Dragon Twist Pen in Antique Brass",
    internalCode: "DRT-AB1",
    category: "pens",
    subcategory: "Other Ballpoint",
    shortDescription: "Dragon twist pen with antique brass trim and fittings; the barrels are epoxy inlaid to resemble dragon scales.",
    fullDescription: "These dragon style twist pens have a dragon shaped clip, a claw going around the center band and a tiger's eye stone in the cap. Dragon twist pen with antique brass trim and fittings; the barrels are epoxy inlaid to resemble dragon scales.",
    price: 85,
    priceType: "fixed",
    status: "available",
    materials: ["Epoxy inlaid dragon scale barrel", "Tiger's eye stone"],
    finishes: ["Antique brass trim"],
    customizable: true,
    featured: false,
    images: [img(drtAb1Img, "Dragon Twist Pen in Antique Brass handcrafted by Paul's Pens n Things", 360, 480)],
    tags: ["dragon", "ballpoint", "pens"],
    occasions: ["Graduation", "Holiday", "Just because"],
    relatedProducts: ["p118", "p119", "p116"],
    seoTitle: "Dragon Twist Pen in Antique Brass | Paul's Pens n Things",
    seoDescription: "Dragon twist pen with antique brass trim and fittings; the barrels are epoxy inlaid to resemble dragon scales. Handcrafted in Paragould, Arkansas.",
  },
  {
    id: "p118",
    slug: "drt-ab2-dragon-twist-pen-in-antique-brass",
    name: "Dragon Twist Pen in Antique Brass",
    internalCode: "DRT-AB2",
    category: "pens",
    subcategory: "Other Ballpoint",
    shortDescription: "Dragon twist pen with antique brass trim and fittings; the barrels are epoxy inlaid to resemble dragon scales.",
    fullDescription: "These dragon style twist pens have a dragon shaped clip, a claw going around the center band and a tiger's eye stone in the cap. Dragon twist pen with antique brass trim and fittings; the barrels are epoxy inlaid to resemble dragon scales.",
    price: 85,
    priceType: "fixed",
    status: "available",
    materials: ["Epoxy inlaid dragon scale barrel", "Tiger's eye stone"],
    finishes: ["Antique brass trim"],
    customizable: true,
    featured: false,
    images: [img(drtAb2Img, "Dragon Twist Pen in Antique Brass handcrafted by Paul's Pens n Things", 360, 480)],
    tags: ["dragon", "ballpoint", "pens"],
    occasions: ["Graduation", "Holiday", "Just because"],
    relatedProducts: ["p119", "p120", "p117"],
    seoTitle: "Dragon Twist Pen in Antique Brass | Paul's Pens n Things",
    seoDescription: "Dragon twist pen with antique brass trim and fittings; the barrels are epoxy inlaid to resemble dragon scales. Handcrafted in Paragould, Arkansas.",
  },
  {
    id: "p119",
    slug: "drt-ap1-dragon-twist-pen-in-antique-pewter",
    name: "Dragon Twist Pen in Antique Pewter",
    internalCode: "DRT-AP1",
    category: "pens",
    subcategory: "Other Ballpoint",
    shortDescription: "Dragon twist pen with antique pewter trim and fittings; the barrels are epoxy inlaid to resemble dragon scales.",
    fullDescription: "These dragon style twist pens have a dragon shaped clip, a claw going around the center band and a tiger's eye stone in the cap. Dragon twist pen with antique pewter trim and fittings; the barrels are epoxy inlaid to resemble dragon scales.",
    price: 85,
    priceType: "fixed",
    status: "available",
    materials: ["Epoxy inlaid dragon scale barrel", "Tiger's eye stone"],
    finishes: ["Antique pewter trim"],
    customizable: true,
    featured: false,
    images: [img(drtAp1Img, "Dragon Twist Pen in Antique Pewter handcrafted by Paul's Pens n Things", 360, 480)],
    tags: ["dragon", "ballpoint", "pens"],
    occasions: ["Graduation", "Holiday", "Just because"],
    relatedProducts: ["p120", "p121", "p118"],
    seoTitle: "Dragon Twist Pen in Antique Pewter | Paul's Pens n Things",
    seoDescription: "Dragon twist pen with antique pewter trim and fittings; the barrels are epoxy inlaid to resemble dragon scales. Handcrafted in Paragould, Arkansas.",
  },
  {
    id: "p120",
    slug: "drt-ap2-dragon-twist-pen-in-antique-pewter-with-wood-barrel",
    name: "Dragon Twist Pen in Antique Pewter with Wood Barrel",
    internalCode: "DRT-AP2",
    category: "pens",
    subcategory: "Other Ballpoint",
    shortDescription: "Dragon twist pen with antique pewter trim and fittings; the barrels are made of an unknown wood.",
    fullDescription: "These dragon style twist pens have a dragon shaped clip, a claw going around the center band and a tiger's eye stone in the cap. Dragon twist pen with antique pewter trim and fittings; the barrels are made of an unknown wood.",
    price: 70,
    priceType: "fixed",
    status: "available",
    materials: ["Unknown wood", "Tiger's eye stone"],
    finishes: ["Antique pewter trim"],
    customizable: true,
    featured: false,
    images: [img(drtAp1bImg, "Dragon Twist Pen in Antique Pewter with Wood Barrel handcrafted by Paul's Pens n Things", 360, 480)],
    tags: ["dragon", "ballpoint", "pens"],
    occasions: ["Graduation", "Holiday", "Just because"],
    relatedProducts: ["p121", "p122", "p119"],
    seoTitle: "Dragon Twist Pen in Antique Pewter with Wood Barrel | Paul's Pens n Things",
    seoDescription: "Dragon twist pen with antique pewter trim and fittings; the barrels are made of an unknown wood. Handcrafted in Paragould, Arkansas.",
  },
  {
    id: "p121",
    slug: "ka1-knights-armor-pen-in-antique-pewter-with-afzelia",
    name: "Knights Armor Pen in Antique Pewter with Afzelia",
    internalCode: "KA1",
    category: "pens",
    subcategory: "Other Ballpoint",
    shortDescription: "This pen is finished in antique pewter and the barrel is made of afzelia that is finished with CA.",
    fullDescription: "These pens are made with a knights armor theme. The clip is a sword and the cap is a knights helmet. This pen is finished in antique pewter and the barrel is made of afzelia that is finished with CA.",
    price: 70,
    priceType: "fixed",
    status: "available",
    materials: ["Afzelia"],
    finishes: ["CA finish", "Antique pewter trim"],
    customizable: true,
    featured: false,
    images: [img(ka1Img, "Knights Armor Pen in Antique Pewter with Afzelia handcrafted by Paul's Pens n Things", 360, 271)],
    tags: ["knights", "ballpoint", "pens"],
    occasions: ["Graduation", "Holiday", "Just because"],
    relatedProducts: ["p122", "p123", "p120"],
    seoTitle: "Knights Armor Pen in Antique Pewter with Afzelia | Paul's Pens n Things",
    seoDescription: "This pen is finished in antique pewter and the barrel is made of afzelia that is finished with CA. Handcrafted in Paragould, Arkansas.",
  },
  {
    id: "p122",
    slug: "ka2-knights-armor-pen-in-antique-brass-with-aq06-resin",
    name: "Knights Armor Pen in Antique Brass with AQ06 Resin",
    internalCode: "KA2",
    category: "pens",
    subcategory: "Other Ballpoint",
    shortDescription: "This pen is finished in antique brass and the barrel is made of AQ06 resin.",
    fullDescription: "These pens are made with a knights armor theme. The clip is a sword and the cap is a knights helmet. This pen is finished in antique brass and the barrel is made of AQ06 resin.",
    price: 70,
    priceType: "fixed",
    status: "available",
    materials: ["AQ06 resin"],
    finishes: ["Antique brass trim"],
    customizable: true,
    featured: false,
    images: [img(ka2Img, "Knights Armor Pen in Antique Brass with AQ06 Resin handcrafted by Paul's Pens n Things", 360, 271)],
    tags: ["knights", "ballpoint", "pens"],
    occasions: ["Graduation", "Holiday", "Just because"],
    relatedProducts: ["p123", "p124", "p121"],
    seoTitle: "Knights Armor Pen in Antique Brass with AQ06 Resin | Paul's Pens n Things",
    seoDescription: "This pen is finished in antique brass and the barrel is made of AQ06 resin. Handcrafted in Paragould, Arkansas.",
  },
  {
    id: "p123",
    slug: "ka4-knights-armor-pen-in-antique-pewter-with-ia73-resin",
    name: "Knights Armor Pen in Antique Pewter with IA73 Resin",
    internalCode: "KA4",
    category: "pens",
    subcategory: "Other Ballpoint",
    shortDescription: "This pen is finished in antique pewter and the barrel is made of IA73 resin.",
    fullDescription: "These pens are made with a knights armor theme. The clip is a sword and the cap is a knights helmet. This pen is finished in antique pewter and the barrel is made of IA73 resin.",
    price: 70,
    priceType: "fixed",
    status: "available",
    materials: ["IA73 resin"],
    finishes: ["Antique pewter trim"],
    customizable: true,
    featured: false,
    images: [img(ka4Img, "Knights Armor Pen in Antique Pewter with IA73 Resin handcrafted by Paul's Pens n Things", 360, 271)],
    tags: ["knights", "ballpoint", "pens"],
    occasions: ["Graduation", "Holiday", "Just because"],
    relatedProducts: ["p124", "p125", "p122"],
    seoTitle: "Knights Armor Pen in Antique Pewter with IA73 Resin | Paul's Pens n Things",
    seoDescription: "This pen is finished in antique pewter and the barrel is made of IA73 resin. Handcrafted in Paragould, Arkansas.",
  },
  {
    id: "p124",
    slug: "ka5-knights-armor-pen-in-antique-pewter-with-castle-inlay",
    name: "Knights Armor Pen in Antique Pewter with Castle Inlay",
    internalCode: "KA5",
    category: "pens",
    subcategory: "Other Ballpoint",
    shortDescription: "This pen is finished in antique pewter and the barrel is made of a castle inlay.",
    fullDescription: "These pens are made with a knights armor theme. The clip is a sword and the cap is a knights helmet. This pen is finished in antique pewter and the barrel is made of a castle inlay.",
    price: 90,
    priceType: "fixed",
    status: "available",
    materials: ["Castle inlay"],
    finishes: ["Antique pewter trim"],
    customizable: true,
    featured: false,
    images: [img(ka5Img, "Knights Armor Pen in Antique Pewter with Castle Inlay handcrafted by Paul's Pens n Things", 360, 480)],
    tags: ["knights", "ballpoint", "pens"],
    occasions: ["Graduation", "Holiday", "Just because"],
    relatedProducts: ["p125", "p126", "p123"],
    seoTitle: "Knights Armor Pen in Antique Pewter with Castle Inlay | Paul's Pens n Things",
    seoDescription: "This pen is finished in antique pewter and the barrel is made of a castle inlay. Handcrafted in Paragould, Arkansas.",
  },
  {
    id: "p125",
    slug: "ka6-knights-armor-pen-in-antique-brass-with-castle-inlay",
    name: "Knights Armor Pen in Antique Brass with Castle Inlay",
    internalCode: "KA6",
    category: "pens",
    subcategory: "Other Ballpoint",
    shortDescription: "This pen is finished in antique brass and the barrel is made of a castle inlay.",
    fullDescription: "These pens are made with a knights armor theme. The clip is a sword and the cap is a knights helmet. This pen is finished in antique brass and the barrel is made of a castle inlay.",
    price: 90,
    priceType: "fixed",
    status: "available",
    materials: ["Castle inlay"],
    finishes: ["Antique brass trim"],
    customizable: true,
    featured: false,
    images: [img(ka6Img, "Knights Armor Pen in Antique Brass with Castle Inlay handcrafted by Paul's Pens n Things", 360, 480)],
    tags: ["knights", "ballpoint", "pens"],
    occasions: ["Graduation", "Holiday", "Just because"],
    relatedProducts: ["p126", "p127", "p124"],
    seoTitle: "Knights Armor Pen in Antique Brass with Castle Inlay | Paul's Pens n Things",
    seoDescription: "This pen is finished in antique brass and the barrel is made of a castle inlay. Handcrafted in Paragould, Arkansas.",
  },
  {
    id: "p126",
    slug: "ka7-knights-armor-pen-in-antique-pewter-with-wood-barrel",
    name: "Knights Armor Pen in Antique Pewter with Wood Barrel",
    internalCode: "KA7",
    category: "pens",
    subcategory: "Other Ballpoint",
    shortDescription: "This pen is finished in antique pewter and the barrel is made of an unknown wood.",
    fullDescription: "These pens are made with a knights armor theme. The clip is a sword and the cap is a knights helmet. This pen is finished in antique pewter and the barrel is made of an unknown wood.",
    price: 70,
    priceType: "fixed",
    status: "available",
    materials: ["Unknown wood"],
    finishes: ["Antique pewter trim"],
    customizable: true,
    featured: false,
    images: [img(ka7Img, "Knights Armor Pen in Antique Pewter with Wood Barrel handcrafted by Paul's Pens n Things", 360, 480)],
    tags: ["knights", "ballpoint", "pens"],
    occasions: ["Graduation", "Holiday", "Just because"],
    relatedProducts: ["p127", "p128", "p125"],
    seoTitle: "Knights Armor Pen in Antique Pewter with Wood Barrel | Paul's Pens n Things",
    seoDescription: "This pen is finished in antique pewter and the barrel is made of an unknown wood. Handcrafted in Paragould, Arkansas.",
  },
  {
    id: "p127",
    slug: "ka8-knights-armor-pen-in-antique-brass-with-wood-barrel",
    name: "Knights Armor Pen in Antique Brass with Wood Barrel",
    internalCode: "KA8",
    category: "pens",
    subcategory: "Other Ballpoint",
    shortDescription: "This pen is finished in antique brass and the barrel is made of an unknown wood.",
    fullDescription: "These pens are made with a knights armor theme. The clip is a sword and the cap is a knights helmet. This pen is finished in antique brass and the barrel is made of an unknown wood.",
    price: 70,
    priceType: "fixed",
    status: "available",
    materials: ["Unknown wood"],
    finishes: ["Antique brass trim"],
    customizable: true,
    featured: false,
    images: [img(ka8Img, "Knights Armor Pen in Antique Brass with Wood Barrel handcrafted by Paul's Pens n Things", 360, 480)],
    tags: ["knights", "ballpoint", "pens"],
    occasions: ["Graduation", "Holiday", "Just because"],
    relatedProducts: ["p128", "p129", "p126"],
    seoTitle: "Knights Armor Pen in Antique Brass with Wood Barrel | Paul's Pens n Things",
    seoDescription: "This pen is finished in antique brass and the barrel is made of an unknown wood. Handcrafted in Paragould, Arkansas.",
  },
  {
    id: "p128",
    slug: "gs1-gearshift-pen-in-antique-pewter",
    name: "Gearshift Pen in Antique Pewter",
    internalCode: "GS1",
    category: "pens",
    subcategory: "Other Ballpoint",
    shortDescription: "This pen is finished in antique pewter.",
    fullDescription: "These pens have a gear shift mechanism to advance and retract the ink refill. The barrel is made of a flames inlay. This pen is finished in antique pewter.",
    price: 110,
    priceType: "fixed",
    status: "available",
    materials: ["Flames inlay barrel"],
    finishes: ["Antique pewter trim"],
    customizable: true,
    featured: false,
    images: [img(gs1Img, "Gearshift Pen in Antique Pewter handcrafted by Paul's Pens n Things", 360, 271)],
    tags: ["gearshift", "ballpoint", "pens"],
    occasions: ["Graduation", "Holiday", "Just because"],
    relatedProducts: ["p129", "p130", "p127"],
    seoTitle: "Gearshift Pen in Antique Pewter | Paul's Pens n Things",
    seoDescription: "This pen is finished in antique pewter. Handcrafted in Paragould, Arkansas.",
  },
  {
    id: "p129",
    slug: "gs2-gearshift-pen-in-antique-brass",
    name: "Gearshift Pen in Antique Brass",
    internalCode: "GS2",
    category: "pens",
    subcategory: "Other Ballpoint",
    shortDescription: "This pen is finished in antique brass.",
    fullDescription: "These pens have a gear shift mechanism to advance and retract the ink refill. The barrel is made of a flames inlay. This pen is finished in antique brass.",
    price: 110,
    priceType: "fixed",
    status: "available",
    materials: ["Flames inlay barrel"],
    finishes: ["Antique brass trim"],
    customizable: true,
    featured: false,
    images: [img(gs2Img, "Gearshift Pen in Antique Brass handcrafted by Paul's Pens n Things", 360, 271)],
    tags: ["gearshift", "ballpoint", "pens"],
    occasions: ["Graduation", "Holiday", "Just because"],
    relatedProducts: ["p130", "p131", "p128"],
    seoTitle: "Gearshift Pen in Antique Brass | Paul's Pens n Things",
    seoDescription: "This pen is finished in antique brass. Handcrafted in Paragould, Arkansas.",
  },
  {
    id: "p130",
    slug: "gs3-gearshift-pen-in-chrome",
    name: "Gearshift Pen in Chrome",
    internalCode: "GS3",
    category: "pens",
    subcategory: "Other Ballpoint",
    shortDescription: "This pen is finished in chrome.",
    fullDescription: "These pens have a gear shift mechanism to advance and retract the ink refill. The barrel is made of a flames inlay. This pen is finished in chrome.",
    price: 110,
    priceType: "fixed",
    status: "previously-created",
    materials: ["Flames inlay barrel"],
    finishes: ["Chrome trim"],
    customizable: true,
    featured: false,
    images: [img(gs3Img, "Gearshift Pen in Chrome handcrafted by Paul's Pens n Things", 360, 271)],
    tags: ["gearshift", "ballpoint", "pens"],
    occasions: ["Graduation", "Holiday", "Just because"],
    relatedProducts: ["p131", "p132", "p129"],
    seoTitle: "Gearshift Pen in Chrome | Paul's Pens n Things",
    seoDescription: "This pen is finished in chrome. Handcrafted in Paragould, Arkansas.",
  },
  {
    id: "p131",
    slug: "gs4-gearshift-pen-in-chrome",
    name: "Gearshift Pen in Chrome",
    internalCode: "GS4",
    category: "pens",
    subcategory: "Other Ballpoint",
    shortDescription: "This pen is finished in chrome.",
    fullDescription: "These pens have a gear shift mechanism to advance and retract the ink refill. The barrel is made of a flames inlay. This pen is finished in chrome. This pen has sold; Paul can make something similar in your own materials.",
    price: 110,
    priceType: "fixed",
    status: "previously-created",
    materials: ["Flames inlay barrel"],
    finishes: ["Chrome trim"],
    customizable: true,
    featured: false,
    images: [img(gs4Img, "Gearshift Pen in Chrome handcrafted by Paul's Pens n Things", 360, 480)],
    tags: ["gearshift", "ballpoint", "pens"],
    occasions: ["Graduation", "Holiday", "Just because"],
    relatedProducts: ["p132", "p133", "p130"],
    seoTitle: "Gearshift Pen in Chrome | Paul's Pens n Things",
    seoDescription: "This pen is finished in chrome. Handcrafted in Paragould, Arkansas.",
  },
  {
    id: "p132",
    slug: "gs5-gearshift-pen-in-antique-pewter",
    name: "Gearshift Pen in Antique Pewter",
    internalCode: "GS5",
    category: "pens",
    subcategory: "Other Ballpoint",
    shortDescription: "This pen is finished in antique pewter.",
    fullDescription: "These pens have a gear shift mechanism to advance and retract the ink refill. The barrel is made of a flames inlay. This pen is finished in antique pewter.",
    price: 110,
    priceType: "fixed",
    status: "available",
    materials: ["Flames inlay barrel"],
    finishes: ["Antique pewter trim"],
    customizable: true,
    featured: false,
    images: [img(gs5Img, "Gearshift Pen in Antique Pewter handcrafted by Paul's Pens n Things", 360, 480)],
    tags: ["gearshift", "ballpoint", "pens"],
    occasions: ["Graduation", "Holiday", "Just because"],
    relatedProducts: ["p133", "p134", "p131"],
    seoTitle: "Gearshift Pen in Antique Pewter | Paul's Pens n Things",
    seoDescription: "This pen is finished in antique pewter. Handcrafted in Paragould, Arkansas.",
  },
  {
    id: "p133",
    slug: "gs6-gearshift-pen-in-antique-brass",
    name: "Gearshift Pen in Antique Brass",
    internalCode: "GS6",
    category: "pens",
    subcategory: "Other Ballpoint",
    shortDescription: "This pen is finished in antique brass.",
    fullDescription: "These pens have a gear shift mechanism to advance and retract the ink refill. The barrel is made of a flames inlay. This pen is finished in antique brass.",
    price: 110,
    priceType: "fixed",
    status: "available",
    materials: ["Flames inlay barrel"],
    finishes: ["Antique brass trim"],
    customizable: true,
    featured: false,
    images: [img(gs6Img, "Gearshift Pen in Antique Brass handcrafted by Paul's Pens n Things", 360, 480)],
    tags: ["gearshift", "ballpoint", "pens"],
    occasions: ["Graduation", "Holiday", "Just because"],
    relatedProducts: ["p134", "p135", "p132"],
    seoTitle: "Gearshift Pen in Antique Brass | Paul's Pens n Things",
    seoDescription: "This pen is finished in antique brass. Handcrafted in Paragould, Arkansas.",
  },
  {
    id: "p134",
    slug: "gs7-gearshift-pen-in-gun-metal",
    name: "Gearshift Pen in Gun Metal",
    internalCode: "GS7",
    category: "pens",
    subcategory: "Other Ballpoint",
    shortDescription: "This pen is finished in gun metal.",
    fullDescription: "These pens have a gear shift mechanism to advance and retract the ink refill. The barrel is made of a flames inlay. This pen is finished in gun metal.",
    price: 110,
    priceType: "fixed",
    status: "available",
    materials: ["Flames inlay barrel"],
    finishes: ["Gun metal trim"],
    customizable: true,
    featured: false,
    images: [img(gs7Img, "Gearshift Pen in Gun Metal handcrafted by Paul's Pens n Things", 360, 480)],
    tags: ["gearshift", "ballpoint", "pens"],
    occasions: ["Graduation", "Holiday", "Just because"],
    relatedProducts: ["p135", "p136", "p133"],
    seoTitle: "Gearshift Pen in Gun Metal | Paul's Pens n Things",
    seoDescription: "This pen is finished in gun metal. Handcrafted in Paragould, Arkansas.",
  },
  {
    id: "p135",
    slug: "bb-1-big-ben-pen-in-antique-copper",
    name: "Big Ben Pen in Antique Copper",
    internalCode: "BB-1",
    category: "pens",
    subcategory: "Other Ballpoint",
    shortDescription: "This pen is made in the big ben style and is finished in antique copper. The barrels are made of an unknown resin.",
    fullDescription: "Pens in this category are limited in quantity and options. This pen is made in the big ben style and is finished in antique copper. The barrels are made of an unknown resin.",
    price: 65,
    priceType: "fixed",
    status: "available",
    materials: ["Unknown resin"],
    finishes: ["Antique copper trim"],
    customizable: true,
    featured: false,
    images: [img(bb1Img, "Big Ben Pen in Antique Copper handcrafted by Paul's Pens n Things", 360, 271)],
    tags: ["misc", "ballpoint", "pens"],
    occasions: ["Graduation", "Holiday", "Just because"],
    relatedProducts: ["p136", "p137", "p134"],
    seoTitle: "Big Ben Pen in Antique Copper | Paul's Pens n Things",
    seoDescription: "This pen is made in the big ben style and is finished in antique copper. The barrels are made of an unknown resin. Handcrafted in Paragould, Arkansas.",
  },
  {
    id: "p136",
    slug: "pt-1-princess-twist-pen-in-gold-with-clear-crystals",
    name: "Princess Twist Pen in Gold with Clear Crystals",
    internalCode: "PT-1",
    category: "pens",
    subcategory: "Other Ballpoint",
    shortDescription: "This princess twist pen is finished in 24kt gold and has clear crystals on the clip and center band. The barrels are made of an unknown resin.",
    fullDescription: "Pens in this category are limited in quantity and options. This princess twist pen is finished in 24kt gold and has clear crystals on the clip and center band. The barrels are made of an unknown resin.",
    price: 45,
    priceType: "fixed",
    status: "previously-created",
    materials: ["Unknown resin", "Clear crystals"],
    finishes: ["24kt gold trim"],
    customizable: true,
    featured: false,
    images: [img(princessImg, "Princess Twist Pen in Gold with Clear Crystals handcrafted by Paul's Pens n Things", 360, 271)],
    tags: ["misc", "ballpoint", "pens"],
    occasions: ["Graduation", "Holiday", "Just because"],
    relatedProducts: ["p137", "p109", "p135"],
    seoTitle: "Princess Twist Pen in Gold with Clear Crystals | Paul's Pens n Things",
    seoDescription: "This princess twist pen is finished in 24kt gold and has clear crystals on the clip and center band. The barrels are made of an unknown resin. Handcrafted in Paragould, Arkansas.",
  },
  {
    id: "p137",
    slug: "np-1-necklace-pen-in-gold",
    name: "Necklace Pen in Gold",
    internalCode: "NP-1",
    category: "pens",
    subcategory: "Other Ballpoint",
    shortDescription: "This necklace pen is detachable and is finished in 24kt gold. The barrels are made of a black and gold resin.",
    fullDescription: "Pens in this category are limited in quantity and options. This necklace pen is detachable and is finished in 24kt gold. The barrels are made of a black and gold resin.",
    price: 45,
    priceType: "fixed",
    status: "previously-created",
    materials: ["Black and gold resin"],
    finishes: ["24kt gold trim"],
    customizable: true,
    featured: false,
    images: [img(np1Img, "Necklace Pen in Gold handcrafted by Paul's Pens n Things", 360, 271)],
    tags: ["misc", "ballpoint", "pens"],
    occasions: ["Graduation", "Holiday", "Just because"],
    relatedProducts: ["p109", "p110", "p136"],
    seoTitle: "Necklace Pen in Gold | Paul's Pens n Things",
    seoDescription: "This necklace pen is detachable and is finished in 24kt gold. The barrels are made of a black and gold resin. Handcrafted in Paragould, Arkansas.",
  },
  // KS-RES and KS-WOOD restocked at $50 — status: available (Aug 2026)
  {
    id: "p154",
    slug: "ks-res-resin-kaleidoscope",
    name: "Resin Kaleidoscope",
    internalCode: "KS-RES",
    category: "lathe-gifts",
    subcategory: "Other Lathe Items",
    shortDescription: "A resin kaleidoscope with a red, green, or blue wand. It is made with assorted resin patterns and shapes.",
    fullDescription: "A resin kaleidoscope with a red, green, or blue wand. It is made with assorted resin patterns and shapes. Hold the wand vertical and look inside to see a continuously changing image. Specify color of wand.",
    price: 50,
    priceType: "fixed",
    status: "available",
    materials: ["Assorted resin", "Lens and mirrors"],
    finishes: ["Polished resin"],
    customizable: true,
    featured: false,
    images: [img(ksResImg, "Resin Kaleidoscope handcrafted by Paul\'s Pens n Things", 360, 271)],
    tags: ["kaleidoscope", "lathe", "gift"],
    occasions: ["Wedding", "Holiday", "Just because"],
    relatedProducts: ["p155", "p156", "p172"],
    seoTitle: "Resin Kaleidoscope | Paul\'s Pens n Things",
    seoDescription: "A resin kaleidoscope with a red, green, or blue wand. It is made with assorted resin patterns and shapes. Hold the wand vertical and look inside to see a continuously changing image. Specify color of wand. Handcrafted in Paragould, Arkansas.",
  },
  {
    id: "p155",
    slug: "ks-wood-wood-kaleidoscope",
    name: "Wood Kaleidoscope",
    internalCode: "KS-WOOD",
    category: "lathe-gifts",
    subcategory: "Other Lathe Items",
    shortDescription: "A wood kaleidoscope with a red, green, or blue wand. It is made with assorted woods and shapes.",
    fullDescription: "A wood kaleidoscope with a red, green, or blue wand. It is made with assorted woods and shapes. Hold the wand vertical and look inside to see a continuously changing image. Specify color of wand.",
    price: 50,
    priceType: "fixed",
    status: "available",
    materials: ["Assorted hardwoods", "Lens and mirrors"],
    finishes: ["Hand-rubbed finish"],
    customizable: true,
    featured: false,
    images: [img(ksWoodImg, "Wood Kaleidoscope handcrafted by Paul\'s Pens n Things", 360, 271)],
    tags: ["kaleidoscope", "lathe", "gift"],
    occasions: ["Wedding", "Holiday", "Just because"],
    relatedProducts: ["p156", "p157", "p154"],
    seoTitle: "Wood Kaleidoscope | Paul\'s Pens n Things",
    seoDescription: "A wood kaleidoscope with a red, green, or blue wand. It is made with assorted woods and shapes. Hold the wand vertical and look inside to see a continuously changing image. Specify color of wand. Handcrafted in Paragould, Arkansas.",
  },
  {
    id: "p156",
    slug: "dc-res-resin-duck-call",
    name: "Resin Duck Call",
    internalCode: "DC-RES",
    category: "lathe-gifts",
    subcategory: "Other Lathe Items",
    shortDescription: "These calls are made from assorted resin blanks with a hand-tuned double reed insert. Currently sold out; more will return.",
    fullDescription: "All duck calls have a double reed insert that is hand tuned and a lanyard is included with each call. These calls are made from assorted resin blanks. Currently sold out; more will return.",
    price: 60,
    priceType: "fixed",
    status: "temporarily-unavailable",
    materials: ["Assorted resin", "Double reed insert"],
    finishes: ["Polished resin"],
    customizable: true,
    featured: false,
    images: [img(dcResImg, "Resin Duck Call handcrafted by Paul\'s Pens n Things", 360, 271)],
    tags: ["duck call", "lathe", "hunting"],
    occasions: ["Wedding", "Holiday", "Just because"],
    relatedProducts: ["p157", "p158", "p155"],
    seoTitle: "Resin Duck Call | Paul\'s Pens n Things",
    seoDescription: "All duck calls have a double reed insert that is hand tuned and a lanyard is included with each call. These calls are made from assorted resin blanks. Handcrafted in Paragould, Arkansas.",
  },
  {
    id: "p157",
    slug: "dc-wood-wood-duck-call",
    name: "Wood Duck Call",
    internalCode: "DC-WOOD",
    category: "lathe-gifts",
    subcategory: "Other Lathe Items",
    shortDescription: "These calls are made from assorted wood blanks and a copper ring, finished with CA to waterproof the outside.",
    fullDescription: "All duck calls have a double reed insert that is hand tuned and a lanyard is included with each call. These calls are made from assorted wood blanks and a copper ring. The wood is finished with CA to waterproof the outside.",
    price: 60,
    priceType: "fixed",
    status: "available",
    materials: ["Assorted hardwoods", "Copper ring", "Double reed insert"],
    finishes: ["CA waterproof finish"],
    customizable: true,
    featured: false,
    images: [img(dcWoodImg, "Wood Duck Call handcrafted by Paul\'s Pens n Things", 360, 271)],
    tags: ["duck call", "lathe", "hunting"],
    occasions: ["Wedding", "Holiday", "Just because"],
    relatedProducts: ["p158", "p159", "p156"],
    seoTitle: "Wood Duck Call | Paul\'s Pens n Things",
    seoDescription: "All duck calls have a double reed insert that is hand tuned and a lanyard is included with each call. These calls are made from assorted wood blanks and a copper ring. The wood is finished with CA to waterproof the outside. Handcrafted in Paragould, Arkansas.",
  },
  {
    id: "p158",
    slug: "cs1-purpleheart-corkscrew",
    name: "Purpleheart Corkscrew",
    internalCode: "CS1",
    category: "lathe-gifts",
    subcategory: "Other Lathe Items",
    shortDescription: "This T-handle corkscrew is made with purpleheart wood.",
    fullDescription: "This T-handle corkscrew is made with purpleheart wood.",
    price: 25,
    priceType: "fixed",
    status: "available",
    materials: ["Purpleheart"],
    finishes: ["Hand-rubbed finish"],
    customizable: true,
    featured: false,
    images: [img(cs1Img, "Purpleheart Corkscrew handcrafted by Paul\'s Pens n Things", 360, 271)],
    tags: ["corkscrew", "lathe", "kitchen"],
    occasions: ["Wedding", "Holiday", "Just because"],
    relatedProducts: ["p159", "p160", "p157"],
    seoTitle: "Purpleheart Corkscrew | Paul\'s Pens n Things",
    seoDescription: "This T-handle corkscrew is made with purpleheart wood. Handcrafted in Paragould, Arkansas.",
  },
  {
    id: "p159",
    slug: "cs2-t-handle-corkscrew",
    name: "T-Handle Corkscrew",
    internalCode: "CS2",
    category: "lathe-gifts",
    subcategory: "Other Lathe Items",
    shortDescription: "This T-handle corkscrew is made with an unknown wood.",
    fullDescription: "This T-handle corkscrew is made with an unknown wood.",
    price: 25,
    priceType: "fixed",
    status: "available",
    materials: ["Unknown hardwood"],
    finishes: ["Hand-rubbed finish"],
    customizable: true,
    featured: false,
    images: [img(cs2Img, "T-Handle Corkscrew handcrafted by Paul\'s Pens n Things", 360, 271)],
    tags: ["corkscrew", "lathe", "kitchen"],
    occasions: ["Wedding", "Holiday", "Just because"],
    relatedProducts: ["p160", "p161", "p158"],
    seoTitle: "T-Handle Corkscrew | Paul\'s Pens n Things",
    seoDescription: "This T-handle corkscrew is made with an unknown wood. Handcrafted in Paragould, Arkansas.",
  },
  {
    id: "p160",
    slug: "cs3-t-handle-corkscrew",
    name: "T-Handle Corkscrew",
    internalCode: "CS3",
    category: "lathe-gifts",
    subcategory: "Other Lathe Items",
    shortDescription: "This T-handle corkscrew is made with an unknown wood.",
    fullDescription: "This T-handle corkscrew is made with an unknown wood.",
    price: 25,
    priceType: "fixed",
    status: "available",
    materials: ["Unknown hardwood"],
    finishes: ["Hand-rubbed finish"],
    customizable: true,
    featured: false,
    images: [img(cs3Img, "T-Handle Corkscrew handcrafted by Paul\'s Pens n Things", 360, 271)],
    tags: ["corkscrew", "lathe", "kitchen"],
    occasions: ["Wedding", "Holiday", "Just because"],
    relatedProducts: ["p161", "p162", "p159"],
    seoTitle: "T-Handle Corkscrew | Paul\'s Pens n Things",
    seoDescription: "This T-handle corkscrew is made with an unknown wood. Handcrafted in Paragould, Arkansas.",
  },
  {
    id: "p161",
    featured: true,
    slug: "bs1-red-pink-bottle-stopper",
    name: "Red / Pink Bottle Stopper",
    internalCode: "BS1",
    category: "lathe-gifts",
    subcategory: "Other Lathe Items",
    shortDescription: "This bottle stopper has a red base and an embedded larger pink porcelain rose.",
    fullDescription: "This bottle stopper has a red base and an embedded larger pink porcelain rose.",
    price: 35,
    priceType: "fixed",
    status: "available",
    materials: ["Red resin base", "Porcelain rose"],
    finishes: ["Stainless stopper"],
    customizable: true,
    images: [img(bs1Img, "Red / Pink Bottle Stopper handcrafted by Paul\'s Pens n Things", 360, 480)],
    tags: ["bottle stopper", "lathe", "kitchen"],
    occasions: ["Wedding", "Holiday", "Just because"],
    relatedProducts: ["p162", "p163", "p160"],
    seoTitle: "Red / Pink Bottle Stopper | Paul\'s Pens n Things",
    seoDescription: "This bottle stopper has a red base and an embedded larger pink porcelain rose. Handcrafted in Paragould, Arkansas.",
  },
  {
    id: "p162",
    slug: "bs2-blue-blue-bottle-stopper",
    name: "Blue / Blue Bottle Stopper",
    internalCode: "BS2",
    category: "lathe-gifts",
    subcategory: "Other Lathe Items",
    shortDescription: "This bottle stopper has a blue base and an embedded smaller blue porcelain rose.",
    fullDescription: "This bottle stopper has a blue base and an embedded smaller blue porcelain rose.",
    price: 35,
    priceType: "fixed",
    status: "available",
    materials: ["Blue resin base", "Porcelain rose"],
    finishes: ["Stainless stopper"],
    customizable: true,
    featured: false,
    images: [img(bs2Img, "Blue / Blue Bottle Stopper handcrafted by Paul\'s Pens n Things", 360, 480)],
    tags: ["bottle stopper", "lathe", "kitchen"],
    occasions: ["Wedding", "Holiday", "Just because"],
    relatedProducts: ["p163", "p164", "p161"],
    seoTitle: "Blue / Blue Bottle Stopper | Paul\'s Pens n Things",
    seoDescription: "This bottle stopper has a blue base and an embedded smaller blue porcelain rose. Handcrafted in Paragould, Arkansas.",
  },
  {
    id: "p163",
    slug: "bs3-green-pink-bottle-stopper",
    name: "Green / Pink Bottle Stopper",
    internalCode: "BS3",
    category: "lathe-gifts",
    subcategory: "Other Lathe Items",
    shortDescription: "This bottle stopper has a green base and an embedded larger pink porcelain rose.",
    fullDescription: "This bottle stopper has a green base and an embedded larger pink porcelain rose.",
    price: 35,
    priceType: "fixed",
    status: "available",
    materials: ["Green resin base", "Porcelain rose"],
    finishes: ["Stainless stopper"],
    customizable: true,
    featured: false,
    images: [img(bs3Img, "Green / Pink Bottle Stopper handcrafted by Paul\'s Pens n Things", 360, 480)],
    tags: ["bottle stopper", "lathe", "kitchen"],
    occasions: ["Wedding", "Holiday", "Just because"],
    relatedProducts: ["p164", "p165", "p162"],
    seoTitle: "Green / Pink Bottle Stopper | Paul\'s Pens n Things",
    seoDescription: "This bottle stopper has a green base and an embedded larger pink porcelain rose. Handcrafted in Paragould, Arkansas.",
  },
  {
    id: "p164",
    slug: "bs4-gold-pink-bottle-stopper",
    name: "Gold / Pink Bottle Stopper",
    internalCode: "BS4",
    category: "lathe-gifts",
    subcategory: "Other Lathe Items",
    shortDescription: "This bottle stopper has a gold base and an embedded larger pink porcelain rose.",
    fullDescription: "This bottle stopper has a gold base and an embedded larger pink porcelain rose.",
    price: 35,
    priceType: "fixed",
    status: "available",
    materials: ["Gold base", "Porcelain rose"],
    finishes: ["Stainless stopper"],
    customizable: true,
    featured: false,
    images: [img(bs4Img, "Gold / Pink Bottle Stopper handcrafted by Paul\'s Pens n Things", 360, 480)],
    tags: ["bottle stopper", "lathe", "kitchen"],
    occasions: ["Wedding", "Holiday", "Just because"],
    relatedProducts: ["p165", "p166", "p163"],
    seoTitle: "Gold / Pink Bottle Stopper | Paul\'s Pens n Things",
    seoDescription: "This bottle stopper has a gold base and an embedded larger pink porcelain rose. Handcrafted in Paragould, Arkansas.",
  },
  {
    id: "p165",
    slug: "bs5-silver-blue-bottle-stopper",
    name: "Silver / Blue Bottle Stopper",
    internalCode: "BS5",
    category: "lathe-gifts",
    subcategory: "Other Lathe Items",
    shortDescription: "This bottle stopper has a silver base and an embedded smaller blue porcelain rose.",
    fullDescription: "This bottle stopper has a silver base and an embedded smaller blue porcelain rose.",
    price: 35,
    priceType: "fixed",
    status: "available",
    materials: ["Silver base", "Porcelain rose"],
    finishes: ["Stainless stopper"],
    customizable: true,
    featured: false,
    images: [img(bs5Img, "Silver / Blue Bottle Stopper handcrafted by Paul\'s Pens n Things", 360, 480)],
    tags: ["bottle stopper", "lathe", "kitchen"],
    occasions: ["Wedding", "Holiday", "Just because"],
    relatedProducts: ["p166", "p167", "p164"],
    seoTitle: "Silver / Blue Bottle Stopper | Paul\'s Pens n Things",
    seoDescription: "This bottle stopper has a silver base and an embedded smaller blue porcelain rose. Handcrafted in Paragould, Arkansas.",
  },
  {
    id: "p166",
    slug: "bsff1-gold-bottle-stopper-with-a-fishing-fly",
    name: "Gold Bottle Stopper with a Fishing Fly",
    internalCode: "BSFF1",
    category: "lathe-gifts",
    subcategory: "Other Lathe Items",
    shortDescription: "This bottle stopper has a gold base and an embedded fishing fly.",
    fullDescription: "This bottle stopper has a gold base and an embedded fishing fly.",
    price: 35,
    priceType: "fixed",
    status: "available",
    materials: ["Gold base", "Embedded fishing fly"],
    finishes: ["Stainless stopper"],
    customizable: true,
    featured: false,
    images: [img(bsff1Img, "Gold Bottle Stopper with a Fishing Fly handcrafted by Paul\'s Pens n Things", 360, 480)],
    tags: ["bottle stopper", "lathe", "fishing"],
    occasions: ["Wedding", "Holiday", "Just because"],
    relatedProducts: ["p167", "p168", "p165"],
    seoTitle: "Gold Bottle Stopper with a Fishing Fly | Paul\'s Pens n Things",
    seoDescription: "This bottle stopper has a gold base and an embedded fishing fly. Handcrafted in Paragould, Arkansas.",
  },
  {
    id: "p167",
    slug: "bsff2-gold-bottle-stopper-with-a-fishing-fly",
    name: "Gold Bottle Stopper with a Fishing Fly",
    internalCode: "BSFF2",
    category: "lathe-gifts",
    subcategory: "Other Lathe Items",
    shortDescription: "This bottle stopper has a gold base and an embedded fishing fly.",
    fullDescription: "This bottle stopper has a gold base and an embedded fishing fly.",
    price: 35,
    priceType: "fixed",
    status: "available",
    materials: ["Gold base", "Embedded fishing fly"],
    finishes: ["Stainless stopper"],
    customizable: true,
    featured: false,
    images: [img(bsff2Img, "Gold Bottle Stopper with a Fishing Fly handcrafted by Paul\'s Pens n Things", 360, 480)],
    tags: ["bottle stopper", "lathe", "fishing"],
    occasions: ["Wedding", "Holiday", "Just because"],
    relatedProducts: ["p168", "p169", "p166"],
    seoTitle: "Gold Bottle Stopper with a Fishing Fly | Paul\'s Pens n Things",
    seoDescription: "This bottle stopper has a gold base and an embedded fishing fly. Handcrafted in Paragould, Arkansas.",
  },
  {
    id: "p168",
    slug: "kr1-african-coral-wood-key-ring",
    name: "African Coral Wood Key Ring",
    internalCode: "KR1",
    category: "lathe-gifts",
    subcategory: "Other Lathe Items",
    shortDescription: "This key ring is made with african coral wood.",
    fullDescription: "This key ring is made with african coral wood. This piece has sold; Paul can make something similar in your own materials.",
    price: 10,
    priceType: "fixed",
    status: "previously-created",
    materials: ["African coral wood"],
    finishes: ["Hand-rubbed finish"],
    customizable: true,
    featured: false,
    images: [img(kr1Img, "African Coral Wood Key Ring handcrafted by Paul\'s Pens n Things", 360, 271)],
    tags: ["key ring", "lathe", "gift"],
    occasions: ["Wedding", "Holiday", "Just because"],
    relatedProducts: ["p169", "p170", "p167"],
    seoTitle: "African Coral Wood Key Ring | Paul\'s Pens n Things",
    seoDescription: "This key ring is made with african coral wood. Handcrafted in Paragould, Arkansas.",
  },
  {
    id: "p169",
    slug: "kr2-red-resin-key-ring",
    name: "Red Resin Key Ring",
    internalCode: "KR2",
    category: "lathe-gifts",
    subcategory: "Other Lathe Items",
    shortDescription: "This key ring is made with a red resin.",
    fullDescription: "This key ring is made with a red resin.",
    price: 10,
    priceType: "fixed",
    status: "available",
    materials: ["Red resin"],
    finishes: ["Polished resin"],
    customizable: true,
    featured: false,
    images: [img(kr2Img, "Red Resin Key Ring handcrafted by Paul\'s Pens n Things", 360, 271)],
    tags: ["key ring", "lathe", "gift"],
    occasions: ["Wedding", "Holiday", "Just because"],
    relatedProducts: ["p170", "p171", "p168"],
    seoTitle: "Red Resin Key Ring | Paul\'s Pens n Things",
    seoDescription: "This key ring is made with a red resin. Handcrafted in Paragould, Arkansas.",
  },
  {
    id: "p170",
    slug: "spm1-salt-pepper-mill",
    name: "Salt / Pepper Mill",
    internalCode: "SPM1",
    category: "lathe-gifts",
    subcategory: "Other Lathe Items",
    shortDescription: "This salt/pepper mill is made with unknown wood and has an adjustable grind.",
    fullDescription: "This salt/pepper mill is made with unknown wood. It has an adjustable grind to change the coarseness of the salt/pepper. This piece has sold; Paul can make something similar in your own materials.",
    price: 40,
    priceType: "fixed",
    status: "previously-created",
    materials: ["Unknown hardwood", "Adjustable grinder mechanism"],
    finishes: ["Hand-rubbed finish"],
    customizable: true,
    featured: false,
    images: [img(spm1Img, "Salt / Pepper Mill handcrafted by Paul\'s Pens n Things", 360, 271)],
    tags: ["salt pepper mill", "lathe", "kitchen"],
    occasions: ["Wedding", "Holiday", "Just because"],
    relatedProducts: ["p171", "p172", "p169"],
    seoTitle: "Salt / Pepper Mill | Paul\'s Pens n Things",
    seoDescription: "This salt/pepper mill is made with unknown wood. It has an adjustable grind to change the coarseness of the salt/pepper. Handcrafted in Paragould, Arkansas.",
  },
  {
    id: "p171",
    slug: "perf-1-perfume-atomizer-in-unknown-wood",
    name: "Perfume Atomizer in Unknown Wood",
    internalCode: "PERF-1",
    category: "lathe-gifts",
    subcategory: "Other Lathe Items",
    shortDescription: "This perfume atomizer is made to stand flat on a dresser or counter. The dropper is included.",
    fullDescription: "This perfume atomizer is made to stand flat on a dresser or counter. The dropper is included to transfer perfume from a bottle to the atomizer.",
    price: 25,
    priceType: "fixed",
    status: "available",
    materials: ["Unknown hardwood", "Glass atomizer"],
    finishes: ["Hand-rubbed finish"],
    customizable: true,
    featured: false,
    images: [img(perf1Img, "Perfume Atomizer in Unknown Wood handcrafted by Paul\'s Pens n Things", 360, 271)],
    tags: ["atomizer", "lathe", "gift"],
    occasions: ["Wedding", "Holiday", "Just because"],
    relatedProducts: ["p172", "p154", "p170"],
    seoTitle: "Perfume Atomizer in Unknown Wood | Paul\'s Pens n Things",
    seoDescription: "This perfume atomizer is made to stand flat on a dresser or counter. The dropper is included to transfer perfume from a bottle to the atomizer. Handcrafted in Paragould, Arkansas.",
  },
  {
    id: "p172",
    slug: "perf-2-perfume-atomizer-in-black-gold-resin",
    name: "Perfume Atomizer in Black & Gold Resin",
    internalCode: "PERF-2",
    category: "lathe-gifts",
    subcategory: "Other Lathe Items",
    shortDescription: "This perfume atomizer is made to stand flat on a dresser or counter. The body is made from black and gold resin.",
    fullDescription: "This perfume atomizer is made to stand flat on a dresser or counter. The dropper is included to transfer perfume from a bottle to the atomizer. The body is made from black and gold resin.",
    price: 25,
    priceType: "fixed",
    status: "available",
    materials: ["Black and gold resin", "Glass atomizer"],
    finishes: ["Polished resin"],
    customizable: true,
    featured: false,
    images: [img(perf2Img, "Perfume Atomizer in Black & Gold Resin handcrafted by Paul\'s Pens n Things", 360, 480)],
    tags: ["atomizer", "lathe", "gift"],
    occasions: ["Wedding", "Holiday", "Just because"],
    relatedProducts: ["p154", "p155", "p171"],
    seoTitle: "Perfume Atomizer in Black & Gold Resin | Paul\'s Pens n Things",
    seoDescription: "This perfume atomizer is made to stand flat on a dresser or counter. The dropper is included to transfer perfume from a bottle to the atomizer. The body is made from black and gold resin. Handcrafted in Paragould, Arkansas.",
  },
  {
    id: "p173",
    featured: true,
    slug: "mosaic-sign-pray",
    name: "Mosaic Sign — Pray",
    internalCode: "MS-PRAY",
    category: "cnc",
    subcategory: "Signs",
    shortDescription: "The engraving reads \"when in doubt, just pray\".",
    fullDescription: "The engraving reads \"when in doubt, just pray\". These 6 x 6 inch signs are made of 1/4 inch thick, two tone HDPE and are carved on a CNC router. The background and lettering colors can be red, green, blue, brown, yellow, black, or white. Yellow must be paired with black and all other colors are paired with white. Specify the color(s) desired.",
    price: 11,
    priceType: "fixed",
    status: "available",
    materials: ["Two-tone HDPE"],
    finishes: ["CNC carved"],
    customizable: true,
    images: [img(smPrayImg, "Mosaic Sign — Pray carved by Paul\'s Pens n Things", 360, 270)],
    tags: ["sign", "mosaic", "cnc"],
    occasions: ["Housewarming", "Holiday", "Just because"],
    relatedProducts: ["p174", "p175", "p196"],
    seoTitle: "Mosaic Sign — Pray | Paul\'s Pens n Things",
    seoDescription: "The engraving reads \"when in doubt, just pray\". CNC carved in Paragould, Arkansas.",
  },
  {
    id: "p174",
    slug: "mosaic-sign-fears",
    name: "Mosaic Sign — Fears",
    internalCode: "MS-FEARS",
    category: "cnc",
    subcategory: "Signs",
    shortDescription: "The engraving reads \"don't let fears decide your future\".",
    fullDescription: "The engraving reads \"don't let fears decide your future\". These 6 x 6 inch signs are made of 1/4 inch thick, two tone HDPE and are carved on a CNC router. The background and lettering colors can be red, green, blue, brown, yellow, black, or white. Yellow must be paired with black and all other colors are paired with white. Specify the color(s) desired.",
    price: 11,
    priceType: "fixed",
    status: "available",
    materials: ["Two-tone HDPE"],
    finishes: ["CNC carved"],
    customizable: true,
    featured: false,
    images: [img(smFearsImg, "Mosaic Sign — Fears carved by Paul\'s Pens n Things", 360, 270)],
    tags: ["sign", "mosaic", "cnc"],
    occasions: ["Housewarming", "Holiday", "Just because"],
    relatedProducts: ["p175", "p176", "p173"],
    seoTitle: "Mosaic Sign — Fears | Paul\'s Pens n Things",
    seoDescription: "The engraving reads \"don't let fears decide your future\". CNC carved in Paragould, Arkansas.",
  },
  {
    id: "p175",
    slug: "mosaic-sign-regret",
    name: "Mosaic Sign — Regret",
    internalCode: "MS-REGRET",
    category: "cnc",
    subcategory: "Signs",
    shortDescription: "The engraving reads \"in the end we only regret the chances we didn't take\".",
    fullDescription: "The engraving reads \"in the end we only regret the chances we didn't take\". These 6 x 6 inch signs are made of 1/4 inch thick, two tone HDPE and are carved on a CNC router. The background and lettering colors can be red, green, blue, brown, yellow, black, or white. Yellow must be paired with black and all other colors are paired with white. Specify the color(s) desired.",
    price: 11,
    priceType: "fixed",
    status: "available",
    materials: ["Two-tone HDPE"],
    finishes: ["CNC carved"],
    customizable: true,
    featured: false,
    images: [img(smRegretImg, "Mosaic Sign — Regret carved by Paul\'s Pens n Things", 360, 270)],
    tags: ["sign", "mosaic", "cnc"],
    occasions: ["Housewarming", "Holiday", "Just because"],
    relatedProducts: ["p176", "p177", "p174"],
    seoTitle: "Mosaic Sign — Regret | Paul\'s Pens n Things",
    seoDescription: "The engraving reads \"in the end we only regret the chances we didn't take\". CNC carved in Paragould, Arkansas.",
  },
  {
    id: "p176",
    slug: "mosaic-sign-be-on-your-guard",
    name: "Mosaic Sign — Be On Your Guard",
    internalCode: "MS-BEONYOURGUARD",
    category: "cnc",
    subcategory: "Signs",
    shortDescription: "This sign contains multiple engravings.",
    fullDescription: "This sign contains multiple engravings. These 6 x 6 inch signs are made of 1/4 inch thick, two tone HDPE and are carved on a CNC router. The background and lettering colors can be red, green, blue, brown, yellow, black, or white. Yellow must be paired with black and all other colors are paired with white. Specify the color(s) desired.",
    price: 11,
    priceType: "fixed",
    status: "available",
    materials: ["Two-tone HDPE"],
    finishes: ["CNC carved"],
    customizable: true,
    featured: false,
    images: [img(smBeOnYourGuardImg, "Mosaic Sign — Be On Your Guard carved by Paul\'s Pens n Things", 360, 270)],
    tags: ["sign", "mosaic", "cnc"],
    occasions: ["Housewarming", "Holiday", "Just because"],
    relatedProducts: ["p177", "p178", "p175"],
    seoTitle: "Mosaic Sign — Be On Your Guard | Paul\'s Pens n Things",
    seoDescription: "This sign contains multiple engravings. CNC carved in Paragould, Arkansas.",
  },
  {
    id: "p177",
    slug: "mosaic-sign-power-of-god",
    name: "Mosaic Sign — Power of God",
    internalCode: "MS-POWEROFGOD",
    category: "cnc",
    subcategory: "Signs",
    shortDescription: "This engraving refers to the Power of God.",
    fullDescription: "This engraving refers to the Power of God. These 6 x 6 inch signs are made of 1/4 inch thick, two tone HDPE and are carved on a CNC router. The background and lettering colors can be red, green, blue, brown, yellow, black, or white. Yellow must be paired with black and all other colors are paired with white. Specify the color(s) desired.",
    price: 11,
    priceType: "fixed",
    status: "available",
    materials: ["Two-tone HDPE"],
    finishes: ["CNC carved"],
    customizable: true,
    featured: false,
    images: [img(smPowerOfGodImg, "Mosaic Sign — Power of God carved by Paul\'s Pens n Things", 360, 270)],
    tags: ["sign", "mosaic", "cnc"],
    occasions: ["Housewarming", "Holiday", "Just because"],
    relatedProducts: ["p178", "p179", "p176"],
    seoTitle: "Mosaic Sign — Power of God | Paul\'s Pens n Things",
    seoDescription: "This engraving refers to the Power of God. CNC carved in Paragould, Arkansas.",
  },
  {
    id: "p178",
    slug: "mosaic-sign-journey",
    name: "Mosaic Sign — Journey",
    internalCode: "MS-JOURNEY",
    category: "cnc",
    subcategory: "Signs",
    shortDescription: "The engraving indicates it is the journey that makes you strong.",
    fullDescription: "The engraving indicates it is the journey that makes you strong. These 6 x 6 inch signs are made of 1/4 inch thick, two tone HDPE and are carved on a CNC router. The background and lettering colors can be red, green, blue, brown, yellow, black, or white. Yellow must be paired with black and all other colors are paired with white. Specify the color(s) desired.",
    price: 11,
    priceType: "fixed",
    status: "available",
    materials: ["Two-tone HDPE"],
    finishes: ["CNC carved"],
    customizable: true,
    featured: false,
    images: [img(smJourneyImg, "Mosaic Sign — Journey carved by Paul\'s Pens n Things", 360, 270)],
    tags: ["sign", "mosaic", "cnc"],
    occasions: ["Housewarming", "Holiday", "Just because"],
    relatedProducts: ["p179", "p180", "p177"],
    seoTitle: "Mosaic Sign — Journey | Paul\'s Pens n Things",
    seoDescription: "The engraving indicates it is the journey that makes you strong. CNC carved in Paragould, Arkansas.",
  },
  {
    id: "p179",
    slug: "mosaic-sign-cares",
    name: "Mosaic Sign — Cares",
    internalCode: "MS-CARES",
    category: "cnc",
    subcategory: "Signs",
    shortDescription: "This engraving asks us to cast your cares on the Lord.",
    fullDescription: "This engraving asks us to cast your cares on the Lord. These 6 x 6 inch signs are made of 1/4 inch thick, two tone HDPE and are carved on a CNC router. The background and lettering colors can be red, green, blue, brown, yellow, black, or white. Yellow must be paired with black and all other colors are paired with white. Specify the color(s) desired.",
    price: 11,
    priceType: "fixed",
    status: "available",
    materials: ["Two-tone HDPE"],
    finishes: ["CNC carved"],
    customizable: true,
    featured: false,
    images: [img(smCaresImg, "Mosaic Sign — Cares carved by Paul\'s Pens n Things", 360, 270)],
    tags: ["sign", "mosaic", "cnc"],
    occasions: ["Housewarming", "Holiday", "Just because"],
    relatedProducts: ["p180", "p181", "p178"],
    seoTitle: "Mosaic Sign — Cares | Paul\'s Pens n Things",
    seoDescription: "This engraving asks us to cast your cares on the Lord. CNC carved in Paragould, Arkansas.",
  },
  {
    id: "p180",
    slug: "mosaic-sign-righteousness",
    name: "Mosaic Sign — Righteousness",
    internalCode: "MS-RIGHTEOUSNESS",
    category: "cnc",
    subcategory: "Signs",
    shortDescription: "The engraving reads \"righteousness guards the man of integrity\".",
    fullDescription: "The engraving reads \"righteousness guards the man of integrity\". These 6 x 6 inch signs are made of 1/4 inch thick, two tone HDPE and are carved on a CNC router. The background and lettering colors can be red, green, blue, brown, yellow, black, or white. Yellow must be paired with black and all other colors are paired with white. Specify the color(s) desired.",
    price: 11,
    priceType: "fixed",
    status: "available",
    materials: ["Two-tone HDPE"],
    finishes: ["CNC carved"],
    customizable: true,
    featured: false,
    images: [img(smRighteousnessImg, "Mosaic Sign — Righteousness carved by Paul\'s Pens n Things", 360, 270)],
    tags: ["sign", "mosaic", "cnc"],
    occasions: ["Housewarming", "Holiday", "Just because"],
    relatedProducts: ["p181", "p182", "p179"],
    seoTitle: "Mosaic Sign — Righteousness | Paul\'s Pens n Things",
    seoDescription: "The engraving reads \"righteousness guards the man of integrity\". CNC carved in Paragould, Arkansas.",
  },
  {
    id: "p181",
    slug: "mosaic-sign-stars",
    name: "Mosaic Sign — Stars",
    internalCode: "MS-STARS",
    category: "cnc",
    subcategory: "Signs",
    shortDescription: "The engraving tells us that we are all stars. It is best shown with yellow lettering.",
    fullDescription: "The engraving tells us that we are all stars. It is best shown with yellow lettering. These 6 x 6 inch signs are made of 1/4 inch thick, two tone HDPE and are carved on a CNC router. The background and lettering colors can be red, green, blue, brown, yellow, black, or white. Yellow must be paired with black and all other colors are paired with white. Specify the color(s) desired.",
    price: 11,
    priceType: "fixed",
    status: "available",
    materials: ["Two-tone HDPE"],
    finishes: ["CNC carved"],
    customizable: true,
    featured: false,
    images: [img(smStarsImg, "Mosaic Sign — Stars carved by Paul\'s Pens n Things", 360, 270)],
    tags: ["sign", "mosaic", "cnc"],
    occasions: ["Housewarming", "Holiday", "Just because"],
    relatedProducts: ["p182", "p183", "p180"],
    seoTitle: "Mosaic Sign — Stars | Paul\'s Pens n Things",
    seoDescription: "The engraving tells us that we are all stars. It is best shown with yellow lettering. CNC carved in Paragould, Arkansas.",
  },
  {
    id: "p182",
    slug: "mosaic-sign-grow-through",
    name: "Mosaic Sign — Grow Through",
    internalCode: "MS-GROWTHROUGH",
    category: "cnc",
    subcategory: "Signs",
    shortDescription: "The engraving reads \"grow through what you go through\".",
    fullDescription: "The engraving reads \"grow through what you go through\". These 6 x 6 inch signs are made of 1/4 inch thick, two tone HDPE and are carved on a CNC router. The background and lettering colors can be red, green, blue, brown, yellow, black, or white. Yellow must be paired with black and all other colors are paired with white. Specify the color(s) desired.",
    price: 11,
    priceType: "fixed",
    status: "available",
    materials: ["Two-tone HDPE"],
    finishes: ["CNC carved"],
    customizable: true,
    featured: false,
    images: [img(smGrowThroughImg, "Mosaic Sign — Grow Through carved by Paul\'s Pens n Things", 360, 270)],
    tags: ["sign", "mosaic", "cnc"],
    occasions: ["Housewarming", "Holiday", "Just because"],
    relatedProducts: ["p183", "p184", "p181"],
    seoTitle: "Mosaic Sign — Grow Through | Paul\'s Pens n Things",
    seoDescription: "The engraving reads \"grow through what you go through\". CNC carved in Paragould, Arkansas.",
  },
  {
    id: "p183",
    slug: "mosaic-sign-awesome",
    name: "Mosaic Sign — Awesome",
    internalCode: "MS-AWESOME",
    category: "cnc",
    subcategory: "Signs",
    shortDescription: "The engraving reminds us to be awesome.",
    fullDescription: "The engraving reminds us to be awesome. These 6 x 6 inch signs are made of 1/4 inch thick, two tone HDPE and are carved on a CNC router. The background and lettering colors can be red, green, blue, brown, yellow, black, or white. Yellow must be paired with black and all other colors are paired with white. Specify the color(s) desired.",
    price: 11,
    priceType: "fixed",
    status: "available",
    materials: ["Two-tone HDPE"],
    finishes: ["CNC carved"],
    customizable: true,
    featured: false,
    images: [img(smAwesomeImg, "Mosaic Sign — Awesome carved by Paul\'s Pens n Things", 360, 270)],
    tags: ["sign", "mosaic", "cnc"],
    occasions: ["Housewarming", "Holiday", "Just because"],
    relatedProducts: ["p184", "p185", "p182"],
    seoTitle: "Mosaic Sign — Awesome | Paul\'s Pens n Things",
    seoDescription: "The engraving reminds us to be awesome. CNC carved in Paragould, Arkansas.",
  },
  {
    id: "p184",
    slug: "mosaic-sign-path",
    name: "Mosaic Sign — Path",
    internalCode: "MS-PATH",
    category: "cnc",
    subcategory: "Signs",
    shortDescription: "This engraving tells us we may all be on a different path.",
    fullDescription: "This engraving tells us we may all be on a different path. These 6 x 6 inch signs are made of 1/4 inch thick, two tone HDPE and are carved on a CNC router. The background and lettering colors can be red, green, blue, brown, yellow, black, or white. Yellow must be paired with black and all other colors are paired with white. Specify the color(s) desired.",
    price: 11,
    priceType: "fixed",
    status: "available",
    materials: ["Two-tone HDPE"],
    finishes: ["CNC carved"],
    customizable: true,
    featured: false,
    images: [img(smPathImg, "Mosaic Sign — Path carved by Paul\'s Pens n Things", 360, 270)],
    tags: ["sign", "mosaic", "cnc"],
    occasions: ["Housewarming", "Holiday", "Just because"],
    relatedProducts: ["p185", "p186", "p183"],
    seoTitle: "Mosaic Sign — Path | Paul\'s Pens n Things",
    seoDescription: "This engraving tells us we may all be on a different path. CNC carved in Paragould, Arkansas.",
  },
  {
    id: "p185",
    slug: "mosaic-sign-hope",
    name: "Mosaic Sign — Hope",
    internalCode: "MS-HOPE",
    category: "cnc",
    subcategory: "Signs",
    shortDescription: "The engraving reminds us to hold on to our hope.",
    fullDescription: "The engraving reminds us to hold on to our hope. These 6 x 6 inch signs are made of 1/4 inch thick, two tone HDPE and are carved on a CNC router. The background and lettering colors can be red, green, blue, brown, yellow, black, or white. Yellow must be paired with black and all other colors are paired with white. Specify the color(s) desired.",
    price: 11,
    priceType: "fixed",
    status: "available",
    materials: ["Two-tone HDPE"],
    finishes: ["CNC carved"],
    customizable: true,
    featured: false,
    images: [img(smHopeImg, "Mosaic Sign — Hope carved by Paul\'s Pens n Things", 360, 270)],
    tags: ["sign", "mosaic", "cnc"],
    occasions: ["Housewarming", "Holiday", "Just because"],
    relatedProducts: ["p186", "p187", "p184"],
    seoTitle: "Mosaic Sign — Hope | Paul\'s Pens n Things",
    seoDescription: "The engraving reminds us to hold on to our hope. CNC carved in Paragould, Arkansas.",
  },
  {
    id: "p186",
    slug: "mosaic-sign-christ",
    name: "Mosaic Sign — Christ",
    internalCode: "MS-CHRIST",
    category: "cnc",
    subcategory: "Signs",
    shortDescription: "The engraving tells us who gives us strength.",
    fullDescription: "The engraving tells us who gives us strength. These 6 x 6 inch signs are made of 1/4 inch thick, two tone HDPE and are carved on a CNC router. The background and lettering colors can be red, green, blue, brown, yellow, black, or white. Yellow must be paired with black and all other colors are paired with white. Specify the color(s) desired.",
    price: 11,
    priceType: "fixed",
    status: "available",
    materials: ["Two-tone HDPE"],
    finishes: ["CNC carved"],
    customizable: true,
    featured: false,
    images: [img(smChristImg, "Mosaic Sign — Christ carved by Paul\'s Pens n Things", 360, 270)],
    tags: ["sign", "mosaic", "cnc"],
    occasions: ["Housewarming", "Holiday", "Just because"],
    relatedProducts: ["p187", "p188", "p185"],
    seoTitle: "Mosaic Sign — Christ | Paul\'s Pens n Things",
    seoDescription: "The engraving tells us who gives us strength. CNC carved in Paragould, Arkansas.",
  },
  {
    id: "p187",
    slug: "wood-sign-lucky",
    name: "Wood Sign — Lucky",
    internalCode: "WS-LUCKY",
    category: "cnc",
    subcategory: "Signs",
    shortDescription: "The engraving reads \"look around at how lucky we are to be alive right now\". It is about 9 by 11 inches in size.",
    fullDescription: "The engraving reads \"look around at how lucky we are to be alive right now\". It is about 9 by 11 inches in size. Except as noted, these signs have been stained prior to cutting on a CNC router.",
    price: 27,
    priceType: "fixed",
    status: "available",
    materials: ["Stained hardwood"],
    finishes: ["CNC carved"],
    customizable: true,
    featured: false,
    images: [img(swLuckyImg, "Wood Sign — Lucky carved by Paul\'s Pens n Things", 360, 270)],
    tags: ["sign", "wood", "cnc"],
    occasions: ["Housewarming", "Holiday", "Just because"],
    relatedProducts: ["p188", "p189", "p186"],
    seoTitle: "Wood Sign — Lucky | Paul\'s Pens n Things",
    seoDescription: "The engraving reads \"look around at how lucky we are to be alive right now\". It is about 9 by 11 inches in size. CNC carved in Paragould, Arkansas.",
  },
  {
    id: "p188",
    slug: "wood-sign-christ",
    name: "Wood Sign — Christ",
    internalCode: "WS-CHRIST",
    category: "cnc",
    subcategory: "Signs",
    shortDescription: "This 6 by 12 inch sign tells us who strengthens us.",
    fullDescription: "This 6 by 12 inch sign tells us who strengthens us. Except as noted, these signs have been stained prior to cutting on a CNC router.",
    price: 20,
    priceType: "fixed",
    status: "available",
    materials: ["Stained hardwood"],
    finishes: ["CNC carved"],
    customizable: true,
    featured: false,
    images: [img(swChristImg, "Wood Sign — Christ carved by Paul\'s Pens n Things", 360, 270)],
    tags: ["sign", "wood", "cnc"],
    occasions: ["Housewarming", "Holiday", "Just because"],
    relatedProducts: ["p189", "p190", "p187"],
    seoTitle: "Wood Sign — Christ | Paul\'s Pens n Things",
    seoDescription: "This 6 by 12 inch sign tells us who strengthens us. CNC carved in Paragould, Arkansas.",
  },
  {
    id: "p189",
    slug: "wood-sign-ask",
    name: "Wood Sign — Ask",
    internalCode: "WS-ASK",
    category: "cnc",
    subcategory: "Signs",
    shortDescription: "This 6 by 12 inch sign reads \"ask, and it will be given to you\".",
    fullDescription: "This 6 by 12 inch sign reads \"ask, and it will be given to you\". Except as noted, these signs have been stained prior to cutting on a CNC router.",
    price: 20,
    priceType: "fixed",
    status: "available",
    materials: ["Stained hardwood"],
    finishes: ["CNC carved"],
    customizable: true,
    featured: false,
    images: [img(swAskImg, "Wood Sign — Ask carved by Paul\'s Pens n Things", 360, 270)],
    tags: ["sign", "wood", "cnc"],
    occasions: ["Housewarming", "Holiday", "Just because"],
    relatedProducts: ["p190", "p191", "p188"],
    seoTitle: "Wood Sign — Ask | Paul\'s Pens n Things",
    seoDescription: "This 6 by 12 inch sign reads \"ask, and it will be given to you\". CNC carved in Paragould, Arkansas.",
  },
  {
    id: "p190",
    slug: "wood-sign-wise-men",
    name: "Wood Sign — Wise Men",
    internalCode: "WS-WISEMEN",
    category: "cnc",
    subcategory: "Signs",
    shortDescription: "This 6 by 12 inch sign tells us \"wise men still seek him\".",
    fullDescription: "This 6 by 12 inch sign tells us \"wise men still seek him\". Except as noted, these signs have been stained prior to cutting on a CNC router.",
    price: 20,
    priceType: "fixed",
    status: "available",
    materials: ["Stained hardwood"],
    finishes: ["CNC carved"],
    customizable: true,
    featured: false,
    images: [img(swWiseMenImg, "Wood Sign — Wise Men carved by Paul\'s Pens n Things", 360, 270)],
    tags: ["sign", "wood", "cnc"],
    occasions: ["Housewarming", "Holiday", "Just because"],
    relatedProducts: ["p191", "p192", "p189"],
    seoTitle: "Wood Sign — Wise Men | Paul\'s Pens n Things",
    seoDescription: "This 6 by 12 inch sign tells us \"wise men still seek him\". CNC carved in Paragould, Arkansas.",
  },
  {
    id: "p191",
    slug: "wood-sign-life-is-tough",
    name: "Wood Sign — Life Is Tough",
    internalCode: "WS-LIFEISTOUGH",
    category: "cnc",
    subcategory: "Signs",
    shortDescription: "This 6 by 12 inch sign tells us \"life is tough, God is tougher\".",
    fullDescription: "This 6 by 12 inch sign tells us \"life is tough, God is tougher\". Except as noted, these signs have been stained prior to cutting on a CNC router.",
    price: 20,
    priceType: "fixed",
    status: "available",
    materials: ["Stained hardwood"],
    finishes: ["CNC carved"],
    customizable: true,
    featured: false,
    images: [img(swLifeIsToughImg, "Wood Sign — Life Is Tough carved by Paul\'s Pens n Things", 360, 270)],
    tags: ["sign", "wood", "cnc"],
    occasions: ["Housewarming", "Holiday", "Just because"],
    relatedProducts: ["p192", "p193", "p190"],
    seoTitle: "Wood Sign — Life Is Tough | Paul\'s Pens n Things",
    seoDescription: "This 6 by 12 inch sign tells us \"life is tough, God is tougher\". CNC carved in Paragould, Arkansas.",
  },
  {
    id: "p192",
    slug: "wood-sign-be-on-your-guard",
    name: "Wood Sign — Be On Your Guard",
    internalCode: "WS-BEONYOURGUARD",
    category: "cnc",
    subcategory: "Signs",
    shortDescription: "This 6 by 12 inch sign tells us to be on your guard.",
    fullDescription: "This 6 by 12 inch sign tells us to be on your guard. Except as noted, these signs have been stained prior to cutting on a CNC router.",
    price: 20,
    priceType: "fixed",
    status: "available",
    materials: ["Stained hardwood"],
    finishes: ["CNC carved"],
    customizable: true,
    featured: false,
    images: [img(swBeOnYourGuardImg, "Wood Sign — Be On Your Guard carved by Paul\'s Pens n Things", 360, 270)],
    tags: ["sign", "wood", "cnc"],
    occasions: ["Housewarming", "Holiday", "Just because"],
    relatedProducts: ["p193", "p194", "p191"],
    seoTitle: "Wood Sign — Be On Your Guard | Paul\'s Pens n Things",
    seoDescription: "This 6 by 12 inch sign tells us to be on your guard. CNC carved in Paragould, Arkansas.",
  },
  {
    id: "p193",
    slug: "wood-sign-righteousness",
    name: "Wood Sign — Righteousness",
    internalCode: "WS-RIGHTEOUSNESS",
    category: "cnc",
    subcategory: "Signs",
    shortDescription: "This 6 by 12 inch sign tells us \"righteousness guards the man of integrity\".",
    fullDescription: "This 6 by 12 inch sign tells us \"righteousness guards the man of integrity\". Except as noted, these signs have been stained prior to cutting on a CNC router.",
    price: 20,
    priceType: "fixed",
    status: "available",
    materials: ["Stained hardwood"],
    finishes: ["CNC carved"],
    customizable: true,
    featured: false,
    images: [img(swRighteousnessImg, "Wood Sign — Righteousness carved by Paul\'s Pens n Things", 360, 270)],
    tags: ["sign", "wood", "cnc"],
    occasions: ["Housewarming", "Holiday", "Just because"],
    relatedProducts: ["p194", "p195", "p192"],
    seoTitle: "Wood Sign — Righteousness | Paul\'s Pens n Things",
    seoDescription: "This 6 by 12 inch sign tells us \"righteousness guards the man of integrity\". CNC carved in Paragould, Arkansas.",
  },
  {
    id: "p194",
    slug: "wood-sign-power-of-god",
    name: "Wood Sign — Power of God",
    internalCode: "WS-POWEROFGOD",
    category: "cnc",
    subcategory: "Signs",
    shortDescription: "This 6 by 12 inch sign tells us about the power of God.",
    fullDescription: "This 6 by 12 inch sign tells us about the power of God. Except as noted, these signs have been stained prior to cutting on a CNC router.",
    price: 20,
    priceType: "fixed",
    status: "available",
    materials: ["Stained hardwood"],
    finishes: ["CNC carved"],
    customizable: true,
    featured: false,
    images: [img(swPowerOfGodImg, "Wood Sign — Power of God carved by Paul\'s Pens n Things", 360, 270)],
    tags: ["sign", "wood", "cnc"],
    occasions: ["Housewarming", "Holiday", "Just because"],
    relatedProducts: ["p195", "p196", "p193"],
    seoTitle: "Wood Sign — Power of God | Paul\'s Pens n Things",
    seoDescription: "This 6 by 12 inch sign tells us about the power of God. CNC carved in Paragould, Arkansas.",
  },
  {
    id: "p195",
    slug: "wood-sign-journey",
    name: "Wood Sign — Journey",
    internalCode: "WS-JOURNEY",
    category: "cnc",
    subcategory: "Signs",
    shortDescription: "This 6 by 12 inch sign tells us the journey makes us strong.",
    fullDescription: "This 6 by 12 inch sign tells us the journey makes us strong. Except as noted, these signs have been stained prior to cutting on a CNC router.",
    price: 20,
    priceType: "fixed",
    status: "available",
    materials: ["Stained hardwood"],
    finishes: ["CNC carved"],
    customizable: true,
    featured: false,
    images: [img(swJourneyImg, "Wood Sign — Journey carved by Paul\'s Pens n Things", 360, 270)],
    tags: ["sign", "wood", "cnc"],
    occasions: ["Housewarming", "Holiday", "Just because"],
    relatedProducts: ["p196", "p173", "p194"],
    seoTitle: "Wood Sign — Journey | Paul\'s Pens n Things",
    seoDescription: "This 6 by 12 inch sign tells us the journey makes us strong. CNC carved in Paragould, Arkansas.",
  },
  {
    id: "p196",
    slug: "wood-sign-fishing",
    name: "Wood Sign — Fishing",
    internalCode: "WS-FISHING",
    category: "cnc",
    subcategory: "Signs",
    shortDescription: "This 6 by 12 inch sign reads \"I'd rather be fishing\". The engraving has been painted black.",
    fullDescription: "This 6 by 12 inch sign reads \"I'd rather be fishing\". The engraving has been painted black. Except as noted, these signs have been stained prior to cutting on a CNC router.",
    price: 20,
    priceType: "fixed",
    status: "available",
    materials: ["Stained hardwood"],
    finishes: ["CNC carved"],
    customizable: true,
    featured: false,
    images: [img(swFishingImg, "Wood Sign — Fishing carved by Paul\'s Pens n Things", 360, 270)],
    tags: ["sign", "wood", "cnc"],
    occasions: ["Housewarming", "Holiday", "Just because"],
    relatedProducts: ["p173", "p174", "p195"],
    seoTitle: "Wood Sign — Fishing | Paul\'s Pens n Things",
    seoDescription: "This 6 by 12 inch sign reads \"I'd rather be fishing\". The engraving has been painted black. CNC carved in Paragould, Arkansas.",
  },
  {
    id: "p197",
    slug: "biohazard-spinner",
    name: "Fidget Spinner — Biohazard Symbol",
    internalCode: "FS-BIOHAZARD",
    category: "cnc",
    subcategory: "Fidget Spinners",
    shortDescription: "This spinner is in the shape of the biohazard symbol and is the largest of the spinners. The counterweights are ball bearings.",
    fullDescription: "This spinner is in the shape of the biohazard symbol and is the largest of the spinners. The counterweights are ball bearings. These fidget spinners are cut on a CNC router from a blank of two tone HDPE. There is a ball bearing at the center and counter weights surrounding it. They come in red, green, blue, yellow, brown, black, and white. Yellow must be paired with black and all other colors are paired with white. Specify the color(s) desired.",
    price: 10,
    priceType: "fixed",
    status: "available",
    materials: ["Two-tone HDPE", "Ball bearings"],
    finishes: ["CNC routed"],
    customizable: true,
    featured: false,
    images: [img(spinnerBiohazardImg, "Fidget Spinner — Biohazard Symbol cut by Paul\'s Pens n Things", 360, 270)],
    tags: ["fidget spinner", "hdpe", "cnc"],
    occasions: ["Birthday", "Stocking stuffer", "Just because"],
    relatedProducts: ["p198", "p199", "p200"],
    seoTitle: "Fidget Spinner — Biohazard Symbol | Paul\'s Pens n Things",
    seoDescription: "This spinner is in the shape of the biohazard symbol and is the largest of the spinners. The counterweights are ball bearings. CNC routed in Paragould, Arkansas.",
  },
  {
    id: "p198",
    slug: "small-fidget-spinner",
    name: "Fidget Spinner — Small",
    internalCode: "FS-SMALL",
    category: "cnc",
    subcategory: "Fidget Spinners",
    shortDescription: "This spinner is smaller for small hands.",
    fullDescription: "This spinner is smaller for small hands. These fidget spinners are cut on a CNC router from a blank of two tone HDPE. There is a ball bearing at the center and counter weights surrounding it. They come in red, green, blue, yellow, brown, black, and white. Yellow must be paired with black and all other colors are paired with white. Specify the color(s) desired.",
    price: 6,
    priceType: "fixed",
    status: "available",
    materials: ["Two-tone HDPE", "Ball bearings"],
    finishes: ["CNC routed"],
    customizable: true,
    featured: false,
    images: [img(spinnerSmallImg, "Fidget Spinner — Small cut by Paul\'s Pens n Things", 360, 270)],
    tags: ["fidget spinner", "hdpe", "cnc"],
    occasions: ["Birthday", "Stocking stuffer", "Just because"],
    relatedProducts: ["p199", "p200", "p201"],
    seoTitle: "Fidget Spinner — Small | Paul\'s Pens n Things",
    seoDescription: "This spinner is smaller for small hands. CNC routed in Paragould, Arkansas.",
  },
  {
    id: "p199",
    featured: true,
    slug: "yin-yang-spinner",
    name: "Fidget Spinner — Yin Yang",
    internalCode: "FS-YINYANG",
    category: "cnc",
    subcategory: "Fidget Spinners",
    shortDescription: "This spinner will be in black and white only.",
    fullDescription: "This spinner will be in black and white only. These fidget spinners are cut on a CNC router from a blank of two tone HDPE. There is a ball bearing at the center and counter weights surrounding it. They come in red, green, blue, yellow, brown, black, and white. Yellow must be paired with black and all other colors are paired with white. Specify the color(s) desired.",
    price: 7,
    priceType: "fixed",
    status: "available",
    materials: ["Two-tone HDPE", "Ball bearings"],
    finishes: ["CNC routed"],
    customizable: true,
    images: [img(spinnerYinYangImg, "Fidget Spinner — Yin Yang cut by Paul\'s Pens n Things", 360, 270)],
    tags: ["fidget spinner", "hdpe", "cnc"],
    occasions: ["Birthday", "Stocking stuffer", "Just because"],
    relatedProducts: ["p200", "p201", "p202"],
    seoTitle: "Fidget Spinner — Yin Yang | Paul\'s Pens n Things",
    seoDescription: "This spinner will be in black and white only. CNC routed in Paragould, Arkansas.",
  },
  {
    id: "p200",
    slug: "mandala-spinner",
    name: "Fidget Spinner — Mandala",
    internalCode: "FS-MANDALA",
    category: "cnc",
    subcategory: "Fidget Spinners",
    shortDescription: "This spinner will be white with colored grooves.",
    fullDescription: "This spinner will be white with colored grooves. These fidget spinners are cut on a CNC router from a blank of two tone HDPE. There is a ball bearing at the center and counter weights surrounding it. They come in red, green, blue, yellow, brown, black, and white. Yellow must be paired with black and all other colors are paired with white. Specify the color(s) desired.",
    price: 7,
    priceType: "fixed",
    status: "available",
    materials: ["Two-tone HDPE", "Ball bearings"],
    finishes: ["CNC routed"],
    customizable: true,
    featured: false,
    images: [img(spinnerMandalaImg, "Fidget Spinner — Mandala cut by Paul\'s Pens n Things", 360, 270)],
    tags: ["fidget spinner", "hdpe", "cnc"],
    occasions: ["Birthday", "Stocking stuffer", "Just because"],
    relatedProducts: ["p201", "p202", "p203"],
    seoTitle: "Fidget Spinner — Mandala | Paul\'s Pens n Things",
    seoDescription: "This spinner will be white with colored grooves. CNC routed in Paragould, Arkansas.",
  },
  {
    id: "p201",
    slug: "hex-pattern-spinner",
    name: "Fidget Spinner — Hex Pattern",
    internalCode: "FS-HEX",
    category: "cnc",
    subcategory: "Fidget Spinners",
    shortDescription: "This spinner will be white with colored grooves.",
    fullDescription: "This spinner will be white with colored grooves. These fidget spinners are cut on a CNC router from a blank of two tone HDPE. There is a ball bearing at the center and counter weights surrounding it. They come in red, green, blue, yellow, brown, black, and white. Yellow must be paired with black and all other colors are paired with white. Specify the color(s) desired.",
    price: 7,
    priceType: "fixed",
    status: "available",
    materials: ["Two-tone HDPE", "Ball bearings"],
    finishes: ["CNC routed"],
    customizable: true,
    featured: false,
    images: [img(spinnerHexImg, "Fidget Spinner — Hex Pattern cut by Paul\'s Pens n Things", 360, 270)],
    tags: ["fidget spinner", "hdpe", "cnc"],
    occasions: ["Birthday", "Stocking stuffer", "Just because"],
    relatedProducts: ["p202", "p203", "p204"],
    seoTitle: "Fidget Spinner — Hex Pattern | Paul\'s Pens n Things",
    seoDescription: "This spinner will be white with colored grooves. CNC routed in Paragould, Arkansas.",
  },
  {
    id: "p202",
    slug: "lol-spinner",
    name: "Fidget Spinner — LOL",
    internalCode: "FS-LOL",
    category: "cnc",
    subcategory: "Fidget Spinners",
    shortDescription: "This spinner will be white with colored grooves.",
    fullDescription: "This spinner will be white with colored grooves. These fidget spinners are cut on a CNC router from a blank of two tone HDPE. There is a ball bearing at the center and counter weights surrounding it. They come in red, green, blue, yellow, brown, black, and white. Yellow must be paired with black and all other colors are paired with white. Specify the color(s) desired.",
    price: 7,
    priceType: "fixed",
    status: "available",
    materials: ["Two-tone HDPE", "Ball bearings"],
    finishes: ["CNC routed"],
    customizable: true,
    featured: false,
    images: [img(spinnerLolImg, "Fidget Spinner — LOL cut by Paul\'s Pens n Things", 360, 270)],
    tags: ["fidget spinner", "hdpe", "cnc"],
    occasions: ["Birthday", "Stocking stuffer", "Just because"],
    relatedProducts: ["p203", "p204", "p205"],
    seoTitle: "Fidget Spinner — LOL | Paul\'s Pens n Things",
    seoDescription: "This spinner will be white with colored grooves. CNC routed in Paragould, Arkansas.",
  },
  {
    id: "p203",
    slug: "star-spinner-with-groove",
    name: "Fidget Spinner — Star with Groove",
    internalCode: "FS-STAR-G",
    category: "cnc",
    subcategory: "Fidget Spinners",
    shortDescription: "This spinner will be white with colored grooves.",
    fullDescription: "This spinner will be white with colored grooves. These fidget spinners are cut on a CNC router from a blank of two tone HDPE. There is a ball bearing at the center and counter weights surrounding it. They come in red, green, blue, yellow, brown, black, and white. Yellow must be paired with black and all other colors are paired with white. Specify the color(s) desired.",
    price: 7,
    priceType: "fixed",
    status: "available",
    materials: ["Two-tone HDPE", "Ball bearings"],
    finishes: ["CNC routed"],
    customizable: true,
    featured: false,
    images: [img(spinnerStarGrooveImg, "Fidget Spinner — Star with Groove cut by Paul\'s Pens n Things", 360, 270)],
    tags: ["fidget spinner", "hdpe", "cnc"],
    occasions: ["Birthday", "Stocking stuffer", "Just because"],
    relatedProducts: ["p204", "p205", "p206"],
    seoTitle: "Fidget Spinner — Star with Groove | Paul\'s Pens n Things",
    seoDescription: "This spinner will be white with colored grooves. CNC routed in Paragould, Arkansas.",
  },
  {
    id: "p204",
    slug: "star-spinner-without-groove",
    name: "Fidget Spinner — Star without Groove",
    internalCode: "FS-STAR",
    category: "cnc",
    subcategory: "Fidget Spinners",
    shortDescription: "This spinner can be made in any of the colors.",
    fullDescription: "This spinner can be made in any of the colors. These fidget spinners are cut on a CNC router from a blank of two tone HDPE. There is a ball bearing at the center and counter weights surrounding it. They come in red, green, blue, yellow, brown, black, and white. Yellow must be paired with black and all other colors are paired with white. Specify the color(s) desired.",
    price: 7,
    priceType: "fixed",
    status: "available",
    materials: ["Two-tone HDPE", "Ball bearings"],
    finishes: ["CNC routed"],
    customizable: true,
    featured: false,
    images: [img(spinnerStarPlainImg, "Fidget Spinner — Star without Groove cut by Paul\'s Pens n Things", 360, 270)],
    tags: ["fidget spinner", "hdpe", "cnc"],
    occasions: ["Birthday", "Stocking stuffer", "Just because"],
    relatedProducts: ["p205", "p206", "p207"],
    seoTitle: "Fidget Spinner — Star without Groove | Paul\'s Pens n Things",
    seoDescription: "This spinner can be made in any of the colors. CNC routed in Paragould, Arkansas.",
  },
  {
    id: "p205",
    slug: "three-squarish-lobes-spinner",
    name: "Fidget Spinner — 3 Squarish Lobes without Groove",
    internalCode: "FS-3SQ",
    category: "cnc",
    subcategory: "Fidget Spinners",
    shortDescription: "This spinner can be made in any of the colors.",
    fullDescription: "This spinner can be made in any of the colors. These fidget spinners are cut on a CNC router from a blank of two tone HDPE. There is a ball bearing at the center and counter weights surrounding it. They come in red, green, blue, yellow, brown, black, and white. Yellow must be paired with black and all other colors are paired with white. Specify the color(s) desired.",
    price: 7,
    priceType: "fixed",
    status: "available",
    materials: ["Two-tone HDPE", "Ball bearings"],
    finishes: ["CNC routed"],
    customizable: true,
    featured: false,
    images: [img(spinnerThreeSquarePlainImg, "Fidget Spinner — 3 Squarish Lobes without Groove cut by Paul\'s Pens n Things", 360, 270)],
    tags: ["fidget spinner", "hdpe", "cnc"],
    occasions: ["Birthday", "Stocking stuffer", "Just because"],
    relatedProducts: ["p206", "p207", "p208"],
    seoTitle: "Fidget Spinner — 3 Squarish Lobes without Groove | Paul\'s Pens n Things",
    seoDescription: "This spinner can be made in any of the colors. CNC routed in Paragould, Arkansas.",
  },
  {
    id: "p206",
    slug: "three-squarish-lobes-spinner-grooved",
    name: "Fidget Spinner — 3 Squarish Lobes with Groove",
    internalCode: "FS-3SQ-G",
    category: "cnc",
    subcategory: "Fidget Spinners",
    shortDescription: "This spinner will be white with colored grooves.",
    fullDescription: "This spinner will be white with colored grooves. These fidget spinners are cut on a CNC router from a blank of two tone HDPE. There is a ball bearing at the center and counter weights surrounding it. They come in red, green, blue, yellow, brown, black, and white. Yellow must be paired with black and all other colors are paired with white. Specify the color(s) desired.",
    price: 7,
    priceType: "fixed",
    status: "available",
    materials: ["Two-tone HDPE", "Ball bearings"],
    finishes: ["CNC routed"],
    customizable: true,
    featured: false,
    images: [img(spinnerThreeSquareGrooveImg, "Fidget Spinner — 3 Squarish Lobes with Groove cut by Paul\'s Pens n Things", 360, 270)],
    tags: ["fidget spinner", "hdpe", "cnc"],
    occasions: ["Birthday", "Stocking stuffer", "Just because"],
    relatedProducts: ["p207", "p208", "p209"],
    seoTitle: "Fidget Spinner — 3 Squarish Lobes with Groove | Paul\'s Pens n Things",
    seoDescription: "This spinner will be white with colored grooves. CNC routed in Paragould, Arkansas.",
  },
  {
    id: "p207",
    slug: "three-round-lobes-spinner",
    name: "Fidget Spinner — 3 Round Lobes without Grooves",
    internalCode: "FS-3RD",
    category: "cnc",
    subcategory: "Fidget Spinners",
    shortDescription: "This spinner can be made in any of the colors.",
    fullDescription: "This spinner can be made in any of the colors. These fidget spinners are cut on a CNC router from a blank of two tone HDPE. There is a ball bearing at the center and counter weights surrounding it. They come in red, green, blue, yellow, brown, black, and white. Yellow must be paired with black and all other colors are paired with white. Specify the color(s) desired.",
    price: 7,
    priceType: "fixed",
    status: "available",
    materials: ["Two-tone HDPE", "Ball bearings"],
    finishes: ["CNC routed"],
    customizable: true,
    featured: false,
    images: [img(spinnerThreeRoundPlainImg, "Fidget Spinner — 3 Round Lobes without Grooves cut by Paul\'s Pens n Things", 360, 270)],
    tags: ["fidget spinner", "hdpe", "cnc"],
    occasions: ["Birthday", "Stocking stuffer", "Just because"],
    relatedProducts: ["p208", "p209", "p210"],
    seoTitle: "Fidget Spinner — 3 Round Lobes without Grooves | Paul\'s Pens n Things",
    seoDescription: "This spinner can be made in any of the colors. CNC routed in Paragould, Arkansas.",
  },
  {
    id: "p208",
    slug: "three-round-lobes-spinner-grooved",
    name: "Fidget Spinner — 3 Round Lobes with Grooves",
    internalCode: "FS-3RD-G",
    category: "cnc",
    subcategory: "Fidget Spinners",
    shortDescription: "This spinner will be white with colored grooves.",
    fullDescription: "This spinner will be white with colored grooves. These fidget spinners are cut on a CNC router from a blank of two tone HDPE. There is a ball bearing at the center and counter weights surrounding it. They come in red, green, blue, yellow, brown, black, and white. Yellow must be paired with black and all other colors are paired with white. Specify the color(s) desired.",
    price: 7,
    priceType: "fixed",
    status: "available",
    materials: ["Two-tone HDPE", "Ball bearings"],
    finishes: ["CNC routed"],
    customizable: true,
    featured: false,
    images: [img(spinnerThreeRoundGrooveImg, "Fidget Spinner — 3 Round Lobes with Grooves cut by Paul\'s Pens n Things", 360, 270)],
    tags: ["fidget spinner", "hdpe", "cnc"],
    occasions: ["Birthday", "Stocking stuffer", "Just because"],
    relatedProducts: ["p209", "p210", "p197"],
    seoTitle: "Fidget Spinner — 3 Round Lobes with Grooves | Paul\'s Pens n Things",
    seoDescription: "This spinner will be white with colored grooves. CNC routed in Paragould, Arkansas.",
  },
  {
    id: "p209",
    slug: "four-round-lobes-spinner",
    name: "Fidget Spinner — 4 Round Lobes without Grooves",
    internalCode: "FS-4RD",
    category: "cnc",
    subcategory: "Fidget Spinners",
    shortDescription: "This spinner can be made in any of the colors.",
    fullDescription: "This spinner can be made in any of the colors. These fidget spinners are cut on a CNC router from a blank of two tone HDPE. There is a ball bearing at the center and counter weights surrounding it. They come in red, green, blue, yellow, brown, black, and white. Yellow must be paired with black and all other colors are paired with white. Specify the color(s) desired.",
    price: 7,
    priceType: "fixed",
    status: "available",
    materials: ["Two-tone HDPE", "Ball bearings"],
    finishes: ["CNC routed"],
    customizable: true,
    featured: false,
    images: [img(spinnerFourRoundPlainImg, "Fidget Spinner — 4 Round Lobes without Grooves cut by Paul\'s Pens n Things", 360, 270)],
    tags: ["fidget spinner", "hdpe", "cnc"],
    occasions: ["Birthday", "Stocking stuffer", "Just because"],
    relatedProducts: ["p210", "p197", "p198"],
    seoTitle: "Fidget Spinner — 4 Round Lobes without Grooves | Paul\'s Pens n Things",
    seoDescription: "This spinner can be made in any of the colors. CNC routed in Paragould, Arkansas.",
  },
  {
    id: "p210",
    slug: "four-round-lobes-spinner-grooved",
    name: "Fidget Spinner — 4 Round Lobes with Grooves",
    internalCode: "FS-4RD-G",
    category: "cnc",
    subcategory: "Fidget Spinners",
    shortDescription: "This spinner will be white with colored grooves.",
    fullDescription: "This spinner will be white with colored grooves. These fidget spinners are cut on a CNC router from a blank of two tone HDPE. There is a ball bearing at the center and counter weights surrounding it. They come in red, green, blue, yellow, brown, black, and white. Yellow must be paired with black and all other colors are paired with white. Specify the color(s) desired.",
    price: 7,
    priceType: "fixed",
    status: "available",
    materials: ["Two-tone HDPE", "Ball bearings"],
    finishes: ["CNC routed"],
    customizable: true,
    featured: false,
    images: [img(spinnerFourRoundGrooveImg, "Fidget Spinner — 4 Round Lobes with Grooves cut by Paul\'s Pens n Things", 360, 270)],
    tags: ["fidget spinner", "hdpe", "cnc"],
    occasions: ["Birthday", "Stocking stuffer", "Just because"],
    relatedProducts: ["p197", "p198", "p199"],
    seoTitle: "Fidget Spinner — 4 Round Lobes with Grooves | Paul\'s Pens n Things",
    seoDescription: "This spinner will be white with colored grooves. CNC routed in Paragould, Arkansas.",
  },
  {
    id: "p211",
    slug: "african-safari-1-carving",
    name: "3D Landscape — African Safari 1",
    internalCode: "3D-SAFARI1",
    category: "cnc",
    subcategory: "3D Carvings",
    shortDescription: "The size of this landscape is about 9 by 11 inches.",
    fullDescription: "The size of this landscape is about 9 by 11 inches. These landscapes were carved on a CNC router.",
    price: 40,
    priceType: "fixed",
    status: "available",
    materials: ["Carved hardwood"],
    finishes: ["CNC carved"],
    customizable: true,
    featured: false,
    images: [img(carvSafari1Img, "3D Landscape — African Safari 1 carved by Paul\'s Pens n Things", 360, 270)],
    tags: ["3d carving", "landscape", "cnc"],
    occasions: ["Housewarming", "Holiday", "Just because"],
    relatedProducts: ["p212", "p213", "p214"],
    seoTitle: "3D Landscape — African Safari 1 | Paul\'s Pens n Things",
    seoDescription: "The size of this landscape is about 9 by 11 inches. CNC carved in Paragould, Arkansas.",
  },
  {
    id: "p212",
    slug: "african-safari-2-carving",
    name: "3D Landscape — African Safari 2",
    internalCode: "3D-SAFARI2",
    category: "cnc",
    subcategory: "3D Carvings",
    shortDescription: "The size of this landscape is about 9 by 11 inches.",
    fullDescription: "The size of this landscape is about 9 by 11 inches. These landscapes were carved on a CNC router.",
    price: 40,
    priceType: "fixed",
    status: "available",
    materials: ["Carved hardwood"],
    finishes: ["CNC carved"],
    customizable: true,
    featured: false,
    images: [img(carvSafari2Img, "3D Landscape — African Safari 2 carved by Paul\'s Pens n Things", 360, 270)],
    tags: ["3d carving", "landscape", "cnc"],
    occasions: ["Housewarming", "Holiday", "Just because"],
    relatedProducts: ["p213", "p214", "p215"],
    seoTitle: "3D Landscape — African Safari 2 | Paul\'s Pens n Things",
    seoDescription: "The size of this landscape is about 9 by 11 inches. CNC carved in Paragould, Arkansas.",
  },
  {
    id: "p213",
    slug: "deer-in-a-frame-carving",
    name: "3D Landscape — Deer in a Frame",
    internalCode: "3D-DEERFRAME",
    category: "cnc",
    subcategory: "3D Carvings",
    shortDescription: "The size of this landscape is about 9 by 11 inches.",
    fullDescription: "The size of this landscape is about 9 by 11 inches. These landscapes were carved on a CNC router.",
    price: 40,
    priceType: "fixed",
    status: "available",
    materials: ["Carved hardwood"],
    finishes: ["CNC carved"],
    customizable: true,
    featured: false,
    images: [img(carvDeerImg, "3D Landscape — Deer in a Frame carved by Paul\'s Pens n Things", 360, 270)],
    tags: ["3d carving", "landscape", "cnc"],
    occasions: ["Housewarming", "Holiday", "Just because"],
    relatedProducts: ["p214", "p215", "p216"],
    seoTitle: "3D Landscape — Deer in a Frame | Paul\'s Pens n Things",
    seoDescription: "The size of this landscape is about 9 by 11 inches. CNC carved in Paragould, Arkansas.",
  },
  {
    id: "p214",
    slug: "eagle-and-wolf-carving",
    name: "3D Landscape — Eagle and Wolf",
    internalCode: "3D-EAGLEWOLF",
    category: "cnc",
    subcategory: "3D Carvings",
    shortDescription: "The size of this landscape is about 9 by 11 inches.",
    fullDescription: "The size of this landscape is about 9 by 11 inches. These landscapes were carved on a CNC router.",
    price: 40,
    priceType: "fixed",
    status: "available",
    materials: ["Carved hardwood"],
    finishes: ["CNC carved"],
    customizable: true,
    featured: false,
    images: [img(carvEagleWolfImg, "3D Landscape — Eagle and Wolf carved by Paul\'s Pens n Things", 360, 270)],
    tags: ["3d carving", "landscape", "cnc"],
    occasions: ["Housewarming", "Holiday", "Just because"],
    relatedProducts: ["p215", "p216", "p217"],
    seoTitle: "3D Landscape — Eagle and Wolf | Paul\'s Pens n Things",
    seoDescription: "The size of this landscape is about 9 by 11 inches. CNC carved in Paragould, Arkansas.",
  },
  {
    id: "p215",
    slug: "pheasant-hunt-carving",
    name: "3D Landscape — Pheasant Hunt",
    internalCode: "3D-PHEASANT",
    category: "cnc",
    subcategory: "3D Carvings",
    shortDescription: "The size of this landscape is about 4 by 23 inches.",
    fullDescription: "The size of this landscape is about 4 by 23 inches. These landscapes were carved on a CNC router.",
    price: 25,
    priceType: "fixed",
    status: "available",
    materials: ["Carved hardwood"],
    finishes: ["CNC carved"],
    customizable: true,
    featured: false,
    images: [img(carvPheasantImg, "3D Landscape — Pheasant Hunt carved by Paul\'s Pens n Things", 360, 270)],
    tags: ["3d carving", "landscape", "cnc"],
    occasions: ["Housewarming", "Holiday", "Just because"],
    relatedProducts: ["p216", "p217", "p218"],
    seoTitle: "3D Landscape — Pheasant Hunt | Paul\'s Pens n Things",
    seoDescription: "The size of this landscape is about 4 by 23 inches. CNC carved in Paragould, Arkansas.",
  },
  {
    id: "p216",
    slug: "fairy-door-with-mushroom",
    name: "Fairy Door with Mushroom",
    internalCode: "3D-FAIRYMUSH",
    category: "cnc",
    subcategory: "3D Carvings",
    shortDescription: "The size of this door is about 9 by 11 inches.",
    fullDescription: "The size of this door is about 9 by 11 inches. These doors are carved out of oak by a CNC router.",
    price: 30,
    priceType: "fixed",
    status: "available",
    materials: ["Oak"],
    finishes: ["CNC carved"],
    customizable: true,
    featured: false,
    images: [img(carvFairyMushImg, "Fairy Door with Mushroom carved by Paul\'s Pens n Things", 360, 270)],
    tags: ["3d carving", "door", "cnc"],
    occasions: ["Housewarming", "Holiday", "Just because"],
    relatedProducts: ["p217", "p218", "p219"],
    seoTitle: "Fairy Door with Mushroom | Paul\'s Pens n Things",
    seoDescription: "The size of this door is about 9 by 11 inches. CNC carved in Paragould, Arkansas.",
  },
  {
    id: "p217",
    slug: "fairy-door-without-mushroom",
    name: "Fairy Door without Mushroom",
    internalCode: "3D-FAIRY",
    category: "cnc",
    subcategory: "3D Carvings",
    shortDescription: "The size of this door is about 9 by 11 inches.",
    fullDescription: "The size of this door is about 9 by 11 inches. These doors are carved out of oak by a CNC router.",
    price: 30,
    priceType: "fixed",
    status: "available",
    materials: ["Oak"],
    finishes: ["CNC carved"],
    customizable: true,
    featured: false,
    images: [img(carvFairyPlainImg, "Fairy Door without Mushroom carved by Paul\'s Pens n Things", 360, 270)],
    tags: ["3d carving", "door", "cnc"],
    occasions: ["Housewarming", "Holiday", "Just because"],
    relatedProducts: ["p218", "p219", "p220"],
    seoTitle: "Fairy Door without Mushroom | Paul\'s Pens n Things",
    seoDescription: "The size of this door is about 9 by 11 inches. CNC carved in Paragould, Arkansas.",
  },
  {
    id: "p218",
    slug: "hobbit-door-carving",
    name: "Hobbit Door",
    internalCode: "3D-HOBBIT",
    category: "cnc",
    subcategory: "3D Carvings",
    shortDescription: "The size of this door is about 9 by 11 inches.",
    fullDescription: "The size of this door is about 9 by 11 inches. These doors are carved out of oak by a CNC router.",
    price: 30,
    priceType: "fixed",
    status: "available",
    materials: ["Oak"],
    finishes: ["CNC carved"],
    customizable: true,
    featured: false,
    images: [img(carvHobbitImg, "Hobbit Door carved by Paul\'s Pens n Things", 360, 270)],
    tags: ["3d carving", "door", "cnc"],
    occasions: ["Housewarming", "Holiday", "Just because"],
    relatedProducts: ["p219", "p220", "p221"],
    seoTitle: "Hobbit Door | Paul\'s Pens n Things",
    seoDescription: "The size of this door is about 9 by 11 inches. CNC carved in Paragould, Arkansas.",
  },
  {
    id: "p219",
    slug: "dished-eagle-1",
    name: "Dished Eagle 1",
    internalCode: "3D-EAGLE1",
    category: "cnc",
    subcategory: "3D Carvings",
    shortDescription: "This carving is a 3D profile of an eagle made in poplar. It is about 5 inches in diameter.",
    fullDescription: "This carving is a 3D profile of an eagle made in poplar. It is about 5 inches in diameter.",
    price: 10,
    priceType: "fixed",
    status: "available",
    materials: ["Poplar"],
    finishes: ["CNC carved"],
    customizable: true,
    featured: false,
    images: [img(carvDishEagle1Img, "Dished Eagle 1 carved by Paul\'s Pens n Things", 360, 270)],
    tags: ["3d carving", "dished", "cnc"],
    occasions: ["Housewarming", "Holiday", "Just because"],
    relatedProducts: ["p220", "p221", "p222"],
    seoTitle: "Dished Eagle 1 | Paul\'s Pens n Things",
    seoDescription: "This carving is a 3D profile of an eagle made in poplar. It is about 5 inches in diameter. CNC carved in Paragould, Arkansas.",
  },
  {
    id: "p220",
    slug: "dished-eagle-2",
    name: "Dished Eagle 2",
    internalCode: "3D-EAGLE2",
    category: "cnc",
    subcategory: "3D Carvings",
    shortDescription: "This carving is a 3D profile of an eagle made in oak. It is about 5 inches in diameter.",
    fullDescription: "This carving is a 3D profile of an eagle made in oak. It is about 5 inches in diameter.",
    price: 10,
    priceType: "fixed",
    status: "available",
    materials: ["Oak"],
    finishes: ["CNC carved"],
    customizable: true,
    featured: false,
    images: [img(carvDishEagle2Img, "Dished Eagle 2 carved by Paul\'s Pens n Things", 360, 270)],
    tags: ["3d carving", "dished", "cnc"],
    occasions: ["Housewarming", "Holiday", "Just because"],
    relatedProducts: ["p221", "p222", "p223"],
    seoTitle: "Dished Eagle 2 | Paul\'s Pens n Things",
    seoDescription: "This carving is a 3D profile of an eagle made in oak. It is about 5 inches in diameter. CNC carved in Paragould, Arkansas.",
  },
  {
    id: "p221",
    slug: "dished-elk",
    name: "Dished Elk",
    internalCode: "3D-ELK",
    category: "cnc",
    subcategory: "3D Carvings",
    shortDescription: "This carving is a 3D profile of an elk made in oak. It is about 5 inches in diameter.",
    fullDescription: "This carving is a 3D profile of an elk made in oak. It is about 5 inches in diameter.",
    price: 10,
    priceType: "fixed",
    status: "available",
    materials: ["Oak"],
    finishes: ["CNC carved"],
    customizable: true,
    featured: false,
    images: [img(carvDishElkImg, "Dished Elk carved by Paul\'s Pens n Things", 360, 270)],
    tags: ["3d carving", "dished", "cnc"],
    occasions: ["Housewarming", "Holiday", "Just because"],
    relatedProducts: ["p222", "p223", "p224"],
    seoTitle: "Dished Elk | Paul\'s Pens n Things",
    seoDescription: "This carving is a 3D profile of an elk made in oak. It is about 5 inches in diameter. CNC carved in Paragould, Arkansas.",
  },
  {
    id: "p222",
    slug: "dished-frog",
    name: "Dished Frog",
    internalCode: "3D-FROG",
    category: "cnc",
    subcategory: "3D Carvings",
    shortDescription: "This carving is a 3D profile of a frog made in oak. It is about 5 inches in diameter.",
    fullDescription: "This carving is a 3D profile of a frog made in oak. It is about 5 inches in diameter.",
    price: 10,
    priceType: "fixed",
    status: "available",
    materials: ["Oak"],
    finishes: ["CNC carved"],
    customizable: true,
    featured: false,
    images: [img(carvDishFrogImg, "Dished Frog carved by Paul\'s Pens n Things", 360, 270)],
    tags: ["3d carving", "dished", "cnc"],
    occasions: ["Housewarming", "Holiday", "Just because"],
    relatedProducts: ["p223", "p224", "p225"],
    seoTitle: "Dished Frog | Paul\'s Pens n Things",
    seoDescription: "This carving is a 3D profile of a frog made in oak. It is about 5 inches in diameter. CNC carved in Paragould, Arkansas.",
  },
  {
    id: "p223",
    slug: "dished-hen",
    name: "Dished Hen",
    internalCode: "3D-HEN",
    category: "cnc",
    subcategory: "3D Carvings",
    shortDescription: "This carving is a 3D profile of a hen made in poplar. It is about 5 inches in diameter.",
    fullDescription: "This carving is a 3D profile of a hen made in poplar. It is about 5 inches in diameter.",
    price: 10,
    priceType: "fixed",
    status: "available",
    materials: ["Poplar"],
    finishes: ["CNC carved"],
    customizable: true,
    featured: false,
    images: [img(carvDishHenImg, "Dished Hen carved by Paul\'s Pens n Things", 360, 270)],
    tags: ["3d carving", "dished", "cnc"],
    occasions: ["Housewarming", "Holiday", "Just because"],
    relatedProducts: ["p224", "p225", "p226"],
    seoTitle: "Dished Hen | Paul\'s Pens n Things",
    seoDescription: "This carving is a 3D profile of a hen made in poplar. It is about 5 inches in diameter. CNC carved in Paragould, Arkansas.",
  },
  {
    id: "p224",
    slug: "dished-horse",
    name: "Dished Horse",
    internalCode: "3D-HORSE",
    category: "cnc",
    subcategory: "3D Carvings",
    shortDescription: "This carving is a 3D profile of a horse made in poplar. It is about 5 inches in diameter.",
    fullDescription: "This carving is a 3D profile of a horse made in poplar. It is about 5 inches in diameter.",
    price: 10,
    priceType: "fixed",
    status: "available",
    materials: ["Poplar"],
    finishes: ["CNC carved"],
    customizable: true,
    featured: false,
    images: [img(carvDishHorseImg, "Dished Horse carved by Paul\'s Pens n Things", 360, 270)],
    tags: ["3d carving", "dished", "cnc"],
    occasions: ["Housewarming", "Holiday", "Just because"],
    relatedProducts: ["p225", "p226", "p211"],
    seoTitle: "Dished Horse | Paul\'s Pens n Things",
    seoDescription: "This carving is a 3D profile of a horse made in poplar. It is about 5 inches in diameter. CNC carved in Paragould, Arkansas.",
  },
  {
    id: "p225",
    slug: "dished-unicorn-1",
    name: "Dished Unicorn 1",
    internalCode: "3D-UNICORN1",
    category: "cnc",
    subcategory: "3D Carvings",
    shortDescription: "This carving is a 3D profile of a unicorn made in poplar. It is about 5 inches in diameter.",
    fullDescription: "This carving is a 3D profile of a unicorn made in poplar. It is about 5 inches in diameter.",
    price: 10,
    priceType: "fixed",
    status: "available",
    materials: ["Poplar"],
    finishes: ["CNC carved"],
    customizable: true,
    featured: false,
    images: [img(carvDishUni1Img, "Dished Unicorn 1 carved by Paul\'s Pens n Things", 360, 270)],
    tags: ["3d carving", "dished", "cnc"],
    occasions: ["Housewarming", "Holiday", "Just because"],
    relatedProducts: ["p226", "p211", "p212"],
    seoTitle: "Dished Unicorn 1 | Paul\'s Pens n Things",
    seoDescription: "This carving is a 3D profile of a unicorn made in poplar. It is about 5 inches in diameter. CNC carved in Paragould, Arkansas.",
  },
  {
    id: "p226",
    slug: "dished-unicorn-2",
    name: "Dished Unicorn 2",
    internalCode: "3D-UNICORN2",
    category: "cnc",
    subcategory: "3D Carvings",
    shortDescription: "This carving is a 3D profile of a unicorn made in oak. It is about 5 inches in diameter.",
    fullDescription: "This carving is a 3D profile of a unicorn made in oak. It is about 5 inches in diameter.",
    price: 10,
    priceType: "fixed",
    status: "available",
    materials: ["Oak"],
    finishes: ["CNC carved"],
    customizable: true,
    featured: false,
    images: [img(carvDishUni2Img, "Dished Unicorn 2 carved by Paul\'s Pens n Things", 360, 270)],
    tags: ["3d carving", "dished", "cnc"],
    occasions: ["Housewarming", "Holiday", "Just because"],
    relatedProducts: ["p211", "p212", "p213"],
    seoTitle: "Dished Unicorn 2 | Paul\'s Pens n Things",
    seoDescription: "This carving is a 3D profile of a unicorn made in oak. It is about 5 inches in diameter. CNC carved in Paragould, Arkansas.",
  },
  {
    id: "p227",
    slug: "mask-rack",
    name: "Mask Rack",
    internalCode: "OC-MASKRACK",
    category: "cnc",
    subcategory: "Other CNC Items",
    shortDescription: "This rack is made of oak, has 4 hooks and is 10 by 3 1/2 inches in size.",
    fullDescription: "This rack is made of oak, has 4 hooks and is 10 by 3 1/2 inches in size.",
    price: 28,
    priceType: "fixed",
    status: "available",
    materials: ["Oak"],
    finishes: ["CNC cut"],
    customizable: true,
    featured: false,
    images: [img(ocncMaskRackImg, "Mask Rack made by Paul\'s Pens n Things", 360, 270)],
    tags: ["cnc", "racks-with-hooks", "home"],
    occasions: ["Housewarming", "Holiday", "Just because"],
    relatedProducts: ["p228", "p229", "p230"],
    seoTitle: "Mask Rack | Paul\'s Pens n Things",
    seoDescription: "This rack is made of oak, has 4 hooks and is 10 by 3 1/2 inches in size. CNC crafted in Paragould, Arkansas.",
  },
  {
    id: "p228",
    slug: "key-mask-rack",
    name: "Key/Mask Rack",
    internalCode: "OC-KEYRACK",
    category: "cnc",
    subcategory: "Other CNC Items",
    shortDescription: "This rack is made of oak, has 4 hooks and is 9 1/2 by 5 1/2 inches in size.",
    fullDescription: "This rack is made of oak, has 4 hooks and is 9 1/2 by 5 1/2 inches in size.",
    price: 22,
    priceType: "fixed",
    status: "available",
    materials: ["Oak"],
    finishes: ["CNC cut"],
    customizable: true,
    featured: false,
    images: [img(ocncKeyMaskRackImg, "Key/Mask Rack made by Paul\'s Pens n Things", 360, 270)],
    tags: ["cnc", "racks-with-hooks", "home"],
    occasions: ["Housewarming", "Holiday", "Just because"],
    relatedProducts: ["p229", "p230", "p231"],
    seoTitle: "Key/Mask Rack | Paul\'s Pens n Things",
    seoDescription: "This rack is made of oak, has 4 hooks and is 9 1/2 by 5 1/2 inches in size. CNC crafted in Paragould, Arkansas.",
  },
  {
    id: "p229",
    slug: "towel-rack",
    name: "Towel Rack",
    internalCode: "OC-TOWELRACK",
    category: "cnc",
    subcategory: "Other CNC Items",
    shortDescription: "This rack is made of oak, has 5 hooks and is 25 by 7 1/2 inches in size.",
    fullDescription: "This rack is made of oak, has 5 hooks and is 25 by 7 1/2 inches in size.",
    price: 35,
    priceType: "fixed",
    status: "available",
    materials: ["Oak"],
    finishes: ["CNC cut"],
    customizable: true,
    featured: false,
    images: [img(ocncTowelRackImg, "Towel Rack made by Paul\'s Pens n Things", 360, 270)],
    tags: ["cnc", "racks-with-hooks", "home"],
    occasions: ["Housewarming", "Holiday", "Just because"],
    relatedProducts: ["p230", "p231", "p232"],
    seoTitle: "Towel Rack | Paul\'s Pens n Things",
    seoDescription: "This rack is made of oak, has 5 hooks and is 25 by 7 1/2 inches in size. CNC crafted in Paragould, Arkansas.",
  },
  {
    id: "p230",
    slug: "plant-hanger-set",
    name: "Plant Hanger Set",
    internalCode: "OC-PLANTSET",
    category: "cnc",
    subcategory: "Other CNC Items",
    shortDescription: "This is a set of plant hangers of varying height. The largest is 11 inches tall, 7.5 inches wide, 3 inches deep and is made of 1/2 thick bamboo plywood.",
    fullDescription: "This is a set of plant hangers of varying height. The largest is 11 inches tall, 7.5 inches wide, 3 inches deep and is made of 1/2 thick bamboo plywood.",
    price: 30,
    priceType: "fixed",
    status: "available",
    materials: ["Bamboo plywood"],
    finishes: ["CNC cut"],
    customizable: true,
    featured: false,
    images: [img(ocncPlantHangerSetImg, "Plant Hanger Set made by Paul\'s Pens n Things", 360, 270)],
    tags: ["cnc", "plant-hangers", "home"],
    occasions: ["Housewarming", "Holiday", "Just because"],
    relatedProducts: ["p231", "p232", "p233"],
    seoTitle: "Plant Hanger Set | Paul\'s Pens n Things",
    seoDescription: "This is a set of plant hangers of varying height. The largest is 11 inches tall, 7.5 inches wide, 3 inches deep and is made of 1/2 thick bamboo plywood. CNC crafted in Paragould, Arkansas.",
  },
  {
    id: "p231",
    slug: "air-plant-hanger-1",
    name: "Air Plant Hanger 1",
    internalCode: "OC-AIR1",
    category: "cnc",
    subcategory: "Other CNC Items",
    shortDescription: "This plant hanger is made of clear acrylic with solid sides and is designed to hold air plants.",
    fullDescription: "This plant hanger is made of clear acrylic with solid sides and is designed to hold air plants.",
    price: 12,
    priceType: "fixed",
    status: "available",
    materials: ["Clear acrylic"],
    finishes: ["CNC cut"],
    customizable: true,
    featured: false,
    images: [img(ocncAirPlant1Img, "Air Plant Hanger 1 made by Paul\'s Pens n Things", 360, 270)],
    tags: ["cnc", "plant-hangers", "home"],
    occasions: ["Housewarming", "Holiday", "Just because"],
    relatedProducts: ["p232", "p233", "p234"],
    seoTitle: "Air Plant Hanger 1 | Paul\'s Pens n Things",
    seoDescription: "This plant hanger is made of clear acrylic with solid sides and is designed to hold air plants. CNC crafted in Paragould, Arkansas.",
  },
  {
    id: "p232",
    slug: "air-plant-hanger-2",
    name: "Air Plant Hanger 2",
    internalCode: "OC-AIR2",
    category: "cnc",
    subcategory: "Other CNC Items",
    shortDescription: "This plant hanger is made of clear acrylic with slotted sides and is designed to hold air plants.",
    fullDescription: "This plant hanger is made of clear acrylic with slotted sides and is designed to hold air plants.",
    price: 12,
    priceType: "fixed",
    status: "available",
    materials: ["Clear acrylic"],
    finishes: ["CNC cut"],
    customizable: true,
    featured: false,
    images: [img(ocncAirPlant2Img, "Air Plant Hanger 2 made by Paul\'s Pens n Things", 360, 270)],
    tags: ["cnc", "plant-hangers", "home"],
    occasions: ["Housewarming", "Holiday", "Just because"],
    relatedProducts: ["p233", "p234", "p235"],
    seoTitle: "Air Plant Hanger 2 | Paul\'s Pens n Things",
    seoDescription: "This plant hanger is made of clear acrylic with slotted sides and is designed to hold air plants. CNC crafted in Paragould, Arkansas.",
  },
  {
    id: "p233",
    slug: "air-plant-hanger-3",
    name: "Air Plant Hanger 3",
    internalCode: "OC-AIR3",
    category: "cnc",
    subcategory: "Other CNC Items",
    shortDescription: "This plant hanger is made of clear acrylic with triangular cutouts and is designed to hold air plants.",
    fullDescription: "This plant hanger is made of clear acrylic with triangular cutouts and is designed to hold air plants.",
    price: 12,
    priceType: "fixed",
    status: "available",
    materials: ["Clear acrylic"],
    finishes: ["CNC cut"],
    customizable: true,
    featured: false,
    images: [img(ocncAirPlant3Img, "Air Plant Hanger 3 made by Paul\'s Pens n Things", 360, 270)],
    tags: ["cnc", "plant-hangers", "home"],
    occasions: ["Housewarming", "Holiday", "Just because"],
    relatedProducts: ["p234", "p235", "p236"],
    seoTitle: "Air Plant Hanger 3 | Paul\'s Pens n Things",
    seoDescription: "This plant hanger is made of clear acrylic with triangular cutouts and is designed to hold air plants. CNC crafted in Paragould, Arkansas.",
  },
  {
    id: "p234",
    slug: "air-plant-hanger-4",
    name: "Air Plant Hanger 4",
    internalCode: "OC-AIR4",
    category: "cnc",
    subcategory: "Other CNC Items",
    shortDescription: "This plant hanger is made of clear acrylic and is designed to hold air plants.",
    fullDescription: "This plant hanger is made of clear acrylic and is designed to hold air plants.",
    price: 12,
    priceType: "fixed",
    status: "available",
    materials: ["Clear acrylic"],
    finishes: ["CNC cut"],
    customizable: true,
    featured: false,
    images: [img(ocncAirPlant4Img, "Air Plant Hanger 4 made by Paul\'s Pens n Things", 360, 270)],
    tags: ["cnc", "plant-hangers", "home"],
    occasions: ["Housewarming", "Holiday", "Just because"],
    relatedProducts: ["p235", "p236", "p237"],
    seoTitle: "Air Plant Hanger 4 | Paul\'s Pens n Things",
    seoDescription: "This plant hanger is made of clear acrylic and is designed to hold air plants. CNC crafted in Paragould, Arkansas.",
  },
  {
    id: "p235",
    slug: "air-plant-hanger-5",
    name: "Air Plant Hanger 5",
    internalCode: "OC-AIR5",
    category: "cnc",
    subcategory: "Other CNC Items",
    shortDescription: "This plant hanger is made of frosted acrylic with solid sides and is designed to hold air plants.",
    fullDescription: "This plant hanger is made of frosted acrylic with solid sides and is designed to hold air plants.",
    price: 17,
    priceType: "fixed",
    status: "available",
    materials: ["Frosted acrylic"],
    finishes: ["CNC cut"],
    customizable: true,
    featured: false,
    images: [img(ocncAirPlant5Img, "Air Plant Hanger 5 made by Paul\'s Pens n Things", 360, 270)],
    tags: ["cnc", "plant-hangers", "home"],
    occasions: ["Housewarming", "Holiday", "Just because"],
    relatedProducts: ["p236", "p237", "p238"],
    seoTitle: "Air Plant Hanger 5 | Paul\'s Pens n Things",
    seoDescription: "This plant hanger is made of frosted acrylic with solid sides and is designed to hold air plants. CNC crafted in Paragould, Arkansas.",
  },
  {
    id: "p236",
    slug: "small-candle-holder",
    name: "Small Candle Holder",
    internalCode: "OC-CANDSM",
    category: "cnc",
    subcategory: "Other CNC Items",
    shortDescription: "This candle holder is designed to hold votive candles.",
    fullDescription: "This candle holder is designed to hold votive candles.",
    price: 9,
    priceType: "fixed",
    status: "available",
    materials: ["Hardwood"],
    finishes: ["CNC cut"],
    customizable: true,
    featured: false,
    images: [img(ocncSmallCandleHolderImg, "Small Candle Holder made by Paul\'s Pens n Things", 360, 270)],
    tags: ["cnc", "candle-holders", "home"],
    occasions: ["Housewarming", "Holiday", "Just because"],
    relatedProducts: ["p237", "p238", "p239"],
    seoTitle: "Small Candle Holder | Paul\'s Pens n Things",
    seoDescription: "This candle holder is designed to hold votive candles. CNC crafted in Paragould, Arkansas.",
  },
  {
    id: "p237",
    slug: "hex-candle-holder",
    name: "Hex Candle Holder",
    internalCode: "OC-CANDHEX",
    category: "cnc",
    subcategory: "Other CNC Items",
    shortDescription: "This candle holder is designed to hold tea lights. It is made of corian and walnut.",
    fullDescription: "This candle holder is designed to hold tea lights. It is made of corian and walnut.",
    price: 9,
    priceType: "fixed",
    status: "available",
    materials: ["Corian", "Walnut"],
    finishes: ["CNC cut"],
    customizable: true,
    featured: false,
    images: [img(ocncHexCandleHolderImg, "Hex Candle Holder made by Paul\'s Pens n Things", 360, 270)],
    tags: ["cnc", "candle-holders", "home"],
    occasions: ["Housewarming", "Holiday", "Just because"],
    relatedProducts: ["p238", "p239", "p240"],
    seoTitle: "Hex Candle Holder | Paul\'s Pens n Things",
    seoDescription: "This candle holder is designed to hold tea lights. It is made of corian and walnut. CNC crafted in Paragould, Arkansas.",
  },
  {
    id: "p238",
    slug: "hex-candle-holder-votive",
    name: "Hex Candle Holder (Votive)",
    internalCode: "OC-CANDHEXV",
    category: "cnc",
    subcategory: "Other CNC Items",
    shortDescription: "This candle holder is designed to hold votive candles, which are included.",
    fullDescription: "This candle holder is designed to hold votive candles, which are included.",
    price: 13,
    priceType: "fixed",
    status: "available",
    materials: ["Hardwood"],
    finishes: ["CNC cut"],
    customizable: true,
    featured: false,
    images: [img(ocncHexCandleHolderVotiveImg, "Hex Candle Holder (Votive) made by Paul\'s Pens n Things", 360, 270)],
    tags: ["cnc", "candle-holders", "home"],
    occasions: ["Housewarming", "Holiday", "Just because"],
    relatedProducts: ["p239", "p240", "p241"],
    seoTitle: "Hex Candle Holder (Votive) | Paul\'s Pens n Things",
    seoDescription: "This candle holder is designed to hold votive candles, which are included. CNC crafted in Paragould, Arkansas.",
  },
  {
    id: "p239",
    slug: "large-candle-holder",
    name: "Large Candle Holder",
    internalCode: "OC-CANDLG",
    category: "cnc",
    subcategory: "Other CNC Items",
    shortDescription: "This candle holder/plant stand is made of 3/4 in thick mdf and was finished with boiled linseed oil to make it water resistant. It is 3.5 inches tall, 6.38 inches wide, 6.38 inches deep and will hold a plant or candle with a base of 4.9 inches in diameter.",
    fullDescription: "This candle holder/plant stand is made of 3/4 in thick mdf and was finished with boiled linseed oil to make it water resistant. It is 3.5 inches tall, 6.38 inches wide, 6.38 inches deep and will hold a plant or candle with a base of 4.9 inches in diameter.",
    price: 12,
    priceType: "fixed",
    status: "available",
    materials: ["MDF"],
    finishes: ["CNC cut"],
    customizable: true,
    featured: false,
    images: [img(ocncLargeCandleHolderImg, "Large Candle Holder made by Paul\'s Pens n Things", 360, 270)],
    tags: ["cnc", "candle-holders", "home"],
    occasions: ["Housewarming", "Holiday", "Just because"],
    relatedProducts: ["p240", "p241", "p242"],
    seoTitle: "Large Candle Holder | Paul\'s Pens n Things",
    seoDescription: "This candle holder/plant stand is made of 3/4 in thick mdf and was finished with boiled linseed oil to make it water resistant. It is 3.5 inches tall, 6.38 inches wide, 6.38 inches deep and will hold a plant or candle with a base of 4.9 inches in diameter. CNC crafted in Paragould, Arkansas.",
  },
  {
    id: "p240",
    slug: "stacked-bowl",
    name: "Stacked Bowl",
    internalCode: "OC-BOWL",
    category: "cnc",
    subcategory: "Other CNC Items",
    shortDescription: "This bowl is made of multiple layers stacked and glued together. It is 6 inches in diameter and 1 1/2 inches tall.",
    fullDescription: "This bowl is made of multiple layers stacked and glued together. It is 6 inches in diameter and 1 1/2 inches tall.",
    price: 17,
    priceType: "fixed",
    status: "available",
    materials: ["Layered hardwood"],
    finishes: ["CNC cut"],
    customizable: true,
    featured: false,
    images: [img(ocncStackedBowlImg, "Stacked Bowl made by Paul\'s Pens n Things", 360, 270)],
    tags: ["cnc", "bowls-cutting-boards", "home"],
    occasions: ["Housewarming", "Holiday", "Just because"],
    relatedProducts: ["p241", "p242", "p243"],
    seoTitle: "Stacked Bowl | Paul\'s Pens n Things",
    seoDescription: "This bowl is made of multiple layers stacked and glued together. It is 6 inches in diameter and 1 1/2 inches tall. CNC crafted in Paragould, Arkansas.",
  },
  {
    id: "p241",
    slug: "santas-hat-candy-dish",
    name: "Santa\'s Hat Candy Dish",
    internalCode: "OC-SANTA",
    category: "cnc",
    subcategory: "Other CNC Items",
    shortDescription: "This candy dish has painted recesses and is 3/4 inch thick. It is 8 by 5 1/2 inches in size.",
    fullDescription: "This candy dish has painted recesses and is 3/4 inch thick. It is 8 by 5 1/2 inches in size.",
    price: 15,
    priceType: "fixed",
    status: "available",
    materials: ["Hardwood"],
    finishes: ["CNC cut"],
    customizable: true,
    featured: false,
    images: [img(ocncSantaHatCandyDishImg, "Santa\'s Hat Candy Dish made by Paul\'s Pens n Things", 360, 270)],
    tags: ["cnc", "bowls-cutting-boards", "home"],
    occasions: ["Housewarming", "Holiday", "Just because"],
    relatedProducts: ["p242", "p243", "p244"],
    seoTitle: "Santa\'s Hat Candy Dish | Paul\'s Pens n Things",
    seoDescription: "This candy dish has painted recesses and is 3/4 inch thick. It is 8 by 5 1/2 inches in size. CNC crafted in Paragould, Arkansas.",
  },
  {
    id: "p242",
    slug: "snowman-candy-dish",
    name: "Snowman Candy Dish",
    internalCode: "OC-SNOWMAN",
    category: "cnc",
    subcategory: "Other CNC Items",
    shortDescription: "This candy dish is made of oak and is 3/4 inch thick. It is 9 1/2 by 6 inches in size.",
    fullDescription: "This candy dish is made of oak and is 3/4 inch thick. It is 9 1/2 by 6 inches in size.",
    price: 15,
    priceType: "fixed",
    status: "available",
    materials: ["Oak"],
    finishes: ["CNC cut"],
    customizable: true,
    featured: false,
    images: [img(ocncSnowmanCandyDishImg, "Snowman Candy Dish made by Paul\'s Pens n Things", 360, 270)],
    tags: ["cnc", "bowls-cutting-boards", "home"],
    occasions: ["Housewarming", "Holiday", "Just because"],
    relatedProducts: ["p243", "p244", "p245"],
    seoTitle: "Snowman Candy Dish | Paul\'s Pens n Things",
    seoDescription: "This candy dish is made of oak and is 3/4 inch thick. It is 9 1/2 by 6 inches in size. CNC crafted in Paragould, Arkansas.",
  },
  {
    id: "p243",
    slug: "platter",
    name: "Platter",
    internalCode: "OC-PLATTER",
    category: "cnc",
    subcategory: "Other CNC Items",
    shortDescription: "It is 11 1/2 inches in diameter.",
    fullDescription: "It is 11 1/2 inches in diameter.",
    price: 20,
    priceType: "fixed",
    status: "available",
    materials: ["Hardwood"],
    finishes: ["CNC cut"],
    customizable: true,
    featured: false,
    images: [img(ocncPlatterImg, "Platter made by Paul\'s Pens n Things", 360, 270)],
    tags: ["cnc", "bowls-cutting-boards", "home"],
    occasions: ["Housewarming", "Holiday", "Just because"],
    relatedProducts: ["p244", "p245", "p246"],
    seoTitle: "Platter | Paul\'s Pens n Things",
    seoDescription: "It is 11 1/2 inches in diameter. CNC crafted in Paragould, Arkansas.",
  },
  {
    id: "p244",
    slug: "cutting-board",
    name: "Cutting Board",
    internalCode: "OC-CUTBOARD",
    category: "cnc",
    subcategory: "Other CNC Items",
    shortDescription: "This cutting board is engraved with several onions and the inscription \"cry me a river\". It is 12 by 8 inches in size.",
    fullDescription: "This cutting board is engraved with several onions and the inscription \"cry me a river\". It is 12 by 8 inches in size.",
    price: 20,
    priceType: "fixed",
    status: "available",
    materials: ["Hardwood"],
    finishes: ["CNC cut"],
    customizable: true,
    featured: false,
    images: [img(ocncCuttingBoardImg, "Cutting Board made by Paul\'s Pens n Things", 360, 270)],
    tags: ["cnc", "bowls-cutting-boards", "home"],
    occasions: ["Housewarming", "Holiday", "Just because"],
    relatedProducts: ["p245", "p246", "p247"],
    seoTitle: "Cutting Board | Paul\'s Pens n Things",
    seoDescription: "This cutting board is engraved with several onions and the inscription \"cry me a river\". It is 12 by 8 inches in size. CNC crafted in Paragould, Arkansas.",
  },
  {
    id: "p245",
    slug: "hex-trivet",
    name: "Hex Trivet",
    internalCode: "OC-TRIVET",
    category: "cnc",
    subcategory: "Other CNC Items",
    shortDescription: "Wood hexagonal trivet made from 1/2 inch thick birch plywood. It is 7.5 x 8 inches in size.",
    fullDescription: "Wood hexagonal trivet made from 1/2 inch thick birch plywood. It is 7.5 x 8 inches in size.",
    price: 12,
    priceType: "fixed",
    status: "available",
    materials: ["Birch plywood"],
    finishes: ["CNC cut"],
    customizable: true,
    featured: false,
    images: [img(ocncHexTrivetImg, "Hex Trivet made by Paul\'s Pens n Things", 360, 270)],
    tags: ["cnc", "bowls-cutting-boards", "home"],
    occasions: ["Housewarming", "Holiday", "Just because"],
    relatedProducts: ["p246", "p247", "p248"],
    seoTitle: "Hex Trivet | Paul\'s Pens n Things",
    seoDescription: "Wood hexagonal trivet made from 1/2 inch thick birch plywood. It is 7.5 x 8 inches in size. CNC crafted in Paragould, Arkansas.",
  },
  {
    id: "p246",
    slug: "ideas-note-pad",
    name: "Ideas Note Pad",
    internalCode: "OC-IDEAS",
    category: "cnc",
    subcategory: "Other CNC Items",
    shortDescription: "This note pad has \"Ideas\" engraved at the top, and has a 1/2 inch thick pad of paper, which can be refilled when needed.",
    fullDescription: "This note pad has \"Ideas\" engraved at the top, and has a 1/2 inch thick pad of paper, which can be refilled when needed.",
    price: 17,
    priceType: "fixed",
    status: "available",
    materials: ["Hardwood", "Paper"],
    finishes: ["CNC cut"],
    customizable: true,
    featured: false,
    images: [img(ocncIdeasNotePadImg, "Ideas Note Pad made by Paul\'s Pens n Things", 360, 270)],
    tags: ["cnc", "miscellaneous", "home"],
    occasions: ["Housewarming", "Holiday", "Just because"],
    relatedProducts: ["p247", "p248", "p249"],
    seoTitle: "Ideas Note Pad | Paul\'s Pens n Things",
    seoDescription: "This note pad has \"Ideas\" engraved at the top, and has a 1/2 inch thick pad of paper, which can be refilled when needed. CNC crafted in Paragould, Arkansas.",
  },
  {
    id: "p247",
    slug: "superman-logo",
    name: "Superman Logo",
    internalCode: "OC-SUPERMAN",
    category: "cnc",
    subcategory: "Other CNC Items",
    shortDescription: "This superman logo is made of birch plywood and is about 6 by 6 inches in size.",
    fullDescription: "This superman logo is made of birch plywood and is about 6 by 6 inches in size.",
    price: 15,
    priceType: "fixed",
    status: "available",
    materials: ["Birch plywood"],
    finishes: ["CNC cut"],
    customizable: true,
    featured: false,
    images: [img(ocncSupermanImg, "Superman Logo made by Paul\'s Pens n Things", 360, 270)],
    tags: ["cnc", "miscellaneous", "home"],
    occasions: ["Housewarming", "Holiday", "Just because"],
    relatedProducts: ["p248", "p249", "p227"],
    seoTitle: "Superman Logo | Paul\'s Pens n Things",
    seoDescription: "This superman logo is made of birch plywood and is about 6 by 6 inches in size. CNC crafted in Paragould, Arkansas.",
  },
  {
    id: "p248",
    slug: "hen-profile",
    name: "Hen Profile",
    internalCode: "OC-HEN",
    category: "cnc",
    subcategory: "Other CNC Items",
    shortDescription: "This hen profile is about 11 inches tall and is made of poplar.",
    fullDescription: "This hen profile is about 11 inches tall and is made of poplar.",
    price: 20,
    priceType: "fixed",
    status: "available",
    materials: ["Poplar"],
    finishes: ["CNC cut"],
    customizable: true,
    featured: false,
    images: [img(ocncHenImg, "Hen Profile made by Paul\'s Pens n Things", 360, 270)],
    tags: ["cnc", "miscellaneous", "home"],
    occasions: ["Housewarming", "Holiday", "Just because"],
    relatedProducts: ["p249", "p227", "p228"],
    seoTitle: "Hen Profile | Paul\'s Pens n Things",
    seoDescription: "This hen profile is about 11 inches tall and is made of poplar. CNC crafted in Paragould, Arkansas.",
  },
  {
    id: "p249",
    slug: "rooster-profile",
    name: "Rooster Profile",
    internalCode: "OC-ROOSTER",
    category: "cnc",
    subcategory: "Other CNC Items",
    shortDescription: "This rooster profile is about 11 inches tall and is made of poplar.",
    fullDescription: "This rooster profile is about 11 inches tall and is made of poplar.",
    price: 20,
    priceType: "fixed",
    status: "available",
    materials: ["Poplar"],
    finishes: ["CNC cut"],
    customizable: true,
    featured: false,
    images: [img(ocncRoosterImg, "Rooster Profile made by Paul\'s Pens n Things", 360, 270)],
    tags: ["cnc", "miscellaneous", "home"],
    occasions: ["Housewarming", "Holiday", "Just because"],
    relatedProducts: ["p227", "p228", "p229"],
    seoTitle: "Rooster Profile | Paul\'s Pens n Things",
    seoDescription: "This rooster profile is about 11 inches tall and is made of poplar. CNC crafted in Paragould, Arkansas.",
  },
  {
    id: "p250",
    slug: "antler-key-chain",
    name: "Antler Key Chain",
    internalCode: "MISC-ANTLERKEY",
    category: "other",
    subcategory: "Miscellaneous Items",
    shortDescription: "Made with the tip of a deer antler. These antler tips are about 2 inches long.",
    fullDescription: "This key chain is made with the tip of a deer antler. These antler tips are about 2 inches long.",
    price: 8,
    priceType: "fixed",
    status: "available",
    materials: ["Deer antler"],
    finishes: ["Hand finished"],
    customizable: true,
    featured: false,
    images: [img(miscAntlerKeyChainImg, "Deer antler key chain made by Paul\'s Pens n Things", 360, 270)],
    tags: ["antler", "key chain", "miscellaneous"],
    occasions: ["Gift for him", "Hunting season", "Just because"],
    relatedProducts: ["p251", "p227", "p228"],
    seoTitle: "Antler Key Chain | Paul\'s Pens n Things",
    seoDescription: "Deer antler tip key chain, about 2 inches long. Handmade in Paragould, Arkansas.",
  },
  {
    id: "p251",
    slug: "antler-pendant",
    name: "Antler Pendant",
    internalCode: "MISC-ANTLERPEND",
    category: "other",
    subcategory: "Miscellaneous Items",
    shortDescription: "Made with the tip of a deer antler. Antler tips are about 4 inches long; the cord is about 28 inches long.",
    fullDescription: "This pendant is made with the tip of a deer antler. These antler tips are about 4 inches long. The cord is about 28 inches long.",
    price: 10,
    priceType: "fixed",
    status: "available",
    materials: ["Deer antler", "Cord"],
    finishes: ["Hand finished"],
    customizable: true,
    featured: false,
    images: [img(miscAntlerPendantImg, "Deer antler pendant made by Paul\'s Pens n Things", 360, 270)],
    tags: ["antler", "pendant", "miscellaneous"],
    occasions: ["Gift for him", "Hunting season", "Just because"],
    relatedProducts: ["p250", "p227", "p228"],
    seoTitle: "Antler Pendant | Paul\'s Pens n Things",
    seoDescription: "Deer antler tip pendant on a 28 inch cord. Handmade in Paragould, Arkansas.",
  },
  {
    id: "p252",
    featured: true,
    slug: "cornhole-boards-red",
    name: "Red Cornhole Boards",
    internalCode: "CRN-RED",
    category: "other",
    subcategory: "Cornhole Boards",
    shortDescription: "Regulation 24 by 48 inch set trimmed in red, three coats of polyurethane.",
    fullDescription: "These cornhole boards are hand-crafted from 2x4s and 3/4 inch thick plywood. Trimmed in red with three coats of polyurethane, they measure 24 by 48 inches, the tops are 3/4 inch hardwood plywood, and they meet ACA specifications.",
    price: 250,
    priceType: "fixed",
    status: "previously-created",
    materials: ["2x4 framing lumber", "3/4 inch hardwood plywood top"],
    finishes: ["Three coats of polyurethane", "Red trim"],
    dimensions: "24 x 48 inches (ACA specification)",
    customizable: true,
    images: [img(cornholeRedImg, "Red trimmed handmade cornhole boards by Paul\'s Pens n Things", 360, 270)],
    tags: ["cornhole", "games", "red"],
    occasions: ["Tailgating", "Family gathering", "Graduation gift"],
    relatedProducts: ["p253", "p254", "p255"],
    seoTitle: "Red Cornhole Boards | Paul\'s Pens n Things",
    seoDescription: "Handmade red trimmed cornhole boards, 24 by 48 inches, ACA specification. Built in Paragould, Arkansas.",
  },
  {
    id: "p253",
    slug: "cornhole-boards-green",
    name: "Green Cornhole Boards",
    internalCode: "CRN-GREEN",
    category: "other",
    subcategory: "Cornhole Boards",
    shortDescription: "Regulation 24 by 48 inch set trimmed in green, three coats of polyurethane.",
    fullDescription: "These cornhole boards are hand-crafted from 2x4s and 3/4 inch thick plywood. Trimmed in green with three coats of polyurethane, they measure 24 by 48 inches, the tops are 3/4 inch hardwood plywood, and they meet ACA specifications.",
    price: 250,
    priceType: "fixed",
    status: "available",
    materials: ["2x4 framing lumber", "3/4 inch hardwood plywood top"],
    finishes: ["Three coats of polyurethane", "Green trim"],
    dimensions: "24 x 48 inches (ACA specification)",
    customizable: true,
    featured: false,
    images: [img(cornholeGreenImg, "Green trimmed handmade cornhole boards by Paul\'s Pens n Things", 360, 270)],
    tags: ["cornhole", "games", "green"],
    occasions: ["Tailgating", "Family gathering", "Graduation gift"],
    relatedProducts: ["p253", "p254", "p255"],
    seoTitle: "Green Cornhole Boards | Paul\'s Pens n Things",
    seoDescription: "Handmade green trimmed cornhole boards, 24 by 48 inches, ACA specification. Built in Paragould, Arkansas.",
  },
  {
    id: "p254",
    slug: "cornhole-boards-orange",
    name: "Orange Cornhole Boards",
    internalCode: "CRN-ORANGE",
    category: "other",
    subcategory: "Cornhole Boards",
    shortDescription: "Regulation 24 by 48 inch set trimmed in orange, three coats of polyurethane.",
    fullDescription: "These cornhole boards are hand-crafted from 2x4s and 3/4 inch thick plywood. Trimmed in orange with three coats of polyurethane, they measure 24 by 48 inches, the tops are 3/4 inch hardwood plywood, and they meet ACA specifications.",
    price: 250,
    priceType: "fixed",
    status: "available",
    materials: ["2x4 framing lumber", "3/4 inch hardwood plywood top"],
    finishes: ["Three coats of polyurethane", "Orange trim"],
    dimensions: "24 x 48 inches (ACA specification)",
    customizable: true,
    featured: false,
    images: [img(cornholeOrangeImg, "Orange trimmed handmade cornhole boards by Paul\'s Pens n Things", 360, 270)],
    tags: ["cornhole", "games", "orange"],
    occasions: ["Tailgating", "Family gathering", "Graduation gift"],
    relatedProducts: ["p253", "p254", "p255"],
    seoTitle: "Orange Cornhole Boards | Paul\'s Pens n Things",
    seoDescription: "Handmade orange trimmed cornhole boards, 24 by 48 inches, ACA specification. Built in Paragould, Arkansas.",
  },
  {
    id: "p255",
    slug: "cornhole-boards-yellow",
    name: "Yellow Cornhole Boards",
    internalCode: "CRN-YELLOW",
    category: "other",
    subcategory: "Cornhole Boards",
    shortDescription: "Regulation 24 by 48 inch set trimmed in yellow, three coats of polyurethane.",
    fullDescription: "These cornhole boards are hand-crafted from 2x4s and 3/4 inch thick plywood. Trimmed in yellow with three coats of polyurethane, they measure 24 by 48 inches, the tops are 3/4 inch hardwood plywood, and they meet ACA specifications.",
    price: 250,
    priceType: "fixed",
    status: "available",
    materials: ["2x4 framing lumber", "3/4 inch hardwood plywood top"],
    finishes: ["Three coats of polyurethane", "Yellow trim"],
    dimensions: "24 x 48 inches (ACA specification)",
    customizable: true,
    featured: false,
    images: [img(cornholeYellowImg, "Yellow trimmed handmade cornhole boards by Paul\'s Pens n Things", 360, 270)],
    tags: ["cornhole", "games", "yellow"],
    occasions: ["Tailgating", "Family gathering", "Graduation gift"],
    relatedProducts: ["p253", "p254", "p255"],
    seoTitle: "Yellow Cornhole Boards | Paul\'s Pens n Things",
    seoDescription: "Handmade yellow trimmed cornhole boards, 24 by 48 inches, ACA specification. Built in Paragould, Arkansas.",
  },
  {
    id: "p256",
    slug: "cornhole-boards-red-led",
    name: "Red Cornhole Boards with LED Lights",
    internalCode: "CRN-RED-LED",
    category: "other",
    subcategory: "Cornhole Boards",
    shortDescription: "Coming soon — red boards with LED lights embedded in the playing surface for night games.",
    fullDescription: "These cornhole boards are hand-crafted from 2x4s, 3/4 inch thick plywood and have LED lights embedded in the top surface for night-time playing. The bottom, sides and legs have one coat of polyurethane; the top is painted and has three coats of polyurethane. These boards meet or exceed the size, strength and rigidity regulations of the ACA and ACO.",
    price: 400,
    priceType: "fixed",
    status: "temporarily-unavailable",
    materials: ["2x4 framing lumber", "3/4 inch plywood top", "Embedded LED lighting"],
    finishes: ["Painted top with three coats of polyurethane", "One coat on frame and legs"],
    dimensions: "24 x 48 inches (meets or exceeds ACA and ACO regulations)",
    customizable: true,
    featured: false,
    images: [img(cornholeRedImg, "Red cornhole boards with embedded LED lights, coming soon", 360, 270)],
    tags: ["cornhole", "led", "red"],
    occasions: ["Tailgating", "Night tournaments", "Backyard parties"],
    relatedProducts: ["p252", "p253", "p254"],
    seoTitle: "Red LED Cornhole Boards | Paul\'s Pens n Things",
    seoDescription: "Red cornhole boards with embedded LED lights for night-time play. Coming soon from Paragould, Arkansas.",
  },
  {
    id: "p257",
    slug: "cornhole-boards-blue-led",
    name: "Blue Cornhole Boards with LED Lights",
    internalCode: "CRN-BLUE-LED",
    category: "other",
    subcategory: "Cornhole Boards",
    shortDescription: "Coming soon — blue boards with LED lights embedded in the playing surface for night games.",
    fullDescription: "These cornhole boards are hand-crafted from 2x4s, 3/4 inch thick plywood and have LED lights embedded in the top surface for night-time playing. The bottom, sides and legs have one coat of polyurethane; the top is painted and has three coats of polyurethane. These boards meet or exceed the size, strength and rigidity regulations of the ACA and ACO.",
    price: 400,
    priceType: "fixed",
    status: "temporarily-unavailable",
    materials: ["2x4 framing lumber", "3/4 inch plywood top", "Embedded LED lighting"],
    finishes: ["Painted top with three coats of polyurethane", "One coat on frame and legs"],
    dimensions: "24 x 48 inches (meets or exceeds ACA and ACO regulations)",
    customizable: true,
    featured: false,
    images: [img(cornholeGreenImg, "Blue cornhole boards with embedded LED lights, coming soon", 360, 270)],
    tags: ["cornhole", "led", "blue"],
    occasions: ["Tailgating", "Night tournaments", "Backyard parties"],
    relatedProducts: ["p252", "p253", "p254"],
    seoTitle: "Blue LED Cornhole Boards | Paul\'s Pens n Things",
    seoDescription: "Blue cornhole boards with embedded LED lights for night-time play. Coming soon from Paragould, Arkansas.",
  },
  {
    id: "p258",
    slug: "cornhole-boards-green-led",
    name: "Green Cornhole Boards with LED Lights",
    internalCode: "CRN-GREEN-LED",
    category: "other",
    subcategory: "Cornhole Boards",
    shortDescription: "Coming soon — green boards with LED lights embedded in the playing surface for night games.",
    fullDescription: "These cornhole boards are hand-crafted from 2x4s, 3/4 inch thick plywood and have LED lights embedded in the top surface for night-time playing. The bottom, sides and legs have one coat of polyurethane; the top is painted and has three coats of polyurethane. These boards meet or exceed the size, strength and rigidity regulations of the ACA and ACO.",
    price: 400,
    priceType: "fixed",
    status: "temporarily-unavailable",
    materials: ["2x4 framing lumber", "3/4 inch plywood top", "Embedded LED lighting"],
    finishes: ["Painted top with three coats of polyurethane", "One coat on frame and legs"],
    dimensions: "24 x 48 inches (meets or exceeds ACA and ACO regulations)",
    customizable: true,
    featured: false,
    images: [img(cornholeGreenImg, "Green cornhole boards with embedded LED lights, coming soon", 360, 270)],
    tags: ["cornhole", "led", "green"],
    occasions: ["Tailgating", "Night tournaments", "Backyard parties"],
    relatedProducts: ["p252", "p253", "p254"],
    seoTitle: "Green LED Cornhole Boards | Paul\'s Pens n Things",
    seoDescription: "Green cornhole boards with embedded LED lights for night-time play. Coming soon from Paragould, Arkansas.",
  },
  {
    id: "p259",
    slug: "cornhole-boards-orange-led",
    name: "Orange Cornhole Boards with LED Lights",
    internalCode: "CRN-ORANGE-LED",
    category: "other",
    subcategory: "Cornhole Boards",
    shortDescription: "Coming soon — orange boards with LED lights embedded in the playing surface for night games.",
    fullDescription: "These cornhole boards are hand-crafted from 2x4s, 3/4 inch thick plywood and have LED lights embedded in the top surface for night-time playing. The bottom, sides and legs have one coat of polyurethane; the top is painted and has three coats of polyurethane. These boards meet or exceed the size, strength and rigidity regulations of the ACA and ACO.",
    price: 400,
    priceType: "fixed",
    status: "temporarily-unavailable",
    materials: ["2x4 framing lumber", "3/4 inch plywood top", "Embedded LED lighting"],
    finishes: ["Painted top with three coats of polyurethane", "One coat on frame and legs"],
    dimensions: "24 x 48 inches (meets or exceeds ACA and ACO regulations)",
    customizable: true,
    featured: false,
    images: [img(cornholeOrangeImg, "Orange cornhole boards with embedded LED lights, coming soon", 360, 270)],
    tags: ["cornhole", "led", "orange"],
    occasions: ["Tailgating", "Night tournaments", "Backyard parties"],
    relatedProducts: ["p252", "p253", "p254"],
    seoTitle: "Orange LED Cornhole Boards | Paul\'s Pens n Things",
    seoDescription: "Orange cornhole boards with embedded LED lights for night-time play. Coming soon from Paragould, Arkansas.",
  },
  {
    id: "p260",
    slug: "cornhole-boards-yellow-led",
    name: "Yellow Cornhole Boards with LED Lights",
    internalCode: "CRN-YELLOW-LED",
    category: "other",
    subcategory: "Cornhole Boards",
    shortDescription: "Coming soon — yellow boards with LED lights embedded in the playing surface for night games.",
    fullDescription: "These cornhole boards are hand-crafted from 2x4s, 3/4 inch thick plywood and have LED lights embedded in the top surface for night-time playing. The bottom, sides and legs have one coat of polyurethane; the top is painted and has three coats of polyurethane. These boards meet or exceed the size, strength and rigidity regulations of the ACA and ACO.",
    price: 400,
    priceType: "fixed",
    status: "temporarily-unavailable",
    materials: ["2x4 framing lumber", "3/4 inch plywood top", "Embedded LED lighting"],
    finishes: ["Painted top with three coats of polyurethane", "One coat on frame and legs"],
    dimensions: "24 x 48 inches (meets or exceeds ACA and ACO regulations)",
    customizable: true,
    featured: false,
    images: [img(cornholeYellowImg, "Yellow cornhole boards with embedded LED lights, coming soon", 360, 270)],
    tags: ["cornhole", "led", "yellow"],
    occasions: ["Tailgating", "Night tournaments", "Backyard parties"],
    relatedProducts: ["p252", "p253", "p254"],
    seoTitle: "Yellow LED Cornhole Boards | Paul\'s Pens n Things",
    seoDescription: "Yellow cornhole boards with embedded LED lights for night-time play. Coming soon from Paragould, Arkansas.",
  },
];

export type { CategorySlug, PriceType, Product, ProductImage, ProductStatus } from "./product-types";
export { formatPrice, statusLabels } from "./product-types";

export const getProduct = (slug: string) => products.find((p) => p.slug === slug);
export const byCategory = (category: CategorySlug) => products.filter((p) => p.category === category);
export const featured = products.filter((p) => p.featured);
export const previouslyCreated = products.filter((p) => p.status === "previously-created");
